/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */
import type {
  AddFaxContactDTO,
  AddendumDTO,
  AddressDTO,
  AlertTypeDto,
  AllocationRequestDTO,
  AllocationResponseBaseDTO,
  AppointmentClaimsDTO,
  AppointmentConfirmationRequestDTO,
  AppointmentDTO,
  AppointmentDetailsDTO,
  AppointmentInfoForVisitNoteDTO,
  AppointmentPaymentMethodDTO,
  AppointmentReminderCallResponseDTO,
  AppointmentRemindersRequestDTO,
  AppointmentRemindersResponseDTO,
  AppointmentTypeSettingDTO,
  AssociateInsuranceCardRequestDTO,
  AvailableClinicsResponseDTO,
  BatchAllocationResponseDTO,
  BillingCodeAliasRequestDTO,
  BillingCodeDTO,
  BillingCodeDTOPaginatedResponseDTO,
  BillingCodeFavoriteRequestDTO,
  BillingMultiMediaResponseDTO,
  BillingMultiMediaUploadDTO,
  BillingProviderDTO,
  BillingProviderPtanDTO,
  BillingProviderPtanDTOListDTO,
  BillingProviderRuleDTO,
  BillingProviderRuleDTOListDTO,
  BillingProviderRulesRequestDTO,
  BillingProviderRulesResponseDTO,
  BillingProvidersByTypeDTO,
  BlobMetaData,
  BlockedTimeSlotDTO,
  BulkPaperClaimsGenerationDTO,
  BulkPaperClaimsRequestDTO,
  BulkPaperClaimsResponseDTO,
  BulkPaperClaimsTriggerResponseDTO,
  BulkPatientStatementGenerationDTO,
  BulkPatientStatementRequestDTO,
  BulkPatientStatementResponseDTO,
  BulkPatientStatementTriggerResponseDTO,
  CPTCodeSuggestionsDTO,
  CalendarEventsResponseDTO,
  CallDetailsDTO,
  CancelTerminalCheckoutRequest,
  CancelledTerminalCheckoutDTO,
  CcmMonthlyPatientsRequestDTO,
  CcmMonthlyPatientsResponseDTO,
  ChargeDetailsResponseDTO,
  ChargeMasterDTO,
  ChargeMasterDTOPaginatedResponseDTO,
  ChargeSummaryBundleDTO,
  ChargesRequestDTO,
  ChargesResponseDTO,
  ChatMessageContent,
  CheckEligibilityResponseDTO,
  ClaimAdjustmentReasonCodeDTO,
  ClaimBundleDTO,
  ClaimDetailsResponseDTO,
  ClaimLogViewDTO,
  ClaimSettingsDTO,
  ClaimWiseTagRequestDTO,
  ClaimsRequestDTO,
  ClaimsResponseDTO,
  CommunicationResult,
  CommuniqueByPatientInfoRequestDTO,
  CommuniqueVisibilityFlagsResponseDTO,
  ConfirmAppointmentCommuniqueResponseDTO,
  ConsentFormsCommuniqueDTO,
  CopyFormRequestDTO,
  CreateAppointmentRequestDTO,
  CreateAppointmentResponseDTO,
  CreateEOBWithInsurancePaymentRequestDTO,
  CreateFormRequestDTO,
  CreateInsuranceWorkflowResolutionDTO,
  CreateOrModifyTagDTO,
  CreatePaperPayerRequestDTO,
  CreatePatientRequestDTO,
  CreatePurchaseRequestDTO,
  CreatePurchaseResponseDTO,
  CreateRoomsSettingDTO,
  CreateSecondaryClaimDTO,
  CreateStickyRequestDTO,
  CreateToDoRequestDTO,
  CreateUserRequestDTO,
  CustomChargeMasterDTO,
  CustomChargeMasterDTOPaginatedResponseDTO,
  CustomServiceCodeDTO,
  CustomServiceCodeDTOPaginatedResponseDTO,
  CustomServiceCodeFavoriteRequestDTO,
  DateTimeRangeDTO,
  DeleteApiBlockedTimeSlotDeleteParams,
  DeleteApiEFaxDeleteFaxContactParams,
  DeleteApiOrgConfigurationDeleteBillingProviderParams,
  DeleteApiOrgConfigurationDeleteBillingProviderPtanParams,
  DeleteApiOrgConfigurationDeleteBillingProviderRuleParams,
  DeleteApiOrgConfigurationDeleteRenderingProviderParams,
  DeleteApiOrgConfigurationDeleteServiceFacilityParams,
  DeleteApiProviderAvailabilityDeleteParams,
  DeleteApiRTMMonitoringDeleteProviderThresholdsParams,
  DeleteApiSettingsDeleteElectronicPayerEntryConfigParams,
  DeleteApiSettingsDeletePaperPayerEntryParams,
  DeleteApiSettingsDeleteRoomSettingParams,
  DeleteAppointmentRequestDTO,
  DeleteCalendarSlotResponseDTO,
  DeleteMasterTemplateRequestDTO,
  DeletePartialBlockedTimeSlotRequest,
  DeletePartialRequest,
  DeletePatientPaymentResponseDTO,
  DeleteRequestDTO,
  DeleteSectionTemplateRequestDTO,
  DeleteStickyRequestDTO,
  DeliveredPatientStatementsDTO,
  DoctorsAppointmentSummaryDTO,
  DosespotConsentByPatientDTO,
  EOBDataForClaimViewDTO,
  EOBExtractionJobResultDTO,
  EOBSummariesDTO,
  EOBSummaryResponseDTOPaginatedResponseDTO,
  EOBUploadSasUrlRequestDTO,
  EOBWithInsurancePaymentRequestDTO,
  EOBWithInsurancePaymentResponseDTO,
  ERxDrugAllergySearchResponseDTO,
  ERxMedicationSearchResponseDTO,
  ERxNotificationsCountResponseDTO,
  ERxPharmacySearchResponseDTO,
  ERxWebpageURLResponseDTO,
  EligibilityRequestDTO,
  EncounterBillingDataDTO,
  EncounterBillingSummaryResponseDTO,
  EncounterDetailsViewModel,
  EncounterPatientWriteOffDTO,
  EncounterPatientWriteOffRequestDTO,
  EncounterSummaryViewModel,
  EncounterViewModel,
  EncounterVitalsRequestDTO,
  EncounterVitalsResponseDTO,
  EncounterWithCustomCodesViewModel,
  EncounterWithPatientPaymentInfoViewModel,
  EnqueueNoteGenerationRequestDTO,
  EnqueueNoteGenerationResponseDTO,
  EnqueueSyncZocdocTimeSlotsForUsersRequestDTO,
  EnqueueZocdocTimeSlotsForUsersResultDTO,
  EnrollPatientInPCCProgramsRequestDTO,
  EnsureAppointmentFormWorkflowResponseDTO,
  ExecuteAlertActionRequestDTO,
  ExecuteAlertActionResponseDTO,
  ExecuteSupportSqlRequest,
  FaxContactDTO,
  FaxContactDTOPaginatedResponseDTO,
  FaxViewDTOPaginatedResponseDTO,
  FileResultDTO,
  FileUploadSasUrlResponseDTO,
  ForgotPasswordRequestDTO,
  ForgotPasswordResponseDTO,
  FormBuilderOptionsDTO,
  FormBuilderResponseDTO,
  FormCategoryDTO,
  FormCategoryRulesResponseDTO,
  FormFieldAssignee,
  FormListDTO,
  FormViewDTO,
  FormWorkflowCancelRequestDTO,
  FormWorkflowCompletionRequestDTO,
  FormWorkflowDetailResponseDTO,
  FormWorkflowInitiateRequestDTO,
  FormWorkflowInitiationRequirementsDTO,
  FormWorkflowInitiationRequirementsRequestDTO,
  FormWorkflowListRequestDTO,
  FormWorkflowPaginatedCollectionDTO,
  FormWorkflowPatientFormStatusResponseDTO,
  FormWorkflowWithTransitionSuccessMessageResponseDTO,
  FormsRenderingMetadataResponseDTO,
  FormsResponseDTO,
  FormsWithSignatureStatusResponseDTO,
  GenerateSupportSqlRequest,
  GetApiAddressGetGeoCodeByAddressParams,
  GetApiBillingCodeGetAliasesForUserParams,
  GetApiBillingCodeGetFavoritesForUserParams,
  GetApiBillingCodeSearchParams,
  GetApiBillingDownloadBulkPatientStatementOutputFileParams,
  GetApiBillingDownloadBulkPatientStatementParams,
  GetApiBillingGetBulkPatientStatementOutputFilePreviewUrlParams,
  GetApiBillingGetBulkPatientStatementOutputParams,
  GetApiBillingGetEOBByPatientPatientIdParams,
  GetApiBillingGetEOBExtractionResultParams,
  GetApiBillingGetEOBParams,
  GetApiBillingGetEncounterBillingDataParams,
  GetApiBillingGetEncountersWithPositivePaymentParams,
  GetApiBillingGetInsurancePaymentsParams,
  GetApiBillingGetInvoiceSummaryParams,
  GetApiBillingGetPatientPaymentParams,
  GetApiBillingGetPatientPaymentRefundsParams,
  GetApiBillingGetPatientPaymentTransactionsByEncounterIdParams,
  GetApiBillingGetStatementLastSentInfoParams,
  GetApiBillingGetUnpaidEncounterBillingDataParams,
  GetApiBlandGetCallDetailsParams,
  GetApiBlandGetCallRecordingParams,
  GetApiBlockedTimeSlotGetBlockedTimeSlotParams,
  GetApiCHGetFavoriteInsurancesByOrgParams,
  GetApiCHGetPaginatedInsurancesParams,
  GetApiCHGetPayerEntryByIdParams,
  GetApiCHSearchInsuranceByOrgParams,
  GetApiCHSearchInsuranceParams,
  GetApiCHTriggerRawEraProcessorParams,
  GetApiChargeSearchChargeMasterParams,
  GetApiChargeSearchCustomChargeMasterParams,
  GetApiClaimDownloadBulkPaperClaimsParams,
  GetApiClaimSearchAdjustmentReasonCodeParams,
  GetApiClaimSearchExternalProviderParams,
  GetApiClaimSearchNdcCodesParams,
  GetApiClaimSearchRemittanceAdviceRemarkCodesParams,
  GetApiCommunicationGetAppointmentCommuniqueByTokenParams,
  GetApiCommunicationGetIntakeFlagsByTokenParams,
  GetApiCommunicationGetPhoneNumberTagParams,
  GetApiCustomServiceCodeSearchParams,
  GetApiEFaxDownloadFaxParams,
  GetApiEFaxGetFaxContactsParams,
  GetApiERxDrugAllergySearchParams,
  GetApiERxMedicationSearchParams,
  GetApiERxPatientWebpageURLParams,
  GetApiERxPharmacySearchParams,
  GetApiEncounterGetAppointmentClaimsSummaryParams,
  GetApiEncounterGetAppointmentsByDateParams,
  GetApiEncounterGetAppointmentsByDateRangeParams,
  GetApiEncounterGetCalendarEventsByDateAndProviderParams,
  GetApiEncounterGetCalendarEventsByDateRangeParams,
  GetApiEncounterGetDailyAppointmentBreakdownByDateRangeParams,
  GetApiEncounterGetEncounterDetailsByIdParams,
  GetApiEncounterGetEncounterSummariesByDateParams,
  GetApiEncounterGetReferringProviderSuggestionsParams,
  GetApiEncounterGetTodaysEncountersWithCustomCodesByPatientIdParams,
  GetApiFormGetFormPreviewPdfParams,
  GetApiFormGetFormsParams,
  GetApiFormWorkflowGetFormWorkflowByIdFormWorkflowIdParams,
  GetApiMultimediaGetFaxMultimediaByFaxIdParams,
  GetApiMultimediaSearchPatientMultimediaPatientIdParams,
  GetApiOrgConfigurationGetBillingProviderRulesParams,
  GetApiOrgConfigurationGetBillingProvidersByTypeParams,
  GetApiOrgConfigurationGetRenderingProvidersParams,
  GetApiOrgConfigurationGetServiceFacilitiesParams,
  GetApiOrganizationGetOrgByPatientIdParams,
  GetApiPCCConsentGetByPatientIdParams,
  GetApiPatientAuthorizationGetByPatientPatientIdParams,
  GetApiPatientGetMoveToCreditLogsParams,
  GetApiPatientGetPatientInsurancesByIdIdParams,
  GetApiPatientGetVitalsHistoryPatientIdParams,
  GetApiPatientPrintPatientFaceSheetParams,
  GetApiPatientSearchPatientsForFilterParams,
  GetApiPatientSearchPatientsParams,
  GetApiPopulateSupportGetUsersByOrganizationParams,
  GetApiProviderAvailabilityGetProviderAvailabilityParams,
  GetApiRTMGetStatusByPatientIdParams,
  GetApiRTMMonitoringGetEncountersForRTMRecommendationParams,
  GetApiRTMMonitoringGetPatientTrendParams,
  GetApiRTMMonitoringGetProviderThresholdsParams,
  GetApiReportDownloadReportOutputFileParams,
  GetApiReportDownloadReportParams,
  GetApiReportGetReportOutputFilePreviewUrlParams,
  GetApiReportGetReportOutputParams,
  GetApiSettingsGePatientHistoryOptionsParams,
  GetApiSettingsGetPayerEntryConfigsByTypeParams,
  GetApiSettingsGetProviderEntryConfigParams,
  GetApiSnapGetNoteBySnapAttemptIdParams,
  GetApiSquareAuthorizationAuthorizationRedirectParams,
  GetApiSquarePaymentsGetDeviceByDeviceIdParams,
  GetApiStickyGetAllStickiesByPatientIdParams,
  GetApiStickyGetStickyByIdParams,
  GetApiTagGetTagsParams,
  GetApiTemplateGetFieldListParams,
  GetApiTemplateGetMasterTemplateListParams,
  GetApiTemplateGetSectionTemplateListParams,
  GetApiTemplateRetrieveMasterTemplateParams,
  GetApiTemplateRetrieveSectionTemplateParams,
  GetApiTempoGetTempoStatusByPatientIdParams,
  GetApiToDoGetCommentsByToDoIdParams,
  GetApiToDoGetFaxToDosParams,
  GetApiToDoGetToDoByIdParams,
  GetApiVisitNoteGetHPIInParagraphFormParams,
  GetApiVisitNoteGetMipsSubmissionDataParams,
  GetApiVisitNoteGetPastVisitNotesForPatientParams,
  GetApiVisitNoteGetSpecificVisitNoteForPatientParams,
  GetApiVisitNoteGetSpecificVisitNoteSectionForPatientParams,
  GetApiVisitNoteGetUpcomingAppointmentsByPatientIdPatientIdParams,
  GetApiVoiceAssistantGetContextFromPopulateParams,
  GetApiVoiceAssistantGetQueryAnswerParams,
  GetApiZocdocGetAuthTokenParams,
  GetChargeDetailsByEncounterIdsRequestDTO,
  GetClaimDetailsByClaimIdsRequestDTO,
  GetClaimSummaryByClaimIdsRequestDTO,
  GetEOBsRequestDTO,
  GetFaxesRequestDTO,
  GetNoteBySnapAttemptIdResponseDTO,
  GetPatientJoinUrlRequestDTO,
  GetPaymentRequest,
  GetTodosByPatientIdRequestDTO,
  ISyncPatientResult,
  ImpersonateRequestDTO,
  ImpersonateResponseDTO,
  InboundFaxDTO,
  InboundWebhookData,
  IndividualBillingProviderDTO,
  InitiateCallResponseDTO,
  InitiateEOBDocumentExtractionResponseDTO,
  InsuranceAttachmentDTO,
  InsuranceBalanceExplanationDTO,
  InsuranceDTO,
  InsurancePaymentResponseDTO,
  InsuranceSettingsDTO,
  InsuranceWorkflowResolutionDTO,
  Int64ListDTO,
  LeanClaimSummaryDTO,
  Ledger,
  LoggedInUserInfoBaseDTO,
  LoggedInUserInfoDTO,
  MarkClaimStatusBulkDTO,
  MarkClaimStatusBulkResponseDTO,
  MarkClaimStatusDTO,
  MarkRTMPatientReviewedRequestDTO,
  MasterTemplateDTO,
  MediaSettingsDTO,
  MigratePatientMultiMediaRequestDTO,
  MigratePatientMultiMediaResponseDTO,
  MigratePatientRequestDTO,
  MigratePatientResponseDTO,
  MipsResponseDTO,
  MipsSubmissionByTinXmlDTO,
  MipsSubmissionStatusDTO,
  ModifyAppointmentDetailsRequestDTO,
  ModifyAppointmentPaymentTypeRequestDTO,
  ModifyAppointmentStatusRequestDTO,
  ModifyAppointmentStatusResponseDTO,
  MoveMoneyFromAppointmentsToCreditRequestDTO,
  MoveToCreditLogViewModel,
  MultiMediaDeleteDTO,
  MultiMediaRequestDTO,
  MultiMediaResponse,
  MultiMediaResponseDTO,
  NPISearchResponseDTO,
  NdcCodeDTOPaginatedResponseDTO,
  None,
  OnlinePaymentRequestDTO,
  OptInPatientToCCMRequestDTO,
  OrgBillingProviderDTO,
  OrgMultiMediaUploadDTO,
  OrganizationByIntakeRequestDTO,
  OrganizationByIntakeResponseDTO,
  OrganizationDTO,
  OutboundWebhookData,
  PCCCcmCallDTO,
  PCCCcmCallsRequestDTO,
  PCCOrgActivationSettingsDTO,
  PCCPatientDetailRequestDTO,
  PCCPatientDetailResponseDTO,
  PCCPatientDetailsRequestDTO,
  PCCPatientDetailsResponseDTO,
  PCCProgram,
  PCCProgramEnrollmentRequestDTO,
  PaperPayerEntryDTO,
  PatientAlertDTO,
  PatientAlertFilterDTO,
  PatientAppointmentChangeSettingsDTO,
  PatientAppointmentStatusSettingDTO,
  PatientAuthorizationListItemDTO,
  PatientAuthorizationListItemDTOPaginatedResponseDTO,
  PatientAuthorizationResponseDTO,
  PatientAuthorizationSaveRequestDTO,
  PatientBillingSummaryResponseDTO,
  PatientCountSummaryDTO,
  PatientDOBDTO,
  PatientDTO,
  PatientFinalLetterRequestDTO,
  PatientInfoCommuniqueDTO,
  PatientInsurancesRequestDTO,
  PatientInvoiceRequestDTO,
  PatientMediaCategoryDetailsResponseDTO,
  PatientMediaSearchResultDTOPaginatedResponseDTO,
  PatientMedicalBackgroundResponseDTO,
  PatientMedicalHistoryRequestDTO,
  PatientMultiMediaResponseDTO,
  PatientMultiMediaUpdateDTO,
  PatientMultiMediaUploadDTO,
  PatientMultimediaBulkUploadRequestDTO,
  PatientMultimediaBulkUploadResponseDTO,
  PatientMultimediaRequestDTO,
  PatientNameMigrationRequestDTO,
  PatientNameMigrationResultDTO,
  PatientPCCConsentsDTO,
  PatientPCCItemsDTO,
  PatientPCCStatusDTO,
  PatientPaymentDTO,
  PatientPaymentRefundRequestDTO,
  PatientPaymentRefundViewModel,
  PatientPaymentRequestDTO,
  PatientPaymentTransactionQueryDTO,
  PatientPaymentTransactionViewModelDTO,
  PatientPaymentTransactionViewModelDTOPaginatedResponseDTO,
  PatientPharmacyAllergyMedicationRequestDTO,
  PatientStatementAppointmentSnapshotDTO,
  PatientStatementDTO,
  PatientStatementReminderResponseDTO,
  PatientStatementRequestDTO,
  PatientSummaryDTO,
  PatientTempoStatus,
  PatientVisitDTO,
  PatientVitalsHistoryItemDTO,
  PatientWithHPIAttributesDTO,
  PayerEntryConfigDTO,
  PayerEntryConfigDTOPaginatedResponseDTO,
  PayerEntryDTO,
  PayerEntryDTOPaginatedResponseDTO,
  PaymentDTO,
  PhoneNumberTagResponseDTO,
  PollEligibilityBatchRequestDTO,
  PollEligibilityBatchResponseDTO,
  PopulateSupportOrganizationDTO,
  PopulateSupportUserDTO,
  PostApiAlertsTriggerInsuranceAlertSyncByOrgParams,
  PostApiAppointmentReminderAgentCallForAppointmentReminderParams,
  PostApiBillingSendDailyDigestEmailsParams,
  PostApiBillingTriggerFinancialViewSyncByOrgParams,
  PostApiBillingTriggerSyncByOrgParams,
  PostApiBillingTriggerSyncParams,
  PostApiBillingTriggerZeroPatientBalanceParams,
  PostApiCCMAgentInitiateCallParams,
  PostApiCHTriggerRawClaimAckProcessorParams,
  PostApiClaimEnqueueReadyElectronicClaimsForBulkTransmissionParams,
  PostApiCommunicationEnsureFormWorkflowForAppointmentCommuniqueParams,
  PostApiEFaxResendFaxParams,
  PostApiEFaxSetInboundFaxInternalStatusParams,
  PostApiEncounterGetEncounterPatientWriteOffsByEncounterIdParams,
  PostApiMonkeyPatchRequeueInvoicePdfGenerationParams,
  PostApiPCCCommuniqueSendByPatientIdParams,
  PostApiPCCCommuniqueSendModMedByPatientIdParams,
  PostApiPCCConsentTriggerDefaultConsentSyncByOrgParams,
  PostApiPCCConsentTriggerPCCEligibilityViewSyncByOrgParams,
  PostApiPopulateSupportRetryFailedSuperDialWebhookParams,
  PostApiPopulateSupportSyncCompletedSuperDialSummaryParams,
  PostApiPopulateSupportTriggerSuperDialSubmissionForClaimsParams,
  PostApiPopulateSupportTriggerSuperDialSubmissionParams,
  PostApiRTMMonitoringAddQualificationByPatientIdParams,
  PostApiRTMMonitoringSendCheckInSurveyByPatientIdParams,
  PostApiRTMMonitoringSendEnrollmentInvitationByPatientIdParams,
  PostApiReportDeleteReportParams,
  PostApiSquarePaymentsCreateDeviceCodeForLocationParams,
  PostApiSquarePaymentsCreateQuickPayCheckoutParams,
  PostApiSquarePaymentsCreateTerminalCheckoutParams,
  PostApiTempoSendDayOneCommuniqueParams,
  PostApiTempoSendDayTwoCommuniqueParams,
  PostApiVisitNoteUnFinalizeParams,
  PostApiZocdocEnqueueSyncZocdocTimeSlotsForAllFacilitiesParams,
  PostApiZocdocRetryFailedSlotCreationAttemptParams,
  PostApiZocdocRetryWebhookEventParams,
  PrintClaimDTO,
  PrintEncounterScheduleRequestDTO,
  ProviderAvailabilityDTO,
  ProviderEntryConfigDTO,
  ProviderSuggestionDTO,
  QueueMipsSubmissionRequestDTO,
  QueueMipsSubmissionResponseDTO,
  RTMPatientStatusResponseDTO,
  RTMPatientTrendResponseDTO,
  RTMPatientsRequestDTO,
  RTMPatientsResponseDTO,
  RTMProviderThresholdsDTO,
  RTMSettingsDTO,
  ReasonForVisitDTO,
  ReconcileExtractedEOBRequestDTO,
  RefundMethodsResponseDTO,
  ReminderCommuniqueRequestDTO,
  RemittanceAdviceRemarkCodeDTO,
  RenderingProviderDTO,
  RenderingProviderDTOListDTO,
  ReplaceFormPdfRequestDTO,
  ReportOutputDTO,
  ReportOutputFilePreviewDTO,
  ReportRequestDTO,
  ReportRequestDTOBase,
  ReportResponseDTO,
  ReportSettingsResponseDTO,
  RetrieveSectionTemplateRequestDTO,
  RoomSettingDTO,
  RoomStatusDTO,
  SaveAvailabilityResponse,
  SaveBlockedTimeSlotResponse,
  SaveFormFieldsRequestDTO,
  SaveMasterTemplateRequestDTO,
  SaveSectionTemplateRequestDTO,
  SaveVisitNoteSOAPRequestDTO,
  SearchPatientForFilterDTOPaginatedResponseDTO,
  SearchPatientResultDTO,
  SearchPatientResultDTOPaginatedResponseDTO,
  SectionTemplateContentDTO,
  SectionTemplateDTO,
  SendDailyClaimDeniedEmailsRequestDTO,
  SendFaxDTO,
  SendPatientPCCConsentRequestDTO,
  ServiceFacilityDTO,
  ServiceFacilityDTOListDTO,
  SetClaimInsuranceDTO,
  SetClaimNotesDTO,
  SetPCCOrgActivationSettingsRequestDTO,
  SettingsDTO,
  SignPatientMultimediaRequestDTO,
  SnapAudioUploadSasUrlRequestDTO,
  SplitClaimsDTO,
  SquareInvoiceSummaryResponseDTO,
  StartEligibilityBatchRequestDTO,
  StartEligibilityBatchResponseDTO,
  StediEraPDFWebHookFileProcessedDTO,
  StediReportWebHookTransactionDTO,
  StickyDTO,
  StringPaginatedResponseDTO,
  SupportSqlExecutionResult,
  SupportSqlGenerationResult,
  SyncInsuranceAttachmentsRequestDTO,
  TagDTO,
  TagDTOPaginatedResponseDTO,
  TelehealthMeetingStatusDTO,
  TelehealthPatientJoinInfoDTO,
  TelehealthProviderJoinInfoDTO,
  TemplateFieldDTO,
  TemplateFieldDTOPaginatedResponseDTO,
  TemplateFieldRequestDTO,
  TemplateListItemDTOPaginatedResponseDTO,
  TempoPatientDetailDTO,
  TempoPatientDetailRequestDTO,
  TempoPatientsRequestDTO,
  TempoPatientsResponseDTO,
  ToDoCommentDTO,
  ToDoCommentRequestDTO,
  ToDoCommentsCollectionDTO,
  ToDoCountResponseDTO,
  ToDoPaginatedCollectionDTO,
  ToDoPanelItemDTOPaginatedResponseDTO,
  ToDoRequestDTO,
  ToDoResponseDTO,
  ToDoResponseWithReferencedObjectsDTO,
  ToDoUpdateRequestDTO,
  TriggerReportResponseDTO,
  UpcomingAppointmentsPdfRequestDTO,
  UpdateFormRequestDTO,
  UpdatePaperPayerRequestDTO,
  UpdatePatientPCCConsentsRequestDTO,
  UpdateRoomsSetingDTO,
  UpdateStickyRequestDTO,
  UpdateToDoCollaboratorsRequestDTO,
  UpdateUserRequestDTO,
  UploadAndAssociateInsuranceCardRequestDTO,
  UploadToPatientChartDTO,
  UpsertInsuranceRequestDTO,
  UserDTO,
  UserFavoritedMedicalCodesResponseDTO,
  UserManagementSettingsDTO,
  UserMessageListRequestDTO,
  UserMessagePaginatedCollectionDTO,
  UserMultimediaBulkUploadRequestDTO,
  UserSettingDTO,
  VisitNoteBillingAssessmentCodeDTO,
  VisitNoteBillingCodeDTO,
  VisitNoteBillingCustomServiceCodeDTO,
  VisitNoteDTO,
  VisitNotePageResponseDTO,
  VisitNoteSummaryDTO,
  ZocdocWebhookPayload
} from './dtos';

import { sendRequest } from './utils/httpClient';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getApiAddressGetGeoCodeByAddress = (
    params?: GetApiAddressGetGeoCodeByAddressParams,
 options?: SecondParameter<typeof sendRequest<AddressDTO>>,) => {
      return sendRequest<AddressDTO>(
      {url: `/api/Address/GetGeoCodeByAddress`, method: 'GET',
        params
    },
      options);
    }

export const postApiAlertsGetPatientAlerts = (
    patientAlertFilterDTO?: PatientAlertFilterDTO,
 options?: SecondParameter<typeof sendRequest<PatientAlertDTO[]>>,) => {
      return sendRequest<PatientAlertDTO[]>(
      {url: `/api/Alerts/GetPatientAlerts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientAlertFilterDTO
    },
      options);
    }

export const getApiAlertsGetAlertTypes = (

 options?: SecondParameter<typeof sendRequest<AlertTypeDto[]>>,) => {
      return sendRequest<AlertTypeDto[]>(
      {url: `/api/Alerts/GetAlertTypes`, method: 'GET'
    },
      options);
    }

export const postApiAlertsExecuteAction = (
    executeAlertActionRequestDTO?: ExecuteAlertActionRequestDTO,
 options?: SecondParameter<typeof sendRequest<ExecuteAlertActionResponseDTO>>,) => {
      return sendRequest<ExecuteAlertActionResponseDTO>(
      {url: `/api/Alerts/ExecuteAction`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeAlertActionRequestDTO
    },
      options);
    }

export const postApiAlertsTriggerInsuranceAlertSyncByOrg = (
    params?: PostApiAlertsTriggerInsuranceAlertSyncByOrgParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Alerts/TriggerInsuranceAlertSyncByOrg`, method: 'POST',
        params
    },
      options);
    }

export const postApiAlertsTriggerInsuranceAlertSyncByPatientIds = (
    postApiAlertsTriggerInsuranceAlertSyncByPatientIdsBody?: number[],
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Alerts/TriggerInsuranceAlertSyncByPatientIds`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiAlertsTriggerInsuranceAlertSyncByPatientIdsBody
    },
      options);
    }

export const postApiAlertsTriggerInsuranceAlertSync = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Alerts/TriggerInsuranceAlertSync`, method: 'POST'
    },
      options);
    }

export const postApiAppointmentReminderAgentCallForAppointmentReminder = (
    params?: PostApiAppointmentReminderAgentCallForAppointmentReminderParams,
 options?: SecondParameter<typeof sendRequest<AppointmentReminderCallResponseDTO>>,) => {
      return sendRequest<AppointmentReminderCallResponseDTO>(
      {url: `/api/AppointmentReminderAgent/CallForAppointmentReminder`, method: 'POST',
        params
    },
      options);
    }

export const postApiAppointmentRemindersDashboardGetAppointments = (
    appointmentRemindersRequestDTO?: NonReadonly<AppointmentRemindersRequestDTO>,
 options?: SecondParameter<typeof sendRequest<AppointmentRemindersResponseDTO>>,) => {
      return sendRequest<AppointmentRemindersResponseDTO>(
      {url: `/api/AppointmentRemindersDashboard/GetAppointments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appointmentRemindersRequestDTO
    },
      options);
    }

export const postApiAuthForgotPassword = (
    forgotPasswordRequestDTO?: ForgotPasswordRequestDTO,
 options?: SecondParameter<typeof sendRequest<ForgotPasswordResponseDTO>>,) => {
      return sendRequest<ForgotPasswordResponseDTO>(
      {url: `/api/Auth/ForgotPassword`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordRequestDTO
    },
      options);
    }

export const getApiBillingGetPatientPayment = (
    params?: GetApiBillingGetPatientPaymentParams,
 options?: SecondParameter<typeof sendRequest<PatientPaymentDTO>>,) => {
      return sendRequest<PatientPaymentDTO>(
      {url: `/api/Billing/GetPatientPayment`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingCreatePatientPayment = (
    patientPaymentRequestDTO?: PatientPaymentRequestDTO,
 options?: SecondParameter<typeof sendRequest<AllocationResponseBaseDTO>>,) => {
      return sendRequest<AllocationResponseBaseDTO>(
      {url: `/api/Billing/CreatePatientPayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPaymentRequestDTO
    },
      options);
    }

export const postApiBillingCreatePatientPaymentRefund = (
    patientPaymentRefundRequestDTO?: PatientPaymentRefundRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/CreatePatientPaymentRefund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPaymentRefundRequestDTO
    },
      options);
    }

export const postApiBillingDeletePatientPayment = (
    deleteRequestDTO?: DeleteRequestDTO,
 options?: SecondParameter<typeof sendRequest<DeletePatientPaymentResponseDTO>>,) => {
      return sendRequest<DeletePatientPaymentResponseDTO>(
      {url: `/api/Billing/DeletePatientPayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deleteRequestDTO
    },
      options);
    }

export const postApiBillingMovePaymentsFromAppointmentsToCredit = (
    moveMoneyFromAppointmentsToCreditRequestDTO?: MoveMoneyFromAppointmentsToCreditRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/MovePaymentsFromAppointmentsToCredit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moveMoneyFromAppointmentsToCreditRequestDTO
    },
      options);
    }

export const postApiBillingSendBillForOnlinePayment = (
    onlinePaymentRequestDTO?: OnlinePaymentRequestDTO,
 options?: SecondParameter<typeof sendRequest<CommunicationResult>>,) => {
      return sendRequest<CommunicationResult>(
      {url: `/api/Billing/SendBillForOnlinePayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: onlinePaymentRequestDTO
    },
      options);
    }

export const postApiBillingAddOrUpdateEncounterPatientWriteOffs = (
    encounterPatientWriteOffRequestDTO?: EncounterPatientWriteOffRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/AddOrUpdateEncounterPatientWriteOffs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: encounterPatientWriteOffRequestDTO
    },
      options);
    }

export const postApiBillingTriggerZeroPatientBalance = (
    params?: PostApiBillingTriggerZeroPatientBalanceParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/TriggerZeroPatientBalance`, method: 'POST',
        params
    },
      options);
    }

export const postApiBillingMarkInsuranceWorkflowResolved = (
    createInsuranceWorkflowResolutionDTO?: CreateInsuranceWorkflowResolutionDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceWorkflowResolutionDTO>>,) => {
      return sendRequest<InsuranceWorkflowResolutionDTO>(
      {url: `/api/Billing/MarkInsuranceWorkflowResolved`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInsuranceWorkflowResolutionDTO
    },
      options);
    }

export const postApiBillingTriggerMarkInsuranceWorkflowResolved = (
    createInsuranceWorkflowResolutionDTO?: CreateInsuranceWorkflowResolutionDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceWorkflowResolutionDTO>>,) => {
      return sendRequest<InsuranceWorkflowResolutionDTO>(
      {url: `/api/Billing/TriggerMarkInsuranceWorkflowResolved`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInsuranceWorkflowResolutionDTO
    },
      options);
    }

export const getApiBillingExplainInsuranceBalanceEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<InsuranceBalanceExplanationDTO>>,) => {
      return sendRequest<InsuranceBalanceExplanationDTO>(
      {url: `/api/Billing/ExplainInsuranceBalance/${encounterId}`, method: 'GET'
    },
      options);
    }

export const getApiBillingGetInsurancePayments = (
    params?: GetApiBillingGetInsurancePaymentsParams,
 options?: SecondParameter<typeof sendRequest<InsurancePaymentResponseDTO>>,) => {
      return sendRequest<InsurancePaymentResponseDTO>(
      {url: `/api/Billing/GetInsurancePayments`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingGetEOBs = (
    getEOBsRequestDTO?: GetEOBsRequestDTO,
 options?: SecondParameter<typeof sendRequest<EOBSummaryResponseDTOPaginatedResponseDTO>>,) => {
      return sendRequest<EOBSummaryResponseDTOPaginatedResponseDTO>(
      {url: `/api/Billing/GetEOBs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getEOBsRequestDTO
    },
      options);
    }

export const getApiBillingGetEOB = (
    params?: GetApiBillingGetEOBParams,
 options?: SecondParameter<typeof sendRequest<EOBWithInsurancePaymentResponseDTO | void>>,) => {
      return sendRequest<EOBWithInsurancePaymentResponseDTO | void>(
      {url: `/api/Billing/GetEOB`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingCreateEOBWithInsurancePayment = (
    createEOBWithInsurancePaymentRequestDTO?: CreateEOBWithInsurancePaymentRequestDTO,
 options?: SecondParameter<typeof sendRequest<EOBWithInsurancePaymentResponseDTO>>,) => {
      return sendRequest<EOBWithInsurancePaymentResponseDTO>(
      {url: `/api/Billing/CreateEOBWithInsurancePayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEOBWithInsurancePaymentRequestDTO
    },
      options);
    }

export const postApiBillingModifyEOBWithInsurancePayment = (
    eOBWithInsurancePaymentRequestDTO?: EOBWithInsurancePaymentRequestDTO,
 options?: SecondParameter<typeof sendRequest<EOBWithInsurancePaymentResponseDTO>>,) => {
      return sendRequest<EOBWithInsurancePaymentResponseDTO>(
      {url: `/api/Billing/ModifyEOBWithInsurancePayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eOBWithInsurancePaymentRequestDTO
    },
      options);
    }

export const deleteApiBillingDeleteEOB = (
    deleteRequestDTO?: DeleteRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/DeleteEOB`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteRequestDTO
    },
      options);
    }

export const getApiBillingGetBillingSummaryDataByEncounterIdEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<EncounterBillingSummaryResponseDTO>>,) => {
      return sendRequest<EncounterBillingSummaryResponseDTO>(
      {url: `/api/Billing/GetBillingSummaryDataByEncounterId/${encounterId}`, method: 'GET'
    },
      options);
    }

export const getApiBillingGetBillingSummaryDataByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientBillingSummaryResponseDTO>>,) => {
      return sendRequest<PatientBillingSummaryResponseDTO>(
      {url: `/api/Billing/GetBillingSummaryDataByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiBillingGetAutoAllocationPreviewPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<BatchAllocationResponseDTO>>,) => {
      return sendRequest<BatchAllocationResponseDTO>(
      {url: `/api/Billing/GetAutoAllocationPreview/${patientId}`, method: 'GET'
    },
      options);
    }

export const postApiBillingCreateAutoAllocationPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<BatchAllocationResponseDTO>>,) => {
      return sendRequest<BatchAllocationResponseDTO>(
      {url: `/api/Billing/CreateAutoAllocation/${patientId}`, method: 'POST'
    },
      options);
    }

export const postApiBillingCreateAllocation = (
    allocationRequestDTO?: AllocationRequestDTO,
 options?: SecondParameter<typeof sendRequest<BatchAllocationResponseDTO>>,) => {
      return sendRequest<BatchAllocationResponseDTO>(
      {url: `/api/Billing/CreateAllocation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: allocationRequestDTO
    },
      options);
    }

export const getApiBillingGetEncounterBillingData = (
    params?: GetApiBillingGetEncounterBillingDataParams,
 options?: SecondParameter<typeof sendRequest<EncounterBillingDataDTO>>,) => {
      return sendRequest<EncounterBillingDataDTO>(
      {url: `/api/Billing/GetEncounterBillingData`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingGetUnpaidEncounterBillingData = (
    params?: GetApiBillingGetUnpaidEncounterBillingDataParams,
 options?: SecondParameter<typeof sendRequest<EncounterBillingDataDTO>>,) => {
      return sendRequest<EncounterBillingDataDTO>(
      {url: `/api/Billing/GetUnpaidEncounterBillingData`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingGetEOBByPatientPatientId = (
    patientId: number,
    params?: GetApiBillingGetEOBByPatientPatientIdParams,
 options?: SecondParameter<typeof sendRequest<EOBDataForClaimViewDTO[]>>,) => {
      return sendRequest<EOBDataForClaimViewDTO[]>(
      {url: `/api/Billing/GetEOBByPatient/${patientId}`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingGetPatientStatement = (
    patientStatementRequestDTO?: PatientStatementRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientStatementDTO>>,) => {
      return sendRequest<PatientStatementDTO>(
      {url: `/api/Billing/GetPatientStatement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientStatementRequestDTO
    },
      options);
    }

export const getApiBillingGetDeliveredPatientStatementsPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<DeliveredPatientStatementsDTO>>,) => {
      return sendRequest<DeliveredPatientStatementsDTO>(
      {url: `/api/Billing/GetDeliveredPatientStatements/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogId = (
    patientStatementDeliveryLogId: number,
 options?: SecondParameter<typeof sendRequest<PatientStatementAppointmentSnapshotDTO[]>>,) => {
      return sendRequest<PatientStatementAppointmentSnapshotDTO[]>(
      {url: `/api/Billing/GetPatientStatementEncounterSnapshots/${patientStatementDeliveryLogId}`, method: 'GET'
    },
      options);
    }

export const postApiBillingPrintStatementPdf = (
    patientStatementRequestDTO?: PatientStatementRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Billing/PrintStatementPdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientStatementRequestDTO
    },
      options);
    }

export const postApiBillingSendStatementPdf = (
    patientStatementRequestDTO?: PatientStatementRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/SendStatementPdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientStatementRequestDTO
    },
      options);
    }

export const postApiBillingPrintFinalLetterPdf = (
    patientFinalLetterRequestDTO?: PatientFinalLetterRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Billing/PrintFinalLetterPdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientFinalLetterRequestDTO
    },
      options);
    }

export const postApiBillingSendFinalLetterPdf = (
    patientFinalLetterRequestDTO?: PatientFinalLetterRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/SendFinalLetterPdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientFinalLetterRequestDTO
    },
      options);
    }

export const postApiBillingGenerateBulkPatientStatement = (
    bulkPatientStatementGenerationDTO?: BulkPatientStatementGenerationDTO,
 options?: SecondParameter<typeof sendRequest<BulkPatientStatementTriggerResponseDTO>>,) => {
      return sendRequest<BulkPatientStatementTriggerResponseDTO>(
      {url: `/api/Billing/GenerateBulkPatientStatement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkPatientStatementGenerationDTO
    },
      options);
    }

export const postApiBillingGetBulkPatientStatements = (
    bulkPatientStatementRequestDTO?: BulkPatientStatementRequestDTO,
 options?: SecondParameter<typeof sendRequest<BulkPatientStatementResponseDTO>>,) => {
      return sendRequest<BulkPatientStatementResponseDTO>(
      {url: `/api/Billing/GetBulkPatientStatements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkPatientStatementRequestDTO
    },
      options);
    }

export const getApiBillingDownloadBulkPatientStatement = (
    params?: GetApiBillingDownloadBulkPatientStatementParams,
 options?: SecondParameter<typeof sendRequest<FileResultDTO>>,) => {
      return sendRequest<FileResultDTO>(
      {url: `/api/Billing/DownloadBulkPatientStatement`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingGetBulkPatientStatementOutput = (
    params?: GetApiBillingGetBulkPatientStatementOutputParams,
 options?: SecondParameter<typeof sendRequest<ReportOutputDTO>>,) => {
      return sendRequest<ReportOutputDTO>(
      {url: `/api/Billing/GetBulkPatientStatementOutput`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingDownloadBulkPatientStatementOutputFile = (
    params?: GetApiBillingDownloadBulkPatientStatementOutputFileParams,
 options?: SecondParameter<typeof sendRequest<FileResultDTO>>,) => {
      return sendRequest<FileResultDTO>(
      {url: `/api/Billing/DownloadBulkPatientStatementOutputFile`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingGetBulkPatientStatementOutputFilePreviewUrl = (
    params?: GetApiBillingGetBulkPatientStatementOutputFilePreviewUrlParams,
 options?: SecondParameter<typeof sendRequest<ReportOutputFilePreviewDTO>>,) => {
      return sendRequest<ReportOutputFilePreviewDTO>(
      {url: `/api/Billing/GetBulkPatientStatementOutputFilePreviewUrl`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingPrintInvoicePdf = (
    patientInvoiceRequestDTO?: PatientInvoiceRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponse>>,) => {
      return sendRequest<MultiMediaResponse>(
      {url: `/api/Billing/PrintInvoicePdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientInvoiceRequestDTO
    },
      options);
    }

export const postApiBillingSendInvoicePdf = (
    patientInvoiceRequestDTO?: PatientInvoiceRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/SendInvoicePdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientInvoiceRequestDTO
    },
      options);
    }

export const getApiBillingGetStatementLastSentInfo = (
    params?: GetApiBillingGetStatementLastSentInfoParams,
 options?: SecondParameter<typeof sendRequest<PatientStatementReminderResponseDTO | void>>,) => {
      return sendRequest<PatientStatementReminderResponseDTO | void>(
      {url: `/api/Billing/GetStatementLastSentInfo`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingGetInvoiceSummary = (
    params?: GetApiBillingGetInvoiceSummaryParams,
 options?: SecondParameter<typeof sendRequest<SquareInvoiceSummaryResponseDTO>>,) => {
      return sendRequest<SquareInvoiceSummaryResponseDTO>(
      {url: `/api/Billing/GetInvoiceSummary`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingShiftToPatientEobIdClaimId = (
    eobId: number,
    claimId: number,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/ShiftToPatient/${eobId}/${claimId}`, method: 'POST'
    },
      options);
    }

export const postApiBillingToggleExcludeServiceLineEobServiceCodePaymentInfoIdExclude = (
    eobServiceCodePaymentInfoId: number,
    exclude: boolean,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/ToggleExcludeServiceLine/${eobServiceCodePaymentInfoId}/${exclude}`, method: 'POST'
    },
      options);
    }

export const postApiBillingTriggerSyncByOrg = (
    params?: PostApiBillingTriggerSyncByOrgParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/TriggerSyncByOrg`, method: 'POST',
        params
    },
      options);
    }

export const postApiBillingTriggerSync = (
    params?: PostApiBillingTriggerSyncParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/TriggerSync`, method: 'POST',
        params
    },
      options);
    }

export const postApiBillingTriggerFinancialViewSyncByOrg = (
    params?: PostApiBillingTriggerFinancialViewSyncByOrgParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/TriggerFinancialViewSyncByOrg`, method: 'POST',
        params
    },
      options);
    }

export const postApiBillingTriggerFinancialViewSync = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/TriggerFinancialViewSync`, method: 'POST'
    },
      options);
    }

export const getApiBillingGetPaymentMethods = (

 options?: SecondParameter<typeof sendRequest<AppointmentPaymentMethodDTO[]>>,) => {
      return sendRequest<AppointmentPaymentMethodDTO[]>(
      {url: `/api/Billing/GetPaymentMethods`, method: 'GET'
    },
      options);
    }

export const getApiBillingGetRefundMethods = (

 options?: SecondParameter<typeof sendRequest<RefundMethodsResponseDTO>>,) => {
      return sendRequest<RefundMethodsResponseDTO>(
      {url: `/api/Billing/GetRefundMethods`, method: 'GET'
    },
      options);
    }

export const getApiBillingGetEncountersWithPositivePayment = (
    params?: GetApiBillingGetEncountersWithPositivePaymentParams,
 options?: SecondParameter<typeof sendRequest<EncounterWithPatientPaymentInfoViewModel[]>>,) => {
      return sendRequest<EncounterWithPatientPaymentInfoViewModel[]>(
      {url: `/api/Billing/GetEncountersWithPositivePayment`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingGetPatientPaymentTransactions = (
    patientPaymentTransactionQueryDTO?: PatientPaymentTransactionQueryDTO,
 options?: SecondParameter<typeof sendRequest<PatientPaymentTransactionViewModelDTOPaginatedResponseDTO>>,) => {
      return sendRequest<PatientPaymentTransactionViewModelDTOPaginatedResponseDTO>(
      {url: `/api/Billing/GetPatientPaymentTransactions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPaymentTransactionQueryDTO
    },
      options);
    }

export const getApiBillingGetPatientPaymentTransactionsByEncounterId = (
    params?: GetApiBillingGetPatientPaymentTransactionsByEncounterIdParams,
 options?: SecondParameter<typeof sendRequest<PatientPaymentTransactionViewModelDTO[]>>,) => {
      return sendRequest<PatientPaymentTransactionViewModelDTO[]>(
      {url: `/api/Billing/GetPatientPaymentTransactionsByEncounterId`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingGetPatientPaymentRefunds = (
    params?: GetApiBillingGetPatientPaymentRefundsParams,
 options?: SecondParameter<typeof sendRequest<PatientPaymentRefundViewModel[]>>,) => {
      return sendRequest<PatientPaymentRefundViewModel[]>(
      {url: `/api/Billing/GetPatientPaymentRefunds`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingGetEOBUploadUrl = (
    eOBUploadSasUrlRequestDTO?: EOBUploadSasUrlRequestDTO,
 options?: SecondParameter<typeof sendRequest<FileUploadSasUrlResponseDTO>>,) => {
      return sendRequest<FileUploadSasUrlResponseDTO>(
      {url: `/api/Billing/GetEOBUploadUrl`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eOBUploadSasUrlRequestDTO
    },
      options);
    }

export const postApiBillingInitiateEOBDocumentExtraction = (
    blobMetaData?: BlobMetaData,
 options?: SecondParameter<typeof sendRequest<InitiateEOBDocumentExtractionResponseDTO>>,) => {
      return sendRequest<InitiateEOBDocumentExtractionResponseDTO>(
      {url: `/api/Billing/InitiateEOBDocumentExtraction`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: blobMetaData
    },
      options);
    }

export const getApiBillingGetEOBExtractionResult = (
    params?: GetApiBillingGetEOBExtractionResultParams,
 options?: SecondParameter<typeof sendRequest<EOBExtractionJobResultDTO>>,) => {
      return sendRequest<EOBExtractionJobResultDTO>(
      {url: `/api/Billing/GetEOBExtractionResult`, method: 'GET',
        params
    },
      options);
    }

export const postApiBillingReconcileExtractedEOB = (
    reconcileExtractedEOBRequestDTO?: ReconcileExtractedEOBRequestDTO,
 options?: SecondParameter<typeof sendRequest<EOBExtractionJobResultDTO>>,) => {
      return sendRequest<EOBExtractionJobResultDTO>(
      {url: `/api/Billing/ReconcileExtractedEOB`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reconcileExtractedEOBRequestDTO
    },
      options);
    }

export const postApiBillingSendDailyClaimDeniedTestEmail = (
    sendDailyClaimDeniedEmailsRequestDTO?: SendDailyClaimDeniedEmailsRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/SendDailyClaimDeniedTestEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendDailyClaimDeniedEmailsRequestDTO
    },
      options);
    }

export const postApiBillingSendDailyDigestEmails = (
    params?: PostApiBillingSendDailyDigestEmailsParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Billing/SendDailyDigestEmails`, method: 'POST',
        params
    },
      options);
    }

export const getApiBillingCodeSearch = (
    params?: GetApiBillingCodeSearchParams,
 options?: SecondParameter<typeof sendRequest<BillingCodeDTOPaginatedResponseDTO | void>>,) => {
      return sendRequest<BillingCodeDTOPaginatedResponseDTO | void>(
      {url: `/api/BillingCode/Search`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingCodeGetFavoritesForUser = (
    params?: GetApiBillingCodeGetFavoritesForUserParams,
 options?: SecondParameter<typeof sendRequest<BillingCodeDTOPaginatedResponseDTO | void>>,) => {
      return sendRequest<BillingCodeDTOPaginatedResponseDTO | void>(
      {url: `/api/BillingCode/GetFavoritesForUser`, method: 'GET',
        params
    },
      options);
    }

export const getApiBillingCodeGetAliasesForUser = (
    params?: GetApiBillingCodeGetAliasesForUserParams,
 options?: SecondParameter<typeof sendRequest<BillingCodeDTOPaginatedResponseDTO | void>>,) => {
      return sendRequest<BillingCodeDTOPaginatedResponseDTO | void>(
      {url: `/api/BillingCode/GetAliasesForUser`, method: 'GET',
        params
    },
      options);
    }

export const putApiBillingCodeToggleFavorite = (
    billingCodeFavoriteRequestDTO?: BillingCodeFavoriteRequestDTO,
 options?: SecondParameter<typeof sendRequest<BillingCodeDTO | void>>,) => {
      return sendRequest<BillingCodeDTO | void>(
      {url: `/api/BillingCode/ToggleFavorite`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: billingCodeFavoriteRequestDTO
    },
      options);
    }

export const postApiBillingCodeCreateAlias = (
    billingCodeAliasRequestDTO?: BillingCodeAliasRequestDTO,
 options?: SecondParameter<typeof sendRequest<BillingCodeDTO | void>>,) => {
      return sendRequest<BillingCodeDTO | void>(
      {url: `/api/BillingCode/CreateAlias`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingCodeAliasRequestDTO
    },
      options);
    }

export const deleteApiBillingCodeDeleteAlias = (
    billingCodeAliasRequestDTO?: BillingCodeAliasRequestDTO,
 options?: SecondParameter<typeof sendRequest<BillingCodeDTO | void>>,) => {
      return sendRequest<BillingCodeDTO | void>(
      {url: `/api/BillingCode/DeleteAlias`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: billingCodeAliasRequestDTO
    },
      options);
    }

export const getApiBlandGetCallDetails = (
    params?: GetApiBlandGetCallDetailsParams,
 options?: SecondParameter<typeof sendRequest<CallDetailsDTO>>,) => {
      return sendRequest<CallDetailsDTO>(
      {url: `/api/Bland/GetCallDetails`, method: 'GET',
        params
    },
      options);
    }

export const getApiBlandGetCallRecording = (
    params?: GetApiBlandGetCallRecordingParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Bland/GetCallRecording`, method: 'GET',
        params
    },
      options);
    }

export const getApiBlockedTimeSlotGetBlockedTimeSlot = (
    params?: GetApiBlockedTimeSlotGetBlockedTimeSlotParams,
 options?: SecondParameter<typeof sendRequest<BlockedTimeSlotDTO>>,) => {
      return sendRequest<BlockedTimeSlotDTO>(
      {url: `/api/BlockedTimeSlot/GetBlockedTimeSlot`, method: 'GET',
        params
    },
      options);
    }

export const postApiBlockedTimeSlotAddOrUpdate = (
    blockedTimeSlotDTO?: BlockedTimeSlotDTO,
 options?: SecondParameter<typeof sendRequest<SaveBlockedTimeSlotResponse>>,) => {
      return sendRequest<SaveBlockedTimeSlotResponse>(
      {url: `/api/BlockedTimeSlot/AddOrUpdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: blockedTimeSlotDTO
    },
      options);
    }

export const deleteApiBlockedTimeSlotDelete = (
    params?: DeleteApiBlockedTimeSlotDeleteParams,
 options?: SecondParameter<typeof sendRequest<DeleteCalendarSlotResponseDTO>>,) => {
      return sendRequest<DeleteCalendarSlotResponseDTO>(
      {url: `/api/BlockedTimeSlot/Delete`, method: 'DELETE',
        params
    },
      options);
    }

export const postApiBlockedTimeSlotDeletePartially = (
    deletePartialBlockedTimeSlotRequest?: DeletePartialBlockedTimeSlotRequest,
 options?: SecondParameter<typeof sendRequest<DeleteCalendarSlotResponseDTO>>,) => {
      return sendRequest<DeleteCalendarSlotResponseDTO>(
      {url: `/api/BlockedTimeSlot/DeletePartially`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deletePartialBlockedTimeSlotRequest
    },
      options);
    }

export const postApiCCMAgentInitiateCall = (
    params?: PostApiCCMAgentInitiateCallParams,
 options?: SecondParameter<typeof sendRequest<InitiateCallResponseDTO>>,) => {
      return sendRequest<InitiateCallResponseDTO>(
      {url: `/api/CCMAgent/InitiateCall`, method: 'POST',
        params
    },
      options);
    }

export const postApiCcmMonthlyDashboardGetPatients = (
    ccmMonthlyPatientsRequestDTO?: CcmMonthlyPatientsRequestDTO,
 options?: SecondParameter<typeof sendRequest<CcmMonthlyPatientsResponseDTO>>,) => {
      return sendRequest<CcmMonthlyPatientsResponseDTO>(
      {url: `/api/CcmMonthlyDashboard/GetPatients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccmMonthlyPatientsRequestDTO
    },
      options);
    }

export const postApiCHCheckEligibility = (
    eligibilityRequestDTO?: EligibilityRequestDTO,
 options?: SecondParameter<typeof sendRequest<CheckEligibilityResponseDTO | void>>,) => {
      return sendRequest<CheckEligibilityResponseDTO | void>(
      {url: `/api/CH/CheckEligibility`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eligibilityRequestDTO
    },
      options);
    }

export const getApiCHSearchInsurance = (
    params?: GetApiCHSearchInsuranceParams,
 options?: SecondParameter<typeof sendRequest<PayerEntryDTO[]>>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/CH/SearchInsurance`, method: 'GET',
        params
    },
      options);
    }

export const getApiCHGetPaginatedInsurances = (
    params?: GetApiCHGetPaginatedInsurancesParams,
 options?: SecondParameter<typeof sendRequest<PayerEntryDTOPaginatedResponseDTO>>,) => {
      return sendRequest<PayerEntryDTOPaginatedResponseDTO>(
      {url: `/api/CH/GetPaginatedInsurances`, method: 'GET',
        params
    },
      options);
    }

export const getApiCHSearchInsuranceByOrg = (
    params?: GetApiCHSearchInsuranceByOrgParams,
 options?: SecondParameter<typeof sendRequest<PayerEntryDTO[]>>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/CH/SearchInsuranceByOrg`, method: 'GET',
        params
    },
      options);
    }

export const getApiCHGetPayerEntryById = (
    params?: GetApiCHGetPayerEntryByIdParams,
 options?: SecondParameter<typeof sendRequest<PayerEntryDTO>>,) => {
      return sendRequest<PayerEntryDTO>(
      {url: `/api/CH/GetPayerEntryById`, method: 'GET',
        params
    },
      options);
    }

export const getApiCHGetFavoriteInsurances = (

 options?: SecondParameter<typeof sendRequest<PayerEntryDTO[]>>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/CH/GetFavoriteInsurances`, method: 'GET'
    },
      options);
    }

export const getApiCHGetFavoriteInsurancesByOrg = (
    params?: GetApiCHGetFavoriteInsurancesByOrgParams,
 options?: SecondParameter<typeof sendRequest<PayerEntryDTO[]>>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/CH/GetFavoriteInsurancesByOrg`, method: 'GET',
        params
    },
      options);
    }

export const postApiCHClaimAcknowledgementHandler = (
    stediReportWebHookTransactionDTO?: StediReportWebHookTransactionDTO,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/CH/ClaimAcknowledgementHandler`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stediReportWebHookTransactionDTO
    },
      options);
    }

export const postApiCHElectronicRemittanceAdviceHandler = (
    stediReportWebHookTransactionDTO?: StediReportWebHookTransactionDTO,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/CH/ElectronicRemittanceAdviceHandler`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stediReportWebHookTransactionDTO
    },
      options);
    }

export const postApiCHEraPDFHandler = (
    stediEraPDFWebHookFileProcessedDTO?: StediEraPDFWebHookFileProcessedDTO,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/CH/EraPDFHandler`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stediEraPDFWebHookFileProcessedDTO
    },
      options);
    }

export const getApiCHTriggerRawEraProcessor = (
    params?: GetApiCHTriggerRawEraProcessorParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/CH/TriggerRawEraProcessor`, method: 'GET',
        params
    },
      options);
    }

export const postApiCHTriggerRawClaimAckProcessor = (
    params?: PostApiCHTriggerRawClaimAckProcessorParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/CH/TriggerRawClaimAckProcessor`, method: 'POST',
        params
    },
      options);
    }

export const getApiChargeSearchChargeMaster = (
    params?: GetApiChargeSearchChargeMasterParams,
 options?: SecondParameter<typeof sendRequest<ChargeMasterDTOPaginatedResponseDTO>>,) => {
      return sendRequest<ChargeMasterDTOPaginatedResponseDTO>(
      {url: `/api/Charge/SearchChargeMaster`, method: 'GET',
        params
    },
      options);
    }

export const getApiChargeSearchCustomChargeMaster = (
    params?: GetApiChargeSearchCustomChargeMasterParams,
 options?: SecondParameter<typeof sendRequest<CustomChargeMasterDTOPaginatedResponseDTO>>,) => {
      return sendRequest<CustomChargeMasterDTOPaginatedResponseDTO>(
      {url: `/api/Charge/SearchCustomChargeMaster`, method: 'GET',
        params
    },
      options);
    }

export const postApiChargeCreateChargePolicy = (
    chargeMasterDTO?: ChargeMasterDTO,
 options?: SecondParameter<typeof sendRequest<ChargeMasterDTO>>,) => {
      return sendRequest<ChargeMasterDTO>(
      {url: `/api/Charge/CreateChargePolicy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chargeMasterDTO
    },
      options);
    }

export const postApiChargeCreateCustomCodeChargePolicy = (
    customChargeMasterDTO?: CustomChargeMasterDTO,
 options?: SecondParameter<typeof sendRequest<CustomChargeMasterDTO>>,) => {
      return sendRequest<CustomChargeMasterDTO>(
      {url: `/api/Charge/CreateCustomCodeChargePolicy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customChargeMasterDTO
    },
      options);
    }

export const postApiChargeModifyChargePolicy = (
    chargeMasterDTO?: ChargeMasterDTO,
 options?: SecondParameter<typeof sendRequest<ChargeMasterDTO>>,) => {
      return sendRequest<ChargeMasterDTO>(
      {url: `/api/Charge/ModifyChargePolicy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chargeMasterDTO
    },
      options);
    }

export const postApiChargeModifyCustomCodeChargePolicy = (
    customChargeMasterDTO?: CustomChargeMasterDTO,
 options?: SecondParameter<typeof sendRequest<CustomChargeMasterDTO>>,) => {
      return sendRequest<CustomChargeMasterDTO>(
      {url: `/api/Charge/ModifyCustomCodeChargePolicy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customChargeMasterDTO
    },
      options);
    }

export const deleteApiChargeDeleteChargePolicy = (
    deleteRequestDTO?: DeleteRequestDTO,
 options?: SecondParameter<typeof sendRequest<ChargeMasterDTO>>,) => {
      return sendRequest<ChargeMasterDTO>(
      {url: `/api/Charge/DeleteChargePolicy`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteRequestDTO
    },
      options);
    }

export const deleteApiChargeDeleteCustomCodeChargePolicy = (
    deleteRequestDTO?: DeleteRequestDTO,
 options?: SecondParameter<typeof sendRequest<CustomChargeMasterDTO>>,) => {
      return sendRequest<CustomChargeMasterDTO>(
      {url: `/api/Charge/DeleteCustomCodeChargePolicy`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteRequestDTO
    },
      options);
    }

export const postApiChargeGetCharges = (
    chargesRequestDTO?: ChargesRequestDTO,
 options?: SecondParameter<typeof sendRequest<ChargesResponseDTO>>,) => {
      return sendRequest<ChargesResponseDTO>(
      {url: `/api/Charge/GetCharges`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chargesRequestDTO
    },
      options);
    }

export const postApiChargeGetClaims = (
    claimsRequestDTO?: ClaimsRequestDTO,
 options?: SecondParameter<typeof sendRequest<ClaimsResponseDTO>>,) => {
      return sendRequest<ClaimsResponseDTO>(
      {url: `/api/Charge/GetClaims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: claimsRequestDTO
    },
      options);
    }

export const postApiChargeGetChargeDetailsByEncounterIds = (
    getChargeDetailsByEncounterIdsRequestDTO?: GetChargeDetailsByEncounterIdsRequestDTO,
 options?: SecondParameter<typeof sendRequest<ChargeDetailsResponseDTO[]>>,) => {
      return sendRequest<ChargeDetailsResponseDTO[]>(
      {url: `/api/Charge/GetChargeDetailsByEncounterIds`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getChargeDetailsByEncounterIdsRequestDTO
    },
      options);
    }

export const postApiChargeGetClaimDetailsByClaimIds = (
    getClaimDetailsByClaimIdsRequestDTO?: GetClaimDetailsByClaimIdsRequestDTO,
 options?: SecondParameter<typeof sendRequest<ClaimDetailsResponseDTO[]>>,) => {
      return sendRequest<ClaimDetailsResponseDTO[]>(
      {url: `/api/Charge/GetClaimDetailsByClaimIds`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getClaimDetailsByClaimIdsRequestDTO
    },
      options);
    }

export const postApiChargeGetClaimSummaryByClaimIds = (
    getClaimSummaryByClaimIdsRequestDTO?: GetClaimSummaryByClaimIdsRequestDTO,
 options?: SecondParameter<typeof sendRequest<LeanClaimSummaryDTO[]>>,) => {
      return sendRequest<LeanClaimSummaryDTO[]>(
      {url: `/api/Charge/GetClaimSummaryByClaimIds`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getClaimSummaryByClaimIdsRequestDTO
    },
      options);
    }

export const getApiClaimSearchExternalProvider = (
    params?: GetApiClaimSearchExternalProviderParams,
 options?: SecondParameter<typeof sendRequest<NPISearchResponseDTO>>,) => {
      return sendRequest<NPISearchResponseDTO>(
      {url: `/api/Claim/SearchExternalProvider`, method: 'GET',
        params
    },
      options);
    }

export const getApiClaimSearchAdjustmentReasonCode = (
    params?: GetApiClaimSearchAdjustmentReasonCodeParams,
 options?: SecondParameter<typeof sendRequest<ClaimAdjustmentReasonCodeDTO>>,) => {
      return sendRequest<ClaimAdjustmentReasonCodeDTO>(
      {url: `/api/Claim/SearchAdjustmentReasonCode`, method: 'GET',
        params
    },
      options);
    }

export const getApiClaimSearchRemittanceAdviceRemarkCodes = (
    params?: GetApiClaimSearchRemittanceAdviceRemarkCodesParams,
 options?: SecondParameter<typeof sendRequest<RemittanceAdviceRemarkCodeDTO>>,) => {
      return sendRequest<RemittanceAdviceRemarkCodeDTO>(
      {url: `/api/Claim/SearchRemittanceAdviceRemarkCodes`, method: 'GET',
        params
    },
      options);
    }

export const getApiClaimSearchNdcCodes = (
    params?: GetApiClaimSearchNdcCodesParams,
 options?: SecondParameter<typeof sendRequest<NdcCodeDTOPaginatedResponseDTO>>,) => {
      return sendRequest<NdcCodeDTOPaginatedResponseDTO>(
      {url: `/api/Claim/SearchNdcCodes`, method: 'GET',
        params
    },
      options);
    }

export const postApiClaimCreateClaimEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/CreateClaim/${encounterId}`, method: 'POST'
    },
      options);
    }

export const getApiClaimGetClaimByIdClaimId = (
    claimId: number,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/GetClaimById/${claimId}`, method: 'GET'
    },
      options);
    }

export const postApiClaimGetClaimLogByIdClaimId = (
    claimId: number,
 options?: SecondParameter<typeof sendRequest<ClaimLogViewDTO>>,) => {
      return sendRequest<ClaimLogViewDTO>(
      {url: `/api/Claim/GetClaimLogById/${claimId}`, method: 'POST'
    },
      options);
    }

export const getApiClaimGetSummaryForEncounterIdEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<ChargeSummaryBundleDTO>>,) => {
      return sendRequest<ChargeSummaryBundleDTO>(
      {url: `/api/Claim/GetSummaryForEncounterId/${encounterId}`, method: 'GET'
    },
      options);
    }

export const getApiClaimGetReferringProviderSuggestionsClaimId = (
    claimId: number,
 options?: SecondParameter<typeof sendRequest<ProviderSuggestionDTO[]>>,) => {
      return sendRequest<ProviderSuggestionDTO[]>(
      {url: `/api/Claim/GetReferringProviderSuggestions/${claimId}`, method: 'GET'
    },
      options);
    }

export const getApiClaimGetEOBSummariesByEncounterIdEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<EOBSummariesDTO>>,) => {
      return sendRequest<EOBSummariesDTO>(
      {url: `/api/Claim/GetEOBSummariesByEncounterId/${encounterId}`, method: 'GET'
    },
      options);
    }

export const deleteApiClaimDeleteClaimByIdClaimId = (
    claimId: number,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Claim/DeleteClaimById/${claimId}`, method: 'DELETE'
    },
      options);
    }

export const postApiClaimSaveClaim = (
    claimBundleDTO?: ClaimBundleDTO,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/SaveClaim`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: claimBundleDTO
    },
      options);
    }

export const postApiClaimTransmitClaimToClearinghouseClaimId = (
    claimId: number,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/TransmitClaimToClearinghouse/${claimId}`, method: 'POST'
    },
      options);
    }

export const postApiClaimMarkClaimStatus = (
    markClaimStatusDTO?: MarkClaimStatusDTO,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/MarkClaimStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markClaimStatusDTO
    },
      options);
    }

export const postApiClaimMarkClaimStatusBulk = (
    markClaimStatusBulkDTO?: MarkClaimStatusBulkDTO,
 options?: SecondParameter<typeof sendRequest<MarkClaimStatusBulkResponseDTO>>,) => {
      return sendRequest<MarkClaimStatusBulkResponseDTO>(
      {url: `/api/Claim/MarkClaimStatusBulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markClaimStatusBulkDTO
    },
      options);
    }

export const postApiClaimSetClaimNotes = (
    setClaimNotesDTO?: SetClaimNotesDTO,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/SetClaimNotes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setClaimNotesDTO
    },
      options);
    }

export const postApiClaimSetClaimInsurance = (
    setClaimInsuranceDTO?: SetClaimInsuranceDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Claim/SetClaimInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setClaimInsuranceDTO
    },
      options);
    }

export const postApiClaimPrintClaim = (
    printClaimDTO?: PrintClaimDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Claim/PrintClaim`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: printClaimDTO
    },
      options);
    }

export const getApiClaimGetSplitByEncounterIdEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<SplitClaimsDTO>>,) => {
      return sendRequest<SplitClaimsDTO>(
      {url: `/api/Claim/GetSplitByEncounterId/${encounterId}`, method: 'GET'
    },
      options);
    }

export const postApiClaimSaveSplit = (
    splitClaimsDTO?: SplitClaimsDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Claim/SaveSplit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: splitClaimsDTO
    },
      options);
    }

export const postApiClaimCheckClaimStatusClaimId = (
    claimId: number,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/CheckClaimStatus/${claimId}`, method: 'POST'
    },
      options);
    }

export const postApiClaimCreateSecondaryClaim = (
    createSecondaryClaimDTO?: CreateSecondaryClaimDTO,
 options?: SecondParameter<typeof sendRequest<ClaimBundleDTO>>,) => {
      return sendRequest<ClaimBundleDTO>(
      {url: `/api/Claim/CreateSecondaryClaim`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSecondaryClaimDTO
    },
      options);
    }

export const getApiClaimGetAccidentDatesByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<string[]>>,) => {
      return sendRequest<string[]>(
      {url: `/api/Claim/GetAccidentDatesByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const postApiClaimGenerateBulkPaperClaims = (
    bulkPaperClaimsGenerationDTO?: BulkPaperClaimsGenerationDTO,
 options?: SecondParameter<typeof sendRequest<BulkPaperClaimsTriggerResponseDTO>>,) => {
      return sendRequest<BulkPaperClaimsTriggerResponseDTO>(
      {url: `/api/Claim/GenerateBulkPaperClaims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkPaperClaimsGenerationDTO
    },
      options);
    }

export const postApiClaimGetBulkPaperClaims = (
    bulkPaperClaimsRequestDTO?: BulkPaperClaimsRequestDTO,
 options?: SecondParameter<typeof sendRequest<BulkPaperClaimsResponseDTO>>,) => {
      return sendRequest<BulkPaperClaimsResponseDTO>(
      {url: `/api/Claim/GetBulkPaperClaims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkPaperClaimsRequestDTO
    },
      options);
    }

export const getApiClaimDownloadBulkPaperClaims = (
    params?: GetApiClaimDownloadBulkPaperClaimsParams,
 options?: SecondParameter<typeof sendRequest<FileResultDTO>>,) => {
      return sendRequest<FileResultDTO>(
      {url: `/api/Claim/DownloadBulkPaperClaims`, method: 'GET',
        params
    },
      options);
    }

export const getApiClaimGetBillingProviders = (

 options?: SecondParameter<typeof sendRequest<BillingProviderDTO[]>>,) => {
      return sendRequest<BillingProviderDTO[]>(
      {url: `/api/Claim/GetBillingProviders`, method: 'GET'
    },
      options);
    }

export const postApiClaimResolveBillingProviderIdFromRules = (
    billingProviderRulesRequestDTO?: BillingProviderRulesRequestDTO,
 options?: SecondParameter<typeof sendRequest<BillingProviderRulesResponseDTO>>,) => {
      return sendRequest<BillingProviderRulesResponseDTO>(
      {url: `/api/Claim/ResolveBillingProviderIdFromRules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingProviderRulesRequestDTO
    },
      options);
    }

export const postApiClaimTriggerSetClaimNotes = (
    setClaimNotesDTO?: SetClaimNotesDTO,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Claim/TriggerSetClaimNotes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setClaimNotesDTO
    },
      options);
    }

export const postApiClaimEnqueueReadyElectronicClaimsForBulkTransmission = (
    params?: PostApiClaimEnqueueReadyElectronicClaimsForBulkTransmissionParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Claim/EnqueueReadyElectronicClaimsForBulkTransmission`, method: 'POST',
        params
    },
      options);
    }

export const postApiCommunicationSendPatientInfoMessage = (
    patientInfoCommuniqueDTO?: PatientInfoCommuniqueDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Communication/SendPatientInfoMessage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientInfoCommuniqueDTO
    },
      options);
    }

export const getApiCommunicationGetPatientInfoCommuniqueByTokenToken = (
    token: string,
 options?: SecondParameter<typeof sendRequest<PatientInfoCommuniqueDTO>>,) => {
      return sendRequest<PatientInfoCommuniqueDTO>(
      {url: `/api/Communication/GetPatientInfoCommuniqueByToken/${token}`, method: 'GET'
    },
      options);
    }

export const postApiCommunicationSendReminderCommunique = (
    reminderCommuniqueRequestDTO?: ReminderCommuniqueRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Communication/SendReminderCommunique`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reminderCommuniqueRequestDTO
    },
      options);
    }

export const getApiCommunicationGetAppointmentCommuniqueByToken = (
    params?: GetApiCommunicationGetAppointmentCommuniqueByTokenParams,
 options?: SecondParameter<typeof sendRequest<ConfirmAppointmentCommuniqueResponseDTO>>,) => {
      return sendRequest<ConfirmAppointmentCommuniqueResponseDTO>(
      {url: `/api/Communication/GetAppointmentCommuniqueByToken`, method: 'GET',
        params
    },
      options);
    }

export const postApiCommunicationEnsureFormWorkflowForAppointmentCommunique = (
    params?: PostApiCommunicationEnsureFormWorkflowForAppointmentCommuniqueParams,
 options?: SecondParameter<typeof sendRequest<EnsureAppointmentFormWorkflowResponseDTO>>,) => {
      return sendRequest<EnsureAppointmentFormWorkflowResponseDTO>(
      {url: `/api/Communication/EnsureFormWorkflowForAppointmentCommunique`, method: 'POST',
        params
    },
      options);
    }

export const postApiCommunicationGetOrCreateCommuniqueByPatientInfoAndUpdateAppointment = (
    communiqueByPatientInfoRequestDTO?: CommuniqueByPatientInfoRequestDTO,
 options?: SecondParameter<typeof sendRequest<ConfirmAppointmentCommuniqueResponseDTO | void>>,) => {
      return sendRequest<ConfirmAppointmentCommuniqueResponseDTO | void>(
      {url: `/api/Communication/GetOrCreateCommuniqueByPatientInfoAndUpdateAppointment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: communiqueByPatientInfoRequestDTO
    },
      options);
    }

export const getApiCommunicationGetIntakeFlagsByToken = (
    params?: GetApiCommunicationGetIntakeFlagsByTokenParams,
 options?: SecondParameter<typeof sendRequest<CommuniqueVisibilityFlagsResponseDTO>>,) => {
      return sendRequest<CommuniqueVisibilityFlagsResponseDTO>(
      {url: `/api/Communication/GetIntakeFlagsByToken`, method: 'GET',
        params
    },
      options);
    }

export const getApiCommunicationGetProceduralConsentFormsInfoByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<FormsWithSignatureStatusResponseDTO>>,) => {
      return sendRequest<FormsWithSignatureStatusResponseDTO>(
      {url: `/api/Communication/GetProceduralConsentFormsInfoByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiCommunicationGetConsentFormCommuniqueByTokenToken = (
    token: string,
 options?: SecondParameter<typeof sendRequest<ConsentFormsCommuniqueDTO>>,) => {
      return sendRequest<ConsentFormsCommuniqueDTO>(
      {url: `/api/Communication/GetConsentFormCommuniqueByToken/${token}`, method: 'GET'
    },
      options);
    }

export const getApiCommunicationGetPhoneNumberTag = (
    params?: GetApiCommunicationGetPhoneNumberTagParams,
 options?: SecondParameter<typeof sendRequest<PhoneNumberTagResponseDTO>>,) => {
      return sendRequest<PhoneNumberTagResponseDTO>(
      {url: `/api/Communication/GetPhoneNumberTag`, method: 'GET',
        params
    },
      options);
    }

export const getApiCustomServiceCodeSearch = (
    params?: GetApiCustomServiceCodeSearchParams,
 options?: SecondParameter<typeof sendRequest<CustomServiceCodeDTOPaginatedResponseDTO | void>>,) => {
      return sendRequest<CustomServiceCodeDTOPaginatedResponseDTO | void>(
      {url: `/api/CustomServiceCode/Search`, method: 'GET',
        params
    },
      options);
    }

export const postApiCustomServiceCodeToggleFavorite = (
    customServiceCodeFavoriteRequestDTO?: CustomServiceCodeFavoriteRequestDTO,
 options?: SecondParameter<typeof sendRequest<CustomServiceCodeDTO | void>>,) => {
      return sendRequest<CustomServiceCodeDTO | void>(
      {url: `/api/CustomServiceCode/ToggleFavorite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customServiceCodeFavoriteRequestDTO
    },
      options);
    }

export const postApiEFaxSendFax = (
    sendFaxDTO?: SendFaxDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/EFax/SendFax`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendFaxDTO
    },
      options);
    }

export const postApiEFaxResendFax = (
    params?: PostApiEFaxResendFaxParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/EFax/ResendFax`, method: 'POST',
        params
    },
      options);
    }

export const postApiEFaxGetFaxes = (
    getFaxesRequestDTO?: GetFaxesRequestDTO,
 options?: SecondParameter<typeof sendRequest<FaxViewDTOPaginatedResponseDTO>>,) => {
      return sendRequest<FaxViewDTOPaginatedResponseDTO>(
      {url: `/api/EFax/GetFaxes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getFaxesRequestDTO
    },
      options);
    }

export const postApiEFaxSetInboundFaxInternalStatus = (
    params?: PostApiEFaxSetInboundFaxInternalStatusParams,
 options?: SecondParameter<typeof sendRequest<InboundFaxDTO>>,) => {
      return sendRequest<InboundFaxDTO>(
      {url: `/api/EFax/SetInboundFaxInternalStatus`, method: 'POST',
        params
    },
      options);
    }

export const postApiEFaxUploadInboundFileToPatientChart = (
    uploadToPatientChartDTO?: UploadToPatientChartDTO,
 options?: SecondParameter<typeof sendRequest<PatientMultiMediaResponseDTO>>,) => {
      return sendRequest<PatientMultiMediaResponseDTO>(
      {url: `/api/EFax/UploadInboundFileToPatientChart`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadToPatientChartDTO
    },
      options);
    }

export const postApiEFaxAddFaxContact = (
    addFaxContactDTO?: AddFaxContactDTO,
 options?: SecondParameter<typeof sendRequest<FaxContactDTO>>,) => {
      return sendRequest<FaxContactDTO>(
      {url: `/api/EFax/AddFaxContact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addFaxContactDTO
    },
      options);
    }

export const getApiEFaxGetFaxContacts = (
    params?: GetApiEFaxGetFaxContactsParams,
 options?: SecondParameter<typeof sendRequest<FaxContactDTOPaginatedResponseDTO>>,) => {
      return sendRequest<FaxContactDTOPaginatedResponseDTO>(
      {url: `/api/EFax/GetFaxContacts`, method: 'GET',
        params
    },
      options);
    }

export const postApiEFaxUpdateFaxContact = (
    faxContactDTO?: FaxContactDTO,
 options?: SecondParameter<typeof sendRequest<FaxContactDTO>>,) => {
      return sendRequest<FaxContactDTO>(
      {url: `/api/EFax/UpdateFaxContact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: faxContactDTO
    },
      options);
    }

export const deleteApiEFaxDeleteFaxContact = (
    params?: DeleteApiEFaxDeleteFaxContactParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/EFax/DeleteFaxContact`, method: 'DELETE',
        params
    },
      options);
    }

export const getApiEFaxDownloadFax = (
    params?: GetApiEFaxDownloadFaxParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/EFax/DownloadFax`, method: 'GET',
        params
    },
      options);
    }

export const postApiEFaxOutboundFaxEventHandler = (
    outboundWebhookData?: OutboundWebhookData,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/EFax/OutboundFaxEventHandler`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: outboundWebhookData
    },
      options);
    }

export const postApiEFaxInboundFaxEventHandler = (
    inboundWebhookData?: InboundWebhookData,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/EFax/InboundFaxEventHandler`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inboundWebhookData
    },
      options);
    }

export const postApiEligibilityBatchStartBatch = (
    startEligibilityBatchRequestDTO?: StartEligibilityBatchRequestDTO,
 options?: SecondParameter<typeof sendRequest<StartEligibilityBatchResponseDTO>>,) => {
      return sendRequest<StartEligibilityBatchResponseDTO>(
      {url: `/api/EligibilityBatch/StartBatch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startEligibilityBatchRequestDTO
    },
      options);
    }

export const postApiEligibilityBatchPollBatch = (
    pollEligibilityBatchRequestDTO?: PollEligibilityBatchRequestDTO,
 options?: SecondParameter<typeof sendRequest<PollEligibilityBatchResponseDTO>>,) => {
      return sendRequest<PollEligibilityBatchResponseDTO>(
      {url: `/api/EligibilityBatch/PollBatch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pollEligibilityBatchRequestDTO
    },
      options);
    }

export const getApiEncounterGetEncounterSummariesByDate = (
    params?: GetApiEncounterGetEncounterSummariesByDateParams,
 options?: SecondParameter<typeof sendRequest<EncounterViewModel[]>>,) => {
      return sendRequest<EncounterViewModel[]>(
      {url: `/api/Encounter/GetEncounterSummariesByDate`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetEncounterDetailsById = (
    params?: GetApiEncounterGetEncounterDetailsByIdParams,
 options?: SecondParameter<typeof sendRequest<EncounterDetailsViewModel>>,) => {
      return sendRequest<EncounterDetailsViewModel>(
      {url: `/api/Encounter/GetEncounterDetailsById`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetAppointmentsByDate = (
    params?: GetApiEncounterGetAppointmentsByDateParams,
 options?: SecondParameter<typeof sendRequest<AppointmentDTO[]>>,) => {
      return sendRequest<AppointmentDTO[]>(
      {url: `/api/Encounter/GetAppointmentsByDate`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetCalendarEventsByDateAndProvider = (
    params?: GetApiEncounterGetCalendarEventsByDateAndProviderParams,
 options?: SecondParameter<typeof sendRequest<CalendarEventsResponseDTO>>,) => {
      return sendRequest<CalendarEventsResponseDTO>(
      {url: `/api/Encounter/GetCalendarEventsByDateAndProvider`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetAppointmentsByDateRange = (
    params?: GetApiEncounterGetAppointmentsByDateRangeParams,
 options?: SecondParameter<typeof sendRequest<AppointmentDTO[]>>,) => {
      return sendRequest<AppointmentDTO[]>(
      {url: `/api/Encounter/GetAppointmentsByDateRange`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetCalendarEventsByDateRange = (
    params?: GetApiEncounterGetCalendarEventsByDateRangeParams,
 options?: SecondParameter<typeof sendRequest<CalendarEventsResponseDTO>>,) => {
      return sendRequest<CalendarEventsResponseDTO>(
      {url: `/api/Encounter/GetCalendarEventsByDateRange`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetAppointmentDetailsByAppointmentIdAppointmentId = (
    appointmentId: number,
 options?: SecondParameter<typeof sendRequest<AppointmentDetailsDTO>>,) => {
      return sendRequest<AppointmentDetailsDTO>(
      {url: `/api/Encounter/GetAppointmentDetailsByAppointmentId/${appointmentId}`, method: 'GET'
    },
      options);
    }

export const getApiEncounterGetVitalsEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<EncounterVitalsResponseDTO>>,) => {
      return sendRequest<EncounterVitalsResponseDTO>(
      {url: `/api/Encounter/GetVitals/${encounterId}`, method: 'GET'
    },
      options);
    }

export const postApiEncounterCreateAppointment = (
    createAppointmentRequestDTO?: CreateAppointmentRequestDTO,
 options?: SecondParameter<typeof sendRequest<CreateAppointmentResponseDTO>>,) => {
      return sendRequest<CreateAppointmentResponseDTO>(
      {url: `/api/Encounter/CreateAppointment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAppointmentRequestDTO
    },
      options);
    }

export const postApiEncounterSaveVitals = (
    encounterVitalsRequestDTO?: EncounterVitalsRequestDTO,
 options?: SecondParameter<typeof sendRequest<EncounterVitalsResponseDTO>>,) => {
      return sendRequest<EncounterVitalsResponseDTO>(
      {url: `/api/Encounter/SaveVitals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: encounterVitalsRequestDTO
    },
      options);
    }

export const deleteApiEncounterDeleteAppointment = (
    deleteAppointmentRequestDTO?: DeleteAppointmentRequestDTO,
 options?: SecondParameter<typeof sendRequest<AppointmentDTO>>,) => {
      return sendRequest<AppointmentDTO>(
      {url: `/api/Encounter/DeleteAppointment`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteAppointmentRequestDTO
    },
      options);
    }

export const getApiEncounterGetDailyAppointmentBreakdownByDateRange = (
    params?: GetApiEncounterGetDailyAppointmentBreakdownByDateRangeParams,
 options?: SecondParameter<typeof sendRequest<DoctorsAppointmentSummaryDTO[]>>,) => {
      return sendRequest<DoctorsAppointmentSummaryDTO[]>(
      {url: `/api/Encounter/GetDailyAppointmentBreakdownByDateRange`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetAppointmentClaimsSummary = (
    params?: GetApiEncounterGetAppointmentClaimsSummaryParams,
 options?: SecondParameter<typeof sendRequest<AppointmentClaimsDTO>>,) => {
      return sendRequest<AppointmentClaimsDTO>(
      {url: `/api/Encounter/GetAppointmentClaimsSummary`, method: 'GET',
        params
    },
      options);
    }

export const getApiEncounterGetReferringProviderSuggestions = (
    params?: GetApiEncounterGetReferringProviderSuggestionsParams,
 options?: SecondParameter<typeof sendRequest<ProviderSuggestionDTO[]>>,) => {
      return sendRequest<ProviderSuggestionDTO[]>(
      {url: `/api/Encounter/GetReferringProviderSuggestions`, method: 'GET',
        params
    },
      options);
    }

export const postApiEncounterSetAppointmentConfirmation = (
    appointmentConfirmationRequestDTO?: AppointmentConfirmationRequestDTO,
 options?: SecondParameter<typeof sendRequest<ModifyAppointmentStatusResponseDTO>>,) => {
      return sendRequest<ModifyAppointmentStatusResponseDTO>(
      {url: `/api/Encounter/SetAppointmentConfirmation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appointmentConfirmationRequestDTO
    },
      options);
    }

export const patchApiEncounterModifyAppointmentDetails = (
    modifyAppointmentDetailsRequestDTO?: ModifyAppointmentDetailsRequestDTO,
 options?: SecondParameter<typeof sendRequest<AppointmentDTO>>,) => {
      return sendRequest<AppointmentDTO>(
      {url: `/api/Encounter/ModifyAppointmentDetails`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: modifyAppointmentDetailsRequestDTO
    },
      options);
    }

export const postApiEncounterModifyAppointmentStatus = (
    modifyAppointmentStatusRequestDTO?: ModifyAppointmentStatusRequestDTO,
 options?: SecondParameter<typeof sendRequest<ModifyAppointmentStatusResponseDTO>>,) => {
      return sendRequest<ModifyAppointmentStatusResponseDTO>(
      {url: `/api/Encounter/ModifyAppointmentStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modifyAppointmentStatusRequestDTO
    },
      options);
    }

export const postApiEncounterModifyAppointmentPaymentType = (
    modifyAppointmentPaymentTypeRequestDTO?: ModifyAppointmentPaymentTypeRequestDTO,
 options?: SecondParameter<typeof sendRequest<AppointmentDTO>>,) => {
      return sendRequest<AppointmentDTO>(
      {url: `/api/Encounter/ModifyAppointmentPaymentType`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modifyAppointmentPaymentTypeRequestDTO
    },
      options);
    }

export const postApiEncounterPrintEncounterSchedule = (
    printEncounterScheduleRequestDTO?: PrintEncounterScheduleRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Encounter/PrintEncounterSchedule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: printEncounterScheduleRequestDTO
    },
      options);
    }

export const postApiEncounterGetEncounterPatientWriteOffsByEncounterId = (
    params?: PostApiEncounterGetEncounterPatientWriteOffsByEncounterIdParams,
 options?: SecondParameter<typeof sendRequest<EncounterPatientWriteOffDTO[]>>,) => {
      return sendRequest<EncounterPatientWriteOffDTO[]>(
      {url: `/api/Encounter/GetEncounterPatientWriteOffsByEncounterId`, method: 'POST',
        params
    },
      options);
    }

export const getApiEncounterGetTodaysEncountersWithCustomCodesByPatientId = (
    params?: GetApiEncounterGetTodaysEncountersWithCustomCodesByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<EncounterWithCustomCodesViewModel[]>>,) => {
      return sendRequest<EncounterWithCustomCodesViewModel[]>(
      {url: `/api/Encounter/GetTodaysEncountersWithCustomCodesByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const postApiEncounterCreatePurchase = (
    createPurchaseRequestDTO?: CreatePurchaseRequestDTO,
 options?: SecondParameter<typeof sendRequest<CreatePurchaseResponseDTO>>,) => {
      return sendRequest<CreatePurchaseResponseDTO>(
      {url: `/api/Encounter/CreatePurchase`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPurchaseRequestDTO
    },
      options);
    }

export const getApiERxUserNotificationCounts = (

 options?: SecondParameter<typeof sendRequest<ERxNotificationsCountResponseDTO>>,) => {
      return sendRequest<ERxNotificationsCountResponseDTO>(
      {url: `/api/eRx/UserNotificationCounts`, method: 'GET'
    },
      options);
    }

export const getApiERxGetAvailableClinics = (

 options?: SecondParameter<typeof sendRequest<AvailableClinicsResponseDTO>>,) => {
      return sendRequest<AvailableClinicsResponseDTO>(
      {url: `/api/eRx/GetAvailableClinics`, method: 'GET'
    },
      options);
    }

export const getApiERxUserWebpageURL = (

 options?: SecondParameter<typeof sendRequest<ERxWebpageURLResponseDTO>>,) => {
      return sendRequest<ERxWebpageURLResponseDTO>(
      {url: `/api/eRx/UserWebpageURL`, method: 'GET'
    },
      options);
    }

export const getApiERxPatientWebpageURL = (
    params?: GetApiERxPatientWebpageURLParams,
 options?: SecondParameter<typeof sendRequest<ERxWebpageURLResponseDTO>>,) => {
      return sendRequest<ERxWebpageURLResponseDTO>(
      {url: `/api/eRx/PatientWebpageURL`, method: 'GET',
        params
    },
      options);
    }

export const getApiERxMedicationSearch = (
    params?: GetApiERxMedicationSearchParams,
 options?: SecondParameter<typeof sendRequest<ERxMedicationSearchResponseDTO>>,) => {
      return sendRequest<ERxMedicationSearchResponseDTO>(
      {url: `/api/eRx/MedicationSearch`, method: 'GET',
        params
    },
      options);
    }

export const getApiERxDrugAllergySearch = (
    params?: GetApiERxDrugAllergySearchParams,
 options?: SecondParameter<typeof sendRequest<ERxDrugAllergySearchResponseDTO>>,) => {
      return sendRequest<ERxDrugAllergySearchResponseDTO>(
      {url: `/api/eRx/DrugAllergySearch`, method: 'GET',
        params
    },
      options);
    }

export const getApiERxPharmacySearch = (
    params?: GetApiERxPharmacySearchParams,
 options?: SecondParameter<typeof sendRequest<ERxPharmacySearchResponseDTO>>,) => {
      return sendRequest<ERxPharmacySearchResponseDTO>(
      {url: `/api/eRx/PharmacySearch`, method: 'GET',
        params
    },
      options);
    }

export const postApiFormCreateForm = (
    createFormRequestDTO?: CreateFormRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormViewDTO>>,) => {
      return sendRequest<FormViewDTO>(
      {url: `/api/Form/CreateForm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFormRequestDTO
    },
      options);
    }

export const postApiFormCopyForm = (
    copyFormRequestDTO?: CopyFormRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormViewDTO>>,) => {
      return sendRequest<FormViewDTO>(
      {url: `/api/Form/CopyForm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyFormRequestDTO
    },
      options);
    }

export const postApiFormUpdateForm = (
    updateFormRequestDTO?: UpdateFormRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormViewDTO>>,) => {
      return sendRequest<FormViewDTO>(
      {url: `/api/Form/UpdateForm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateFormRequestDTO
    },
      options);
    }

export const getApiFormGetForms = (
    params?: GetApiFormGetFormsParams,
 options?: SecondParameter<typeof sendRequest<FormListDTO>>,) => {
      return sendRequest<FormListDTO>(
      {url: `/api/Form/GetForms`, method: 'GET',
        params
    },
      options);
    }

export const deleteApiFormDeleteForm = (
    deleteRequestDTO?: DeleteRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Form/DeleteForm`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteRequestDTO
    },
      options);
    }

export const getApiFormGetFormBuilderFormId = (
    formId: number,
 options?: SecondParameter<typeof sendRequest<FormBuilderResponseDTO>>,) => {
      return sendRequest<FormBuilderResponseDTO>(
      {url: `/api/Form/GetFormBuilder/${formId}`, method: 'GET'
    },
      options);
    }

export const getApiFormGetFormPreviewPdf = (
    params?: GetApiFormGetFormPreviewPdfParams,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Form/GetFormPreviewPdf`, method: 'GET',
        params
    },
      options);
    }

export const getApiFormGetFormPreviewForPatientGetFormPreviewForPatientFormIdPatientId = (
    formId: number,
    patientId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Form/GetFormPreviewForPatient/GetFormPreviewForPatient/${formId}/${patientId}`, method: 'GET'
    },
      options);
    }

export const postApiFormSaveFormFields = (
    saveFormFieldsRequestDTO?: SaveFormFieldsRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Form/SaveFormFields`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveFormFieldsRequestDTO
    },
      options);
    }

export const postApiFormReplaceFormPdf = (
    replaceFormPdfRequestDTO?: ReplaceFormPdfRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Form/ReplaceFormPdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: replaceFormPdfRequestDTO
    },
      options);
    }

export const getApiFormGetFormCategories = (

 options?: SecondParameter<typeof sendRequest<FormCategoryDTO[]>>,) => {
      return sendRequest<FormCategoryDTO[]>(
      {url: `/api/Form/GetFormCategories`, method: 'GET'
    },
      options);
    }

export const getApiFormGetFormWorkflowInitiationCategories = (

 options?: SecondParameter<typeof sendRequest<FormCategoryDTO[]>>,) => {
      return sendRequest<FormCategoryDTO[]>(
      {url: `/api/Form/GetFormWorkflowInitiationCategories`, method: 'GET'
    },
      options);
    }

export const getApiFormGetCategoryRules = (

 options?: SecondParameter<typeof sendRequest<FormCategoryRulesResponseDTO>>,) => {
      return sendRequest<FormCategoryRulesResponseDTO>(
      {url: `/api/Form/GetCategoryRules`, method: 'GET'
    },
      options);
    }

export const getApiFormGetFormBuilderOptions = (

 options?: SecondParameter<typeof sendRequest<FormBuilderOptionsDTO>>,) => {
      return sendRequest<FormBuilderOptionsDTO>(
      {url: `/api/Form/GetFormBuilderOptions`, method: 'GET'
    },
      options);
    }

export const postApiFormWorkflowGetInitiationRequirements = (
    formWorkflowInitiationRequirementsRequestDTO?: FormWorkflowInitiationRequirementsRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormWorkflowInitiationRequirementsDTO>>,) => {
      return sendRequest<FormWorkflowInitiationRequirementsDTO>(
      {url: `/api/FormWorkflow/GetInitiationRequirements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowInitiationRequirementsRequestDTO
    },
      options);
    }

export const postApiFormWorkflowInitiate = (
    formWorkflowInitiateRequestDTO?: FormWorkflowInitiateRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>>,) => {
      return sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>(
      {url: `/api/FormWorkflow/Initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowInitiateRequestDTO
    },
      options);
    }

export const getApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssignee = (
    formWorkflowId: number,
    assignee: FormFieldAssignee,
 options?: SecondParameter<typeof sendRequest<FormsRenderingMetadataResponseDTO>>,) => {
      return sendRequest<FormsRenderingMetadataResponseDTO>(
      {url: `/api/FormWorkflow/GetRenderingMetadata/${formWorkflowId}/${assignee}`, method: 'GET'
    },
      options);
    }

export const postApiFormWorkflowSaveClinicianFieldValues = (
    formWorkflowCompletionRequestDTO?: FormWorkflowCompletionRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/FormWorkflow/SaveClinicianFieldValues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowCompletionRequestDTO
    },
      options);
    }

export const postApiFormWorkflowCompleteClinicianStep = (
    formWorkflowCompletionRequestDTO?: FormWorkflowCompletionRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>>,) => {
      return sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>(
      {url: `/api/FormWorkflow/CompleteClinicianStep`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowCompletionRequestDTO
    },
      options);
    }

export const postApiFormWorkflowCompletePatientStep = (
    formWorkflowCompletionRequestDTO?: FormWorkflowCompletionRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>>,) => {
      return sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>(
      {url: `/api/FormWorkflow/CompletePatientStep`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowCompletionRequestDTO
    },
      options);
    }

export const postApiFormWorkflowCancel = (
    formWorkflowCancelRequestDTO?: FormWorkflowCancelRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/FormWorkflow/Cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowCancelRequestDTO
    },
      options);
    }

export const getApiFormWorkflowGetFormStatusByPatientPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<FormWorkflowPatientFormStatusResponseDTO>>,) => {
      return sendRequest<FormWorkflowPatientFormStatusResponseDTO>(
      {url: `/api/FormWorkflow/GetFormStatusByPatient/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiFormWorkflowGetWorkflowPdfsFormWorkflowId = (
    formWorkflowId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/FormWorkflow/GetWorkflowPdfs/${formWorkflowId}`, method: 'GET'
    },
      options);
    }

export const postApiFormWorkflowRequestFormWorkflowList = (
    formWorkflowListRequestDTO?: FormWorkflowListRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormWorkflowPaginatedCollectionDTO>>,) => {
      return sendRequest<FormWorkflowPaginatedCollectionDTO>(
      {url: `/api/FormWorkflow/RequestFormWorkflowList`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowListRequestDTO
    },
      options);
    }

export const getApiFormWorkflowGetFormWorkflowByIdFormWorkflowId = (
    formWorkflowId: number,
    params?: GetApiFormWorkflowGetFormWorkflowByIdFormWorkflowIdParams,
 options?: SecondParameter<typeof sendRequest<FormWorkflowDetailResponseDTO>>,) => {
      return sendRequest<FormWorkflowDetailResponseDTO>(
      {url: `/api/FormWorkflow/GetFormWorkflowById/${formWorkflowId}`, method: 'GET',
        params
    },
      options);
    }

export const postApiMipsSubmissionQueueMipsSubmission = (
    queueMipsSubmissionRequestDTO?: QueueMipsSubmissionRequestDTO,
 options?: SecondParameter<typeof sendRequest<QueueMipsSubmissionResponseDTO>>,) => {
      return sendRequest<QueueMipsSubmissionResponseDTO>(
      {url: `/api/MipsSubmission/QueueMipsSubmission`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: queueMipsSubmissionRequestDTO
    },
      options);
    }

export const getApiMipsSubmissionGetMipsSubmissionStatusBatchId = (
    batchId: number,
 options?: SecondParameter<typeof sendRequest<MipsSubmissionStatusDTO>>,) => {
      return sendRequest<MipsSubmissionStatusDTO>(
      {url: `/api/MipsSubmission/GetMipsSubmissionStatus/${batchId}`, method: 'GET'
    },
      options);
    }

export const postApiMonkeyPatchRequeueInvoicePdfGeneration = (
    params?: PostApiMonkeyPatchRequeueInvoicePdfGenerationParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/MonkeyPatch/RequeueInvoicePdfGeneration`, method: 'POST',
        params
    },
      options);
    }

export const getApiMonkeyPatchWaitForOneMinute = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/MonkeyPatch/WaitForOneMinute`, method: 'GET'
    },
      options);
    }

export const getApiMultimediaGetPatientMediaCategoryDetails = (

 options?: SecondParameter<typeof sendRequest<PatientMediaCategoryDetailsResponseDTO>>,) => {
      return sendRequest<PatientMediaCategoryDetailsResponseDTO>(
      {url: `/api/Multimedia/GetPatientMediaCategoryDetails`, method: 'GET'
    },
      options);
    }

export const postApiMultimediaDeleteMultiMedia = (
    multiMediaDeleteDTO?: MultiMediaDeleteDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Multimedia/DeleteMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: multiMediaDeleteDTO
    },
      options);
    }

export const postApiMultimediaRequestMultiMedia = (
    multiMediaRequestDTO?: MultiMediaRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/RequestMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: multiMediaRequestDTO
    },
      options);
    }

export const postApiMultimediaPostPatientMultiMedia = (
    patientMultiMediaUploadDTO?: PatientMultiMediaUploadDTO,
 options?: SecondParameter<typeof sendRequest<PatientMultiMediaResponseDTO>>,) => {
      return sendRequest<PatientMultiMediaResponseDTO>(
      {url: `/api/Multimedia/PostPatientMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMultiMediaUploadDTO
    },
      options);
    }

export const postApiMultimediaBulkUploadPatientMultimedia = (
    patientMultimediaBulkUploadRequestDTO?: PatientMultimediaBulkUploadRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientMultimediaBulkUploadResponseDTO>>,) => {
      return sendRequest<PatientMultimediaBulkUploadResponseDTO>(
      {url: `/api/Multimedia/BulkUploadPatientMultimedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMultimediaBulkUploadRequestDTO
    },
      options);
    }

export const postApiMultimediaBulkUploadUserMultimedia = (
    userMultimediaBulkUploadRequestDTO?: UserMultimediaBulkUploadRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientMultimediaBulkUploadResponseDTO>>,) => {
      return sendRequest<PatientMultimediaBulkUploadResponseDTO>(
      {url: `/api/Multimedia/BulkUploadUserMultimedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userMultimediaBulkUploadRequestDTO
    },
      options);
    }

export const putApiMultimediaUpdatePatientMultiMedia = (
    patientMultiMediaUpdateDTO?: PatientMultiMediaUpdateDTO,
 options?: SecondParameter<typeof sendRequest<PatientMultiMediaResponseDTO>>,) => {
      return sendRequest<PatientMultiMediaResponseDTO>(
      {url: `/api/Multimedia/UpdatePatientMultiMedia`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientMultiMediaUpdateDTO
    },
      options);
    }

export const postApiMultimediaPostBillingMultiMedia = (
    billingMultiMediaUploadDTO?: BillingMultiMediaUploadDTO,
 options?: SecondParameter<typeof sendRequest<BillingMultiMediaResponseDTO>>,) => {
      return sendRequest<BillingMultiMediaResponseDTO>(
      {url: `/api/Multimedia/PostBillingMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingMultiMediaUploadDTO
    },
      options);
    }

export const postApiMultimediaPostOrgMultiMedia = (
    orgMultiMediaUploadDTO?: OrgMultiMediaUploadDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Multimedia/PostOrgMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgMultiMediaUploadDTO
    },
      options);
    }

export const getApiMultimediaGetOrgMultimediaByTypeOrgIdMultimediaType = (
    orgId: number,
    multimediaType: string,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetOrgMultimediaByType/${orgId}/${multimediaType}`, method: 'GET'
    },
      options);
    }

export const getApiMultimediaGetOrgBannerPictureByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetOrgBannerPictureByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiMultimediaGetBillingMultiMediaByIdBillingMultiMediaIdMultimediaType = (
    billingMultiMediaId: number,
    multimediaType: string,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponse>>,) => {
      return sendRequest<MultiMediaResponse>(
      {url: `/api/Multimedia/GetBillingMultiMediaById/${billingMultiMediaId}/${multimediaType}`, method: 'GET'
    },
      options);
    }

export const getApiMultimediaGetBillingMultiMediaByIdForPatientBillingMultiMediaId = (
    billingMultiMediaId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetBillingMultiMediaByIdForPatient/${billingMultiMediaId}`, method: 'GET'
    },
      options);
    }

export const getApiMultimediaGetPatientMultiMediaByIdPatientMultiMediaId = (
    patientMultiMediaId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetPatientMultiMediaById/${patientMultiMediaId}`, method: 'GET'
    },
      options);
    }

export const postApiMultimediaGetPatientMultiMedia = (
    patientMultimediaRequestDTO?: PatientMultimediaRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetPatientMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMultimediaRequestDTO
    },
      options);
    }

export const getApiMultimediaSearchPatientMultimediaPatientId = (
    patientId: number,
    params?: GetApiMultimediaSearchPatientMultimediaPatientIdParams,
 options?: SecondParameter<typeof sendRequest<PatientMediaSearchResultDTOPaginatedResponseDTO>>,) => {
      return sendRequest<PatientMediaSearchResultDTOPaginatedResponseDTO>(
      {url: `/api/Multimedia/SearchPatientMultimedia/${patientId}`, method: 'GET',
        params
    },
      options);
    }

export const getApiMultimediaGetPatientMultimediaByTypePatientIdMultimediaType = (
    patientId: number,
    multimediaType: string,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetPatientMultimediaByType/${patientId}/${multimediaType}`, method: 'GET'
    },
      options);
    }

export const getApiMultimediaGetFaxMultimediaByFaxId = (
    params?: GetApiMultimediaGetFaxMultimediaByFaxIdParams,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetFaxMultimediaByFaxId`, method: 'GET',
        params
    },
      options);
    }

export const postApiMultimediaSignPatientMultimedia = (
    signPatientMultimediaRequestDTO?: SignPatientMultimediaRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Multimedia/SignPatientMultimedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signPatientMultimediaRequestDTO
    },
      options);
    }

export const postApiMultimediaMigratePatientMutlimedia = (
    migratePatientMultiMediaRequestDTO?: MigratePatientMultiMediaRequestDTO,
 options?: SecondParameter<typeof sendRequest<MigratePatientMultiMediaResponseDTO>>,) => {
      return sendRequest<MigratePatientMultiMediaResponseDTO>(
      {url: `/api/Multimedia/MigratePatientMutlimedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: migratePatientMultiMediaRequestDTO
    },
      options);
    }

export const getApiOrganizationGetOrgByPatientId = (
    params?: GetApiOrganizationGetOrgByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<OrganizationDTO>>,) => {
      return sendRequest<OrganizationDTO>(
      {url: `/api/Organization/GetOrgByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const postApiOrganizationGetOrgByIpadBaseIntakeUrl = (
    organizationByIntakeRequestDTO?: OrganizationByIntakeRequestDTO,
 options?: SecondParameter<typeof sendRequest<OrganizationByIntakeResponseDTO>>,) => {
      return sendRequest<OrganizationByIntakeResponseDTO>(
      {url: `/api/Organization/GetOrgByIpadBaseIntakeUrl`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationByIntakeRequestDTO
    },
      options);
    }

export const getApiOrgConfigurationGetServiceFacilities = (
    params?: GetApiOrgConfigurationGetServiceFacilitiesParams,
 options?: SecondParameter<typeof sendRequest<ServiceFacilityDTOListDTO>>,) => {
      return sendRequest<ServiceFacilityDTOListDTO>(
      {url: `/api/OrgConfiguration/GetServiceFacilities`, method: 'GET',
        params
    },
      options);
    }

export const postApiOrgConfigurationAddServiceFacility = (
    serviceFacilityDTO?: NonReadonly<ServiceFacilityDTO>,
 options?: SecondParameter<typeof sendRequest<ServiceFacilityDTO>>,) => {
      return sendRequest<ServiceFacilityDTO>(
      {url: `/api/OrgConfiguration/AddServiceFacility`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceFacilityDTO
    },
      options);
    }

export const postApiOrgConfigurationUpdateServiceFacility = (
    serviceFacilityDTO?: NonReadonly<ServiceFacilityDTO>,
 options?: SecondParameter<typeof sendRequest<ServiceFacilityDTO>>,) => {
      return sendRequest<ServiceFacilityDTO>(
      {url: `/api/OrgConfiguration/UpdateServiceFacility`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceFacilityDTO
    },
      options);
    }

export const deleteApiOrgConfigurationDeleteServiceFacility = (
    params?: DeleteApiOrgConfigurationDeleteServiceFacilityParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/OrgConfiguration/DeleteServiceFacility`, method: 'DELETE',
        params
    },
      options);
    }

export const getApiOrgConfigurationGetRenderingProviders = (
    params?: GetApiOrgConfigurationGetRenderingProvidersParams,
 options?: SecondParameter<typeof sendRequest<RenderingProviderDTOListDTO>>,) => {
      return sendRequest<RenderingProviderDTOListDTO>(
      {url: `/api/OrgConfiguration/GetRenderingProviders`, method: 'GET',
        params
    },
      options);
    }

export const postApiOrgConfigurationUpdateRenderingProvider = (
    renderingProviderDTO?: RenderingProviderDTO,
 options?: SecondParameter<typeof sendRequest<RenderingProviderDTO>>,) => {
      return sendRequest<RenderingProviderDTO>(
      {url: `/api/OrgConfiguration/UpdateRenderingProvider`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: renderingProviderDTO
    },
      options);
    }

export const deleteApiOrgConfigurationDeleteRenderingProvider = (
    params?: DeleteApiOrgConfigurationDeleteRenderingProviderParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/OrgConfiguration/DeleteRenderingProvider`, method: 'DELETE',
        params
    },
      options);
    }

export const getApiOrgConfigurationGetBillingProvidersByType = (
    params?: GetApiOrgConfigurationGetBillingProvidersByTypeParams,
 options?: SecondParameter<typeof sendRequest<BillingProvidersByTypeDTO>>,) => {
      return sendRequest<BillingProvidersByTypeDTO>(
      {url: `/api/OrgConfiguration/GetBillingProvidersByType`, method: 'GET',
        params
    },
      options);
    }

export const postApiOrgConfigurationAddOrganizationBillingProvider = (
    orgBillingProviderDTO?: OrgBillingProviderDTO,
 options?: SecondParameter<typeof sendRequest<OrgBillingProviderDTO>>,) => {
      return sendRequest<OrgBillingProviderDTO>(
      {url: `/api/OrgConfiguration/AddOrganizationBillingProvider`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgBillingProviderDTO
    },
      options);
    }

export const postApiOrgConfigurationAddIndividualBillingProvider = (
    individualBillingProviderDTO?: IndividualBillingProviderDTO,
 options?: SecondParameter<typeof sendRequest<IndividualBillingProviderDTO>>,) => {
      return sendRequest<IndividualBillingProviderDTO>(
      {url: `/api/OrgConfiguration/AddIndividualBillingProvider`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: individualBillingProviderDTO
    },
      options);
    }

export const postApiOrgConfigurationUpdateOrganizationBillingProvider = (
    orgBillingProviderDTO?: OrgBillingProviderDTO,
 options?: SecondParameter<typeof sendRequest<OrgBillingProviderDTO>>,) => {
      return sendRequest<OrgBillingProviderDTO>(
      {url: `/api/OrgConfiguration/UpdateOrganizationBillingProvider`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgBillingProviderDTO
    },
      options);
    }

export const postApiOrgConfigurationUpdateIndividualBillingProvider = (
    individualBillingProviderDTO?: IndividualBillingProviderDTO,
 options?: SecondParameter<typeof sendRequest<IndividualBillingProviderDTO>>,) => {
      return sendRequest<IndividualBillingProviderDTO>(
      {url: `/api/OrgConfiguration/UpdateIndividualBillingProvider`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: individualBillingProviderDTO
    },
      options);
    }

export const deleteApiOrgConfigurationDeleteBillingProvider = (
    params?: DeleteApiOrgConfigurationDeleteBillingProviderParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/OrgConfiguration/DeleteBillingProvider`, method: 'DELETE',
        params
    },
      options);
    }

export const getApiOrgConfigurationGetBillingProviderRules = (
    params?: GetApiOrgConfigurationGetBillingProviderRulesParams,
 options?: SecondParameter<typeof sendRequest<BillingProviderRuleDTOListDTO>>,) => {
      return sendRequest<BillingProviderRuleDTOListDTO>(
      {url: `/api/OrgConfiguration/GetBillingProviderRules`, method: 'GET',
        params
    },
      options);
    }

export const postApiOrgConfigurationAddBillingProviderRule = (
    billingProviderRuleDTO?: BillingProviderRuleDTO,
 options?: SecondParameter<typeof sendRequest<BillingProviderRuleDTO>>,) => {
      return sendRequest<BillingProviderRuleDTO>(
      {url: `/api/OrgConfiguration/AddBillingProviderRule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingProviderRuleDTO
    },
      options);
    }

export const postApiOrgConfigurationUpdateBillingProviderRule = (
    billingProviderRuleDTO?: BillingProviderRuleDTO,
 options?: SecondParameter<typeof sendRequest<BillingProviderRuleDTO>>,) => {
      return sendRequest<BillingProviderRuleDTO>(
      {url: `/api/OrgConfiguration/UpdateBillingProviderRule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingProviderRuleDTO
    },
      options);
    }

export const deleteApiOrgConfigurationDeleteBillingProviderRule = (
    params?: DeleteApiOrgConfigurationDeleteBillingProviderRuleParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/OrgConfiguration/DeleteBillingProviderRule`, method: 'DELETE',
        params
    },
      options);
    }

export const postApiOrgConfigurationReorderBillingProviderRules = (
    int64ListDTO?: Int64ListDTO,
 options?: SecondParameter<typeof sendRequest<BillingProviderRuleDTO[]>>,) => {
      return sendRequest<BillingProviderRuleDTO[]>(
      {url: `/api/OrgConfiguration/ReorderBillingProviderRules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: int64ListDTO
    },
      options);
    }

export const getApiOrgConfigurationGetBillingProviderPtans = (

 options?: SecondParameter<typeof sendRequest<BillingProviderPtanDTOListDTO>>,) => {
      return sendRequest<BillingProviderPtanDTOListDTO>(
      {url: `/api/OrgConfiguration/GetBillingProviderPtans`, method: 'GET'
    },
      options);
    }

export const postApiOrgConfigurationAddBillingProviderPtan = (
    billingProviderPtanDTO?: BillingProviderPtanDTO,
 options?: SecondParameter<typeof sendRequest<BillingProviderPtanDTO>>,) => {
      return sendRequest<BillingProviderPtanDTO>(
      {url: `/api/OrgConfiguration/AddBillingProviderPtan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingProviderPtanDTO
    },
      options);
    }

export const postApiOrgConfigurationUpdateBillingProviderPtan = (
    billingProviderPtanDTO?: BillingProviderPtanDTO,
 options?: SecondParameter<typeof sendRequest<BillingProviderPtanDTO>>,) => {
      return sendRequest<BillingProviderPtanDTO>(
      {url: `/api/OrgConfiguration/UpdateBillingProviderPtan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingProviderPtanDTO
    },
      options);
    }

export const deleteApiOrgConfigurationDeleteBillingProviderPtan = (
    params?: DeleteApiOrgConfigurationDeleteBillingProviderPtanParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/OrgConfiguration/DeleteBillingProviderPtan`, method: 'DELETE',
        params
    },
      options);
    }

export const postApiPatientCreateNewPatient = (
    createPatientRequestDTO?: CreatePatientRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/CreateNewPatient`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPatientRequestDTO
    },
      options);
    }

export const getApiPatientSearchPatients = (
    params?: GetApiPatientSearchPatientsParams,
 options?: SecondParameter<typeof sendRequest<SearchPatientResultDTOPaginatedResponseDTO>>,) => {
      return sendRequest<SearchPatientResultDTOPaginatedResponseDTO>(
      {url: `/api/Patient/SearchPatients`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientSearchPatientsForFilter = (
    params?: GetApiPatientSearchPatientsForFilterParams,
 options?: SecondParameter<typeof sendRequest<SearchPatientForFilterDTOPaginatedResponseDTO>>,) => {
      return sendRequest<SearchPatientForFilterDTOPaginatedResponseDTO>(
      {url: `/api/Patient/SearchPatientsForFilter`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientGetPatientByIdId = (
    id: number,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/GetPatientById/${id}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetPCCStatusByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientPCCStatusDTO>>,) => {
      return sendRequest<PatientPCCStatusDTO>(
      {url: `/api/Patient/GetPCCStatusByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetPCCItemsByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientPCCItemsDTO>>,) => {
      return sendRequest<PatientPCCItemsDTO>(
      {url: `/api/Patient/GetPCCItemsByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetPatientByIdWithPharmacyMedicationAndAllergyId = (
    id: number,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/GetPatientByIdWithPharmacyMedicationAndAllergy/${id}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetCountsSummaryPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientCountSummaryDTO>>,) => {
      return sendRequest<PatientCountSummaryDTO>(
      {url: `/api/Patient/GetCountsSummary/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetPatientMedicalBackgroundId = (
    id: number,
 options?: SecondParameter<typeof sendRequest<PatientMedicalBackgroundResponseDTO>>,) => {
      return sendRequest<PatientMedicalBackgroundResponseDTO>(
      {url: `/api/Patient/GetPatientMedicalBackground/${id}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetPatientInsurancesByIdId = (
    id: number,
    params?: GetApiPatientGetPatientInsurancesByIdIdParams,
 options?: SecondParameter<typeof sendRequest<InsuranceDTO[]>>,) => {
      return sendRequest<InsuranceDTO[]>(
      {url: `/api/Patient/GetPatientInsurancesById/${id}`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientGetPatientSummaryPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientSummaryDTO>>,) => {
      return sendRequest<PatientSummaryDTO>(
      {url: `/api/Patient/GetPatientSummary/${patientId}`, method: 'GET'
    },
      options);
    }

export const postApiPatientAddPatientMedicalHistory = (
    patientMedicalHistoryRequestDTO?: PatientMedicalHistoryRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/AddPatientMedicalHistory`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMedicalHistoryRequestDTO
    },
      options);
    }

export const postApiPatientAddPatientPharmacyAllergyAndMedication = (
    patientPharmacyAllergyMedicationRequestDTO?: PatientPharmacyAllergyMedicationRequestDTO,
 options?: SecondParameter<typeof sendRequest<ISyncPatientResult>>,) => {
      return sendRequest<ISyncPatientResult>(
      {url: `/api/Patient/AddPatientPharmacyAllergyAndMedication`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPharmacyAllergyMedicationRequestDTO
    },
      options);
    }

export const patchApiPatientUpdatePatient = (
    patientDTO?: PatientDTO,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/UpdatePatient`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patientDTO
    },
      options);
    }

export const postApiPatientAddInsurance = (
    upsertInsuranceRequestDTO?: UpsertInsuranceRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceDTO>>,) => {
      return sendRequest<InsuranceDTO>(
      {url: `/api/Patient/AddInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertInsuranceRequestDTO
    },
      options);
    }

export const putApiPatientUpdateInsurance = (
    upsertInsuranceRequestDTO?: UpsertInsuranceRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceDTO>>,) => {
      return sendRequest<InsuranceDTO>(
      {url: `/api/Patient/UpdateInsurance`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertInsuranceRequestDTO
    },
      options);
    }

export const deleteApiPatientDeleteInsuranceInsuranceId = (
    insuranceId: number,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Patient/DeleteInsurance/${insuranceId}`, method: 'DELETE'
    },
      options);
    }

export const getApiPatientGetUnassociatedInsuranceCardsPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Patient/GetUnassociatedInsuranceCards/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetInsuranceAttachmentsInsuranceId = (
    insuranceId: number,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO[]>>,) => {
      return sendRequest<InsuranceAttachmentDTO[]>(
      {url: `/api/Patient/GetInsuranceAttachments/${insuranceId}`, method: 'GET'
    },
      options);
    }

export const postApiPatientUploadAndAssociateInsuranceCardWithInsurance = (
    uploadAndAssociateInsuranceCardRequestDTO?: UploadAndAssociateInsuranceCardRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO>>,) => {
      return sendRequest<InsuranceAttachmentDTO>(
      {url: `/api/Patient/UploadAndAssociateInsuranceCardWithInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadAndAssociateInsuranceCardRequestDTO
    },
      options);
    }

export const postApiPatientAssociateInsuranceCardWithInsurance = (
    associateInsuranceCardRequestDTO?: AssociateInsuranceCardRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO>>,) => {
      return sendRequest<InsuranceAttachmentDTO>(
      {url: `/api/Patient/AssociateInsuranceCardWithInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateInsuranceCardRequestDTO
    },
      options);
    }

export const deleteApiPatientDisassociateInsuranceCardInsuranceAttachmentId = (
    insuranceAttachmentId: number,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Patient/DisassociateInsuranceCard/${insuranceAttachmentId}`, method: 'DELETE'
    },
      options);
    }

export const postApiPatientSyncInsuranceAttachments = (
    syncInsuranceAttachmentsRequestDTO?: SyncInsuranceAttachmentsRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO[]>>,) => {
      return sendRequest<InsuranceAttachmentDTO[]>(
      {url: `/api/Patient/SyncInsuranceAttachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncInsuranceAttachmentsRequestDTO
    },
      options);
    }

export const postApiPatientAddPatientInsurances = (
    patientInsurancesRequestDTO?: PatientInsurancesRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/AddPatientInsurances`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientInsurancesRequestDTO
    },
      options);
    }

export const postApiPatientAddReasonForVisit = (
    reasonForVisitDTO?: ReasonForVisitDTO,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/AddReasonForVisit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reasonForVisitDTO
    },
      options);
    }

export const getApiPatientGetSymptomsFromImmediatePastVisitPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientWithHPIAttributesDTO>>,) => {
      return sendRequest<PatientWithHPIAttributesDTO>(
      {url: `/api/Patient/GetSymptomsFromImmediatePastVisit/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetAgreementFormsForPatientPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<FormsResponseDTO>>,) => {
      return sendRequest<FormsResponseDTO>(
      {url: `/api/Patient/GetAgreementFormsForPatient/${patientId}`, method: 'GET'
    },
      options);
    }

export const postApiPatientSubmitDosespotConsentForm = (
    dosespotConsentByPatientDTO?: DosespotConsentByPatientDTO,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Patient/SubmitDosespotConsentForm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dosespotConsentByPatientDTO
    },
      options);
    }

export const postApiPatientVerifyPatientDOBById = (
    patientDOBDTO?: PatientDOBDTO,
 options?: SecondParameter<typeof sendRequest<None | void>>,) => {
      return sendRequest<None | void>(
      {url: `/api/Patient/VerifyPatientDOBById`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientDOBDTO
    },
      options);
    }

export const getApiPatientGetPatientLedgerPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<Ledger>>,) => {
      return sendRequest<Ledger>(
      {url: `/api/Patient/GetPatientLedger/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientPrintPatientFaceSheet = (
    params?: GetApiPatientPrintPatientFaceSheetParams,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Patient/PrintPatientFaceSheet`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientGetMoveToCreditLogs = (
    params?: GetApiPatientGetMoveToCreditLogsParams,
 options?: SecondParameter<typeof sendRequest<MoveToCreditLogViewModel[]>>,) => {
      return sendRequest<MoveToCreditLogViewModel[]>(
      {url: `/api/Patient/GetMoveToCreditLogs`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientGetVitalsHistoryPatientId = (
    patientId: number,
    params?: GetApiPatientGetVitalsHistoryPatientIdParams,
 options?: SecondParameter<typeof sendRequest<PatientVitalsHistoryItemDTO[]>>,) => {
      return sendRequest<PatientVitalsHistoryItemDTO[]>(
      {url: `/api/Patient/GetVitalsHistory/${patientId}`, method: 'GET',
        params
    },
      options);
    }

export const postApiPatientMigratePatient = (
    migratePatientRequestDTO?: MigratePatientRequestDTO,
 options?: SecondParameter<typeof sendRequest<MigratePatientResponseDTO>>,) => {
      return sendRequest<MigratePatientResponseDTO>(
      {url: `/api/Patient/MigratePatient`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: migratePatientRequestDTO
    },
      options);
    }

export const postApiPatientRecordChartAccessPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Patient/RecordChartAccess/${patientId}`, method: 'POST'
    },
      options);
    }

export const getApiPatientRecentSearches = (

 options?: SecondParameter<typeof sendRequest<SearchPatientResultDTO[]>>,) => {
      return sendRequest<SearchPatientResultDTO[]>(
      {url: `/api/Patient/RecentSearches`, method: 'GET'
    },
      options);
    }

export const deleteApiPatientRecentSearches = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Patient/RecentSearches`, method: 'DELETE'
    },
      options);
    }

export const getApiPatientAuthorizationGetByPatientPatientId = (
    patientId: number,
    params?: GetApiPatientAuthorizationGetByPatientPatientIdParams,
 options?: SecondParameter<typeof sendRequest<PatientAuthorizationListItemDTOPaginatedResponseDTO>>,) => {
      return sendRequest<PatientAuthorizationListItemDTOPaginatedResponseDTO>(
      {url: `/api/PatientAuthorization/GetByPatient/${patientId}`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientAuthorizationGetByInsuranceInsuranceId = (
    insuranceId: number,
 options?: SecondParameter<typeof sendRequest<PatientAuthorizationListItemDTO[]>>,) => {
      return sendRequest<PatientAuthorizationListItemDTO[]>(
      {url: `/api/PatientAuthorization/GetByInsurance/${insuranceId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientAuthorizationGetByIdPatientAuthorizationId = (
    patientAuthorizationId: number,
 options?: SecondParameter<typeof sendRequest<PatientAuthorizationResponseDTO>>,) => {
      return sendRequest<PatientAuthorizationResponseDTO>(
      {url: `/api/PatientAuthorization/GetById/${patientAuthorizationId}`, method: 'GET'
    },
      options);
    }

export const postApiPatientAuthorizationSave = (
    patientAuthorizationSaveRequestDTO?: PatientAuthorizationSaveRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientAuthorizationResponseDTO>>,) => {
      return sendRequest<PatientAuthorizationResponseDTO>(
      {url: `/api/PatientAuthorization/Save`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientAuthorizationSaveRequestDTO
    },
      options);
    }

export const deleteApiPatientAuthorizationDeletePatientAuthorizationId = (
    patientAuthorizationId: number,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PatientAuthorization/Delete/${patientAuthorizationId}`, method: 'DELETE'
    },
      options);
    }

export const getApiPCCActivationGetSettings = (

 options?: SecondParameter<typeof sendRequest<PCCOrgActivationSettingsDTO>>,) => {
      return sendRequest<PCCOrgActivationSettingsDTO>(
      {url: `/api/PCCActivation/GetSettings`, method: 'GET'
    },
      options);
    }

export const postApiPCCActivationSetSettings = (
    setPCCOrgActivationSettingsRequestDTO?: SetPCCOrgActivationSettingsRequestDTO,
 options?: SecondParameter<typeof sendRequest<PCCOrgActivationSettingsDTO>>,) => {
      return sendRequest<PCCOrgActivationSettingsDTO>(
      {url: `/api/PCCActivation/SetSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setPCCOrgActivationSettingsRequestDTO
    },
      options);
    }

export const postApiPCCActivationDeactivate = (

 options?: SecondParameter<typeof sendRequest<PCCOrgActivationSettingsDTO>>,) => {
      return sendRequest<PCCOrgActivationSettingsDTO>(
      {url: `/api/PCCActivation/Deactivate`, method: 'POST'
    },
      options);
    }

export const postApiPCCCommuniqueSendByPatientId = (
    params?: PostApiPCCCommuniqueSendByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PCCCommunique/SendByPatientId`, method: 'POST',
        params
    },
      options);
    }

export const postApiPCCCommuniqueSendModMedByPatientId = (
    params?: PostApiPCCCommuniqueSendModMedByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PCCCommunique/SendModMedByPatientId`, method: 'POST',
        params
    },
      options);
    }

export const postApiPCCConsentTriggerPCCEligibilityViewSyncByOrg = (
    params?: PostApiPCCConsentTriggerPCCEligibilityViewSyncByOrgParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PCCConsent/TriggerPCCEligibilityViewSyncByOrg`, method: 'POST',
        params
    },
      options);
    }

export const getApiPCCConsentGetByPatientId = (
    params?: GetApiPCCConsentGetByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<PatientPCCConsentsDTO>>,) => {
      return sendRequest<PatientPCCConsentsDTO>(
      {url: `/api/PCCConsent/GetByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const putApiPCCConsentUpdate = (
    updatePatientPCCConsentsRequestDTO?: UpdatePatientPCCConsentsRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientPCCConsentsDTO>>,) => {
      return sendRequest<PatientPCCConsentsDTO>(
      {url: `/api/PCCConsent/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePatientPCCConsentsRequestDTO
    },
      options);
    }

export const postApiPCCConsentOptInToCCM = (
    optInPatientToCCMRequestDTO?: OptInPatientToCCMRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PCCConsent/OptInToCCM`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: optInPatientToCCMRequestDTO
    },
      options);
    }

export const postApiPCCConsentEnrollPatient = (
    enrollPatientInPCCProgramsRequestDTO?: EnrollPatientInPCCProgramsRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PCCConsent/EnrollPatient`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollPatientInPCCProgramsRequestDTO
    },
      options);
    }

export const getApiPCCConsentGetEnabledPrograms = (

 options?: SecondParameter<typeof sendRequest<PCCProgram[]>>,) => {
      return sendRequest<PCCProgram[]>(
      {url: `/api/PCCConsent/GetEnabledPrograms`, method: 'GET'
    },
      options);
    }

export const postApiPCCConsentSendPCCConsent = (
    sendPatientPCCConsentRequestDTO?: SendPatientPCCConsentRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PCCConsent/SendPCCConsent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendPatientPCCConsentRequestDTO
    },
      options);
    }

export const postApiPCCConsentTriggerDefaultConsentSyncByOrg = (
    params?: PostApiPCCConsentTriggerDefaultConsentSyncByOrgParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PCCConsent/TriggerDefaultConsentSyncByOrg`, method: 'POST',
        params
    },
      options);
    }

export const postApiPCCDashboardGetPCCPatientDetails = (
    pCCPatientDetailsRequestDTO?: NonReadonly<PCCPatientDetailsRequestDTO>,
 options?: SecondParameter<typeof sendRequest<PCCPatientDetailsResponseDTO>>,) => {
      return sendRequest<PCCPatientDetailsResponseDTO>(
      {url: `/api/PCCDashboard/GetPCCPatientDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pCCPatientDetailsRequestDTO
    },
      options);
    }

export const postApiPCCDashboardGetPatientDetailsByPatientId = (
    pCCPatientDetailRequestDTO?: PCCPatientDetailRequestDTO,
 options?: SecondParameter<typeof sendRequest<PCCPatientDetailResponseDTO>>,) => {
      return sendRequest<PCCPatientDetailResponseDTO>(
      {url: `/api/PCCDashboard/GetPatientDetailsByPatientId`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pCCPatientDetailRequestDTO
    },
      options);
    }

export const postApiPCCDashboardGetCcmCallsByPatientId = (
    pCCCcmCallsRequestDTO?: PCCCcmCallsRequestDTO,
 options?: SecondParameter<typeof sendRequest<PCCCcmCallDTO[]>>,) => {
      return sendRequest<PCCCcmCallDTO[]>(
      {url: `/api/PCCDashboard/GetCcmCallsByPatientId`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pCCCcmCallsRequestDTO
    },
      options);
    }

export const getApiPopulateSupportGetAllOrganizations = (

 options?: SecondParameter<typeof sendRequest<PopulateSupportOrganizationDTO[]>>,) => {
      return sendRequest<PopulateSupportOrganizationDTO[]>(
      {url: `/api/PopulateSupport/GetAllOrganizations`, method: 'GET'
    },
      options);
    }

export const getApiPopulateSupportGetUsersByOrganization = (
    params?: GetApiPopulateSupportGetUsersByOrganizationParams,
 options?: SecondParameter<typeof sendRequest<PopulateSupportUserDTO[]>>,) => {
      return sendRequest<PopulateSupportUserDTO[]>(
      {url: `/api/PopulateSupport/GetUsersByOrganization`, method: 'GET',
        params
    },
      options);
    }

export const postApiPopulateSupportImpersonate = (
    impersonateRequestDTO?: ImpersonateRequestDTO,
 options?: SecondParameter<typeof sendRequest<ImpersonateResponseDTO>>,) => {
      return sendRequest<ImpersonateResponseDTO>(
      {url: `/api/PopulateSupport/Impersonate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: impersonateRequestDTO
    },
      options);
    }

export const postApiPopulateSupportMigratePatientNames = (
    patientNameMigrationRequestDTO?: PatientNameMigrationRequestDTO,
 options?: SecondParameter<typeof sendRequest<PatientNameMigrationResultDTO>>,) => {
      return sendRequest<PatientNameMigrationResultDTO>(
      {url: `/api/PopulateSupport/MigratePatientNames`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientNameMigrationRequestDTO
    },
      options);
    }

export const postApiPopulateSupportEnrollPatientsInPCCPrograms = (
    pCCProgramEnrollmentRequestDTO?: PCCProgramEnrollmentRequestDTO[],
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PopulateSupport/EnrollPatientsInPCCPrograms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pCCProgramEnrollmentRequestDTO
    },
      options);
    }

export const postApiPopulateSupportTriggerCommunicationMethodAlertSync = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PopulateSupport/TriggerCommunicationMethodAlertSync`, method: 'POST'
    },
      options);
    }

export const postApiPopulateSupportTriggerSuperDialSubmission = (
    params?: PostApiPopulateSupportTriggerSuperDialSubmissionParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PopulateSupport/TriggerSuperDialSubmission`, method: 'POST',
        params
    },
      options);
    }

export const postApiPopulateSupportTriggerSuperDialSubmissionForClaims = (
    postApiPopulateSupportTriggerSuperDialSubmissionForClaimsBody?: number[],
    params?: PostApiPopulateSupportTriggerSuperDialSubmissionForClaimsParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PopulateSupport/TriggerSuperDialSubmissionForClaims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiPopulateSupportTriggerSuperDialSubmissionForClaimsBody,
        params
    },
      options);
    }

export const postApiPopulateSupportRetryFailedSuperDialWebhook = (
    params?: PostApiPopulateSupportRetryFailedSuperDialWebhookParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/PopulateSupport/RetryFailedSuperDialWebhook`, method: 'POST',
        params
    },
      options);
    }

export const postApiPopulateSupportSyncCompletedSuperDialSummary = (
    params?: PostApiPopulateSupportSyncCompletedSuperDialSummaryParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/PopulateSupport/SyncCompletedSuperDialSummary`, method: 'POST',
        params
    },
      options);
    }

export const getApiProviderAvailabilityGetProviderAvailability = (
    params?: GetApiProviderAvailabilityGetProviderAvailabilityParams,
 options?: SecondParameter<typeof sendRequest<ProviderAvailabilityDTO>>,) => {
      return sendRequest<ProviderAvailabilityDTO>(
      {url: `/api/ProviderAvailability/GetProviderAvailability`, method: 'GET',
        params
    },
      options);
    }

export const postApiProviderAvailabilityAddOrUpdate = (
    providerAvailabilityDTO?: NonReadonly<ProviderAvailabilityDTO>,
 options?: SecondParameter<typeof sendRequest<SaveAvailabilityResponse>>,) => {
      return sendRequest<SaveAvailabilityResponse>(
      {url: `/api/ProviderAvailability/AddOrUpdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: providerAvailabilityDTO
    },
      options);
    }

export const deleteApiProviderAvailabilityDelete = (
    params?: DeleteApiProviderAvailabilityDeleteParams,
 options?: SecondParameter<typeof sendRequest<DeleteCalendarSlotResponseDTO>>,) => {
      return sendRequest<DeleteCalendarSlotResponseDTO>(
      {url: `/api/ProviderAvailability/Delete`, method: 'DELETE',
        params
    },
      options);
    }

export const postApiProviderAvailabilityDeletePartially = (
    deletePartialRequest?: DeletePartialRequest,
 options?: SecondParameter<typeof sendRequest<DeleteCalendarSlotResponseDTO>>,) => {
      return sendRequest<DeleteCalendarSlotResponseDTO>(
      {url: `/api/ProviderAvailability/DeletePartially`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deletePartialRequest
    },
      options);
    }

export const getApiReportGetReportSettings = (

 options?: SecondParameter<typeof sendRequest<ReportSettingsResponseDTO>>,) => {
      return sendRequest<ReportSettingsResponseDTO>(
      {url: `/api/Report/GetReportSettings`, method: 'GET'
    },
      options);
    }

export const postApiReportTriggerReport = (
    reportRequestDTOBase?: ReportRequestDTOBase,
 options?: SecondParameter<typeof sendRequest<TriggerReportResponseDTO>>,) => {
      return sendRequest<TriggerReportResponseDTO>(
      {url: `/api/Report/TriggerReport`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportRequestDTOBase
    },
      options);
    }

export const postApiReportGetReports = (
    reportRequestDTO?: ReportRequestDTO,
 options?: SecondParameter<typeof sendRequest<ReportResponseDTO>>,) => {
      return sendRequest<ReportResponseDTO>(
      {url: `/api/Report/GetReports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportRequestDTO
    },
      options);
    }

export const getApiReportDownloadReport = (
    params?: GetApiReportDownloadReportParams,
 options?: SecondParameter<typeof sendRequest<FileResultDTO>>,) => {
      return sendRequest<FileResultDTO>(
      {url: `/api/Report/DownloadReport`, method: 'GET',
        params
    },
      options);
    }

export const getApiReportGetReportOutput = (
    params?: GetApiReportGetReportOutputParams,
 options?: SecondParameter<typeof sendRequest<ReportOutputDTO>>,) => {
      return sendRequest<ReportOutputDTO>(
      {url: `/api/Report/GetReportOutput`, method: 'GET',
        params
    },
      options);
    }

export const getApiReportDownloadReportOutputFile = (
    params?: GetApiReportDownloadReportOutputFileParams,
 options?: SecondParameter<typeof sendRequest<FileResultDTO>>,) => {
      return sendRequest<FileResultDTO>(
      {url: `/api/Report/DownloadReportOutputFile`, method: 'GET',
        params
    },
      options);
    }

export const getApiReportGetReportOutputFilePreviewUrl = (
    params?: GetApiReportGetReportOutputFilePreviewUrlParams,
 options?: SecondParameter<typeof sendRequest<ReportOutputFilePreviewDTO>>,) => {
      return sendRequest<ReportOutputFilePreviewDTO>(
      {url: `/api/Report/GetReportOutputFilePreviewUrl`, method: 'GET',
        params
    },
      options);
    }

export const postApiReportDeleteReport = (
    params?: PostApiReportDeleteReportParams,
 options?: SecondParameter<typeof sendRequest<FileResultDTO>>,) => {
      return sendRequest<FileResultDTO>(
      {url: `/api/Report/DeleteReport`, method: 'POST',
        params
    },
      options);
    }

export const postApiReportTestWeeklyARReport = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Report/TestWeeklyARReport`, method: 'POST'
    },
      options);
    }

export const postApiReportTestWeeklyPCCReport = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Report/TestWeeklyPCCReport`, method: 'POST'
    },
      options);
    }

export const postApiReportTestMonthlyPCCCollectionsARReport = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Report/TestMonthlyPCCCollectionsARReport`, method: 'POST'
    },
      options);
    }

export const getApiRoomGetRoomStatus = (

 options?: SecondParameter<typeof sendRequest<RoomStatusDTO[]>>,) => {
      return sendRequest<RoomStatusDTO[]>(
      {url: `/api/Room/GetRoomStatus`, method: 'GET'
    },
      options);
    }

export const getApiRTMGetStatusByPatientId = (
    params?: GetApiRTMGetStatusByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<RTMPatientStatusResponseDTO>>,) => {
      return sendRequest<RTMPatientStatusResponseDTO>(
      {url: `/api/RTM/GetStatusByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const postApiRTMMonitoringAddQualificationByPatientId = (
    params?: PostApiRTMMonitoringAddQualificationByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/RTMMonitoring/AddQualificationByPatientId`, method: 'POST',
        params
    },
      options);
    }

export const postApiRTMMonitoringGetPatients = (
    rTMPatientsRequestDTO?: RTMPatientsRequestDTO,
 options?: SecondParameter<typeof sendRequest<RTMPatientsResponseDTO>>,) => {
      return sendRequest<RTMPatientsResponseDTO>(
      {url: `/api/RTMMonitoring/GetPatients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rTMPatientsRequestDTO
    },
      options);
    }

export const getApiRTMMonitoringGetEncountersForRTMRecommendation = (
    params?: GetApiRTMMonitoringGetEncountersForRTMRecommendationParams,
 options?: SecondParameter<typeof sendRequest<EncounterSummaryViewModel[]>>,) => {
      return sendRequest<EncounterSummaryViewModel[]>(
      {url: `/api/RTMMonitoring/GetEncountersForRTMRecommendation`, method: 'GET',
        params
    },
      options);
    }

export const getApiRTMMonitoringGetPatientTrend = (
    params?: GetApiRTMMonitoringGetPatientTrendParams,
 options?: SecondParameter<typeof sendRequest<RTMPatientTrendResponseDTO>>,) => {
      return sendRequest<RTMPatientTrendResponseDTO>(
      {url: `/api/RTMMonitoring/GetPatientTrend`, method: 'GET',
        params
    },
      options);
    }

export const postApiRTMMonitoringMarkPatientReviewed = (
    markRTMPatientReviewedRequestDTO?: MarkRTMPatientReviewedRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/RTMMonitoring/MarkPatientReviewed`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markRTMPatientReviewedRequestDTO
    },
      options);
    }

export const postApiRTMMonitoringSendCheckInSurveyByPatientId = (
    params?: PostApiRTMMonitoringSendCheckInSurveyByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/RTMMonitoring/SendCheckInSurveyByPatientId`, method: 'POST',
        params
    },
      options);
    }

export const postApiRTMMonitoringSendEnrollmentInvitationByPatientId = (
    params?: PostApiRTMMonitoringSendEnrollmentInvitationByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/RTMMonitoring/SendEnrollmentInvitationByPatientId`, method: 'POST',
        params
    },
      options);
    }

export const getApiRTMMonitoringGetProviderThresholds = (
    params?: GetApiRTMMonitoringGetProviderThresholdsParams,
 options?: SecondParameter<typeof sendRequest<RTMProviderThresholdsDTO>>,) => {
      return sendRequest<RTMProviderThresholdsDTO>(
      {url: `/api/RTMMonitoring/GetProviderThresholds`, method: 'GET',
        params
    },
      options);
    }

export const postApiRTMMonitoringAddOrUpdateProviderThresholds = (
    rTMProviderThresholdsDTO?: RTMProviderThresholdsDTO,
 options?: SecondParameter<typeof sendRequest<RTMProviderThresholdsDTO>>,) => {
      return sendRequest<RTMProviderThresholdsDTO>(
      {url: `/api/RTMMonitoring/AddOrUpdateProviderThresholds`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rTMProviderThresholdsDTO
    },
      options);
    }

export const deleteApiRTMMonitoringDeleteProviderThresholds = (
    params?: DeleteApiRTMMonitoringDeleteProviderThresholdsParams,
 options?: SecondParameter<typeof sendRequest<unknown>>,) => {
      return sendRequest<unknown>(
      {url: `/api/RTMMonitoring/DeleteProviderThresholds`, method: 'DELETE',
        params
    },
      options);
    }

export const postApiScheduledJobRunBatchSyncMedicalHistoryForOrgOrgId = (
    orgId: number,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/ScheduledJob/RunBatchSyncMedicalHistoryForOrg/${orgId}`, method: 'POST'
    },
      options);
    }

export const postApiScheduledJobRunOldPatientDosespotSync = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/ScheduledJob/RunOldPatientDosespotSync`, method: 'POST'
    },
      options);
    }

export const getApiSettingsHasUnseenUserMessages = (

 options?: SecondParameter<typeof sendRequest<boolean>>,) => {
      return sendRequest<boolean>(
      {url: `/api/Settings/HasUnseenUserMessages`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetIntakeFormSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetIntakeFormSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGePatientHistoryOptions = (
    params?: GetApiSettingsGePatientHistoryOptionsParams,
 options?: SecondParameter<typeof sendRequest<StringPaginatedResponseDTO>>,) => {
      return sendRequest<StringPaginatedResponseDTO>(
      {url: `/api/Settings/GePatientHistoryOptions`, method: 'GET',
        params
    },
      options);
    }

export const getApiSettingsGetClaimSettings = (

 options?: SecondParameter<typeof sendRequest<ClaimSettingsDTO>>,) => {
      return sendRequest<ClaimSettingsDTO>(
      {url: `/api/Settings/GetClaimSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetInsuranceSettings = (

 options?: SecondParameter<typeof sendRequest<InsuranceSettingsDTO>>,) => {
      return sendRequest<InsuranceSettingsDTO>(
      {url: `/api/Settings/GetInsuranceSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetEOBFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetEOBFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetChargeFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetChargeFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetCcmMonthlyDashboardFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetCcmMonthlyDashboardFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetTempoDashboardFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetTempoDashboardFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetRTMMonitoringFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetRTMMonitoringFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetRTMSettings = (

 options?: SecondParameter<typeof sendRequest<RTMSettingsDTO>>,) => {
      return sendRequest<RTMSettingsDTO>(
      {url: `/api/Settings/GetRTMSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetSurgicalChecklistFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetSurgicalChecklistFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetPatientPaymentTransactionFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetPatientPaymentTransactionFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetPatientMultimediaFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetPatientMultimediaFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetAppointmentSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetAppointmentSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetPatientAppointmentChangeSettings = (

 options?: SecondParameter<typeof sendRequest<PatientAppointmentChangeSettingsDTO>>,) => {
      return sendRequest<PatientAppointmentChangeSettingsDTO>(
      {url: `/api/Settings/GetPatientAppointmentChangeSettings`, method: 'GET'
    },
      options);
    }

export const putApiSettingsUpdatePatientAppointmentChangeSettings = (
    patientAppointmentChangeSettingsDTO?: PatientAppointmentChangeSettingsDTO,
 options?: SecondParameter<typeof sendRequest<PatientAppointmentChangeSettingsDTO>>,) => {
      return sendRequest<PatientAppointmentChangeSettingsDTO>(
      {url: `/api/Settings/UpdatePatientAppointmentChangeSettings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientAppointmentChangeSettingsDTO
    },
      options);
    }

export const getApiSettingsGetAppointmentTypeSettings = (

 options?: SecondParameter<typeof sendRequest<AppointmentTypeSettingDTO[]>>,) => {
      return sendRequest<AppointmentTypeSettingDTO[]>(
      {url: `/api/Settings/GetAppointmentTypeSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetPatientAppointmentStatusSettings = (

 options?: SecondParameter<typeof sendRequest<PatientAppointmentStatusSettingDTO[]>>,) => {
      return sendRequest<PatientAppointmentStatusSettingDTO[]>(
      {url: `/api/Settings/GetPatientAppointmentStatusSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetFixedAppointmentStatuses = (

 options?: SecondParameter<typeof sendRequest<string[]>>,) => {
      return sendRequest<string[]>(
      {url: `/api/Settings/GetFixedAppointmentStatuses`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetRoomSettings = (

 options?: SecondParameter<typeof sendRequest<RoomSettingDTO[]>>,) => {
      return sendRequest<RoomSettingDTO[]>(
      {url: `/api/Settings/GetRoomSettings`, method: 'GET'
    },
      options);
    }

export const postApiSettingsAddRoomSetting = (
    createRoomsSettingDTO?: CreateRoomsSettingDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Settings/AddRoomSetting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRoomsSettingDTO
    },
      options);
    }

export const patchApiSettingsUpdateRoomSetting = (
    updateRoomsSetingDTO?: UpdateRoomsSetingDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Settings/UpdateRoomSetting`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateRoomsSetingDTO
    },
      options);
    }

export const deleteApiSettingsDeleteRoomSetting = (
    params?: DeleteApiSettingsDeleteRoomSettingParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Settings/DeleteRoomSetting`, method: 'DELETE',
        params
    },
      options);
    }

export const postApiSettingsAddAppointmentTypeSetting = (
    appointmentTypeSettingDTO?: AppointmentTypeSettingDTO,
 options?: SecondParameter<typeof sendRequest<AppointmentTypeSettingDTO>>,) => {
      return sendRequest<AppointmentTypeSettingDTO>(
      {url: `/api/Settings/AddAppointmentTypeSetting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appointmentTypeSettingDTO
    },
      options);
    }

export const postApiSettingsUpdateAppointmentTypeSetting = (
    appointmentTypeSettingDTO?: AppointmentTypeSettingDTO,
 options?: SecondParameter<typeof sendRequest<AppointmentTypeSettingDTO>>,) => {
      return sendRequest<AppointmentTypeSettingDTO>(
      {url: `/api/Settings/UpdateAppointmentTypeSetting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appointmentTypeSettingDTO
    },
      options);
    }

export const getApiSettingsGetToDoSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetToDoSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetFormWorkflowSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetFormWorkflowSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetWriteOffSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetWriteOffSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetEFaxFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetEFaxFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetUserManagementSettings = (

 options?: SecondParameter<typeof sendRequest<UserManagementSettingsDTO>>,) => {
      return sendRequest<UserManagementSettingsDTO>(
      {url: `/api/Settings/GetUserManagementSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetMediaSettings = (

 options?: SecondParameter<typeof sendRequest<MediaSettingsDTO>>,) => {
      return sendRequest<MediaSettingsDTO>(
      {url: `/api/Settings/GetMediaSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetOrCreateUserSettings = (

 options?: SecondParameter<typeof sendRequest<UserSettingDTO>>,) => {
      return sendRequest<UserSettingDTO>(
      {url: `/api/Settings/GetOrCreateUserSettings`, method: 'GET'
    },
      options);
    }

export const postApiSettingsCreateOrUpdateUserSettings = (
    userSettingDTO?: UserSettingDTO,
 options?: SecondParameter<typeof sendRequest<UserSettingDTO>>,) => {
      return sendRequest<UserSettingDTO>(
      {url: `/api/Settings/CreateOrUpdateUserSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userSettingDTO
    },
      options);
    }

export const getApiSettingsGetModifierListSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetModifierListSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetPayerEntryConfigsByType = (
    params?: GetApiSettingsGetPayerEntryConfigsByTypeParams,
 options?: SecondParameter<typeof sendRequest<PayerEntryConfigDTOPaginatedResponseDTO>>,) => {
      return sendRequest<PayerEntryConfigDTOPaginatedResponseDTO>(
      {url: `/api/Settings/GetPayerEntryConfigsByType`, method: 'GET',
        params
    },
      options);
    }

export const postApiSettingsAddPaperPayerEntry = (
    createPaperPayerRequestDTO?: CreatePaperPayerRequestDTO,
 options?: SecondParameter<typeof sendRequest<PaperPayerEntryDTO>>,) => {
      return sendRequest<PaperPayerEntryDTO>(
      {url: `/api/Settings/AddPaperPayerEntry`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPaperPayerRequestDTO
    },
      options);
    }

export const putApiSettingsUpdatePaperPayerEntry = (
    updatePaperPayerRequestDTO?: UpdatePaperPayerRequestDTO,
 options?: SecondParameter<typeof sendRequest<PaperPayerEntryDTO>>,) => {
      return sendRequest<PaperPayerEntryDTO>(
      {url: `/api/Settings/UpdatePaperPayerEntry`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePaperPayerRequestDTO
    },
      options);
    }

export const deleteApiSettingsDeletePaperPayerEntry = (
    params?: DeleteApiSettingsDeletePaperPayerEntryParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Settings/DeletePaperPayerEntry`, method: 'DELETE',
        params
    },
      options);
    }

export const postApiSettingsAddElectronicPayerEntryConfig = (
    payerEntryConfigDTO?: PayerEntryConfigDTO,
 options?: SecondParameter<typeof sendRequest<PayerEntryConfigDTO>>,) => {
      return sendRequest<PayerEntryConfigDTO>(
      {url: `/api/Settings/AddElectronicPayerEntryConfig`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payerEntryConfigDTO
    },
      options);
    }

export const putApiSettingsUpdateElectronicPayerEntryConfig = (
    payerEntryConfigDTO?: PayerEntryConfigDTO,
 options?: SecondParameter<typeof sendRequest<PayerEntryConfigDTO>>,) => {
      return sendRequest<PayerEntryConfigDTO>(
      {url: `/api/Settings/UpdateElectronicPayerEntryConfig`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: payerEntryConfigDTO
    },
      options);
    }

export const deleteApiSettingsDeleteElectronicPayerEntryConfig = (
    params?: DeleteApiSettingsDeleteElectronicPayerEntryConfigParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Settings/DeleteElectronicPayerEntryConfig`, method: 'DELETE',
        params
    },
      options);
    }

export const getApiSettingsGetProviderEntryConfig = (
    params?: GetApiSettingsGetProviderEntryConfigParams,
 options?: SecondParameter<typeof sendRequest<ProviderEntryConfigDTO>>,) => {
      return sendRequest<ProviderEntryConfigDTO>(
      {url: `/api/Settings/GetProviderEntryConfig`, method: 'GET',
        params
    },
      options);
    }

export const postApiSettingsUpsertProviderEntryConfig = (
    providerEntryConfigDTO?: ProviderEntryConfigDTO,
 options?: SecondParameter<typeof sendRequest<ProviderEntryConfigDTO>>,) => {
      return sendRequest<ProviderEntryConfigDTO>(
      {url: `/api/Settings/UpsertProviderEntryConfig`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: providerEntryConfigDTO
    },
      options);
    }

export const postApiSnapGetAudioUploadUrl = (
    snapAudioUploadSasUrlRequestDTO?: SnapAudioUploadSasUrlRequestDTO,
 options?: SecondParameter<typeof sendRequest<FileUploadSasUrlResponseDTO>>,) => {
      return sendRequest<FileUploadSasUrlResponseDTO>(
      {url: `/api/Snap/GetAudioUploadUrl`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: snapAudioUploadSasUrlRequestDTO
    },
      options);
    }

export const postApiSnapEnqueueNoteGeneration = (
    enqueueNoteGenerationRequestDTO?: EnqueueNoteGenerationRequestDTO,
 options?: SecondParameter<typeof sendRequest<EnqueueNoteGenerationResponseDTO>>,) => {
      return sendRequest<EnqueueNoteGenerationResponseDTO>(
      {url: `/api/Snap/EnqueueNoteGeneration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enqueueNoteGenerationRequestDTO
    },
      options);
    }

export const getApiSnapGetNoteBySnapAttemptId = (
    params?: GetApiSnapGetNoteBySnapAttemptIdParams,
 options?: SecondParameter<typeof sendRequest<GetNoteBySnapAttemptIdResponseDTO>>,) => {
      return sendRequest<GetNoteBySnapAttemptIdResponseDTO>(
      {url: `/api/Snap/GetNoteBySnapAttemptId`, method: 'GET',
        params
    },
      options);
    }

export const getApiSquareAuthorizationGetAuthorizationUrl = (

 options?: SecondParameter<typeof sendRequest<string>>,) => {
      return sendRequest<string>(
      {url: `/api/SquareAuthorization/GetAuthorizationUrl`, method: 'GET'
    },
      options);
    }

export const getApiSquareAuthorizationAuthorizationRedirect = (
    params?: GetApiSquareAuthorizationAuthorizationRedirectParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquareAuthorization/AuthorizationRedirect`, method: 'GET',
        params
    },
      options);
    }

export const postApiSquareAuthorizationRetrieveTokenStatus = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquareAuthorization/RetrieveTokenStatus`, method: 'POST'
    },
      options);
    }

export const postApiSquareAuthorizationRefreshToken = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquareAuthorization/RefreshToken`, method: 'POST'
    },
      options);
    }

export const postApiSquareAuthorizationRevokeToken = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquareAuthorization/RevokeToken`, method: 'POST'
    },
      options);
    }

export const postApiSquarePaymentsHandleEventNotification = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquarePayments/HandleEventNotification`, method: 'POST'
    },
      options);
    }

export const getApiSquarePaymentsListLocations = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquarePayments/ListLocations`, method: 'GET'
    },
      options);
    }

export const getApiSquarePaymentsGetDeviceByDeviceId = (
    params?: GetApiSquarePaymentsGetDeviceByDeviceIdParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquarePayments/GetDeviceByDeviceId`, method: 'GET',
        params
    },
      options);
    }

export const getApiSquarePaymentsListDevices = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquarePayments/ListDevices`, method: 'GET'
    },
      options);
    }

export const postApiSquarePaymentsCreateDeviceCodeForLocation = (
    params?: PostApiSquarePaymentsCreateDeviceCodeForLocationParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquarePayments/CreateDeviceCodeForLocation`, method: 'POST',
        params
    },
      options);
    }

export const postApiSquarePaymentsCreateTerminalCheckout = (
    params?: PostApiSquarePaymentsCreateTerminalCheckoutParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquarePayments/CreateTerminalCheckout`, method: 'POST',
        params
    },
      options);
    }

export const postApiSquarePaymentsGetPayment = (
    getPaymentRequest?: GetPaymentRequest,
 options?: SecondParameter<typeof sendRequest<PaymentDTO>>,) => {
      return sendRequest<PaymentDTO>(
      {url: `/api/SquarePayments/GetPayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getPaymentRequest
    },
      options);
    }

export const postApiSquarePaymentsCancelTerminalCheckout = (
    cancelTerminalCheckoutRequest?: CancelTerminalCheckoutRequest,
 options?: SecondParameter<typeof sendRequest<CancelledTerminalCheckoutDTO>>,) => {
      return sendRequest<CancelledTerminalCheckoutDTO>(
      {url: `/api/SquarePayments/CancelTerminalCheckout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelTerminalCheckoutRequest
    },
      options);
    }

export const postApiSquarePaymentsCreateQuickPayCheckout = (
    params?: PostApiSquarePaymentsCreateQuickPayCheckoutParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SquarePayments/CreateQuickPayCheckout`, method: 'POST',
        params
    },
      options);
    }

export const getApiStickyGetAllStickiesByPatientId = (
    params?: GetApiStickyGetAllStickiesByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<StickyDTO[]>>,) => {
      return sendRequest<StickyDTO[]>(
      {url: `/api/Sticky/GetAllStickiesByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const getApiStickyGetStickyById = (
    params?: GetApiStickyGetStickyByIdParams,
 options?: SecondParameter<typeof sendRequest<StickyDTO>>,) => {
      return sendRequest<StickyDTO>(
      {url: `/api/Sticky/GetStickyById`, method: 'GET',
        params
    },
      options);
    }

export const postApiStickyCreateSticky = (
    createStickyRequestDTO?: CreateStickyRequestDTO,
 options?: SecondParameter<typeof sendRequest<StickyDTO>>,) => {
      return sendRequest<StickyDTO>(
      {url: `/api/Sticky/CreateSticky`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStickyRequestDTO
    },
      options);
    }

export const postApiStickyUpdateSticky = (
    updateStickyRequestDTO?: UpdateStickyRequestDTO,
 options?: SecondParameter<typeof sendRequest<StickyDTO>>,) => {
      return sendRequest<StickyDTO>(
      {url: `/api/Sticky/UpdateSticky`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateStickyRequestDTO
    },
      options);
    }

export const deleteApiStickyDeleteSticky = (
    deleteStickyRequestDTO?: DeleteStickyRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Sticky/DeleteSticky`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteStickyRequestDTO
    },
      options);
    }

export const postApiSuperDialRequestWebhook = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/SuperDial/RequestWebhook`, method: 'POST'
    },
      options);
    }

export const postApiSupportSqlGenerateSql = (
    generateSupportSqlRequest?: GenerateSupportSqlRequest,
 options?: SecondParameter<typeof sendRequest<SupportSqlGenerationResult>>,) => {
      return sendRequest<SupportSqlGenerationResult>(
      {url: `/api/SupportSql/GenerateSql`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateSupportSqlRequest
    },
      options);
    }

export const postApiSupportSqlExecuteSql = (
    executeSupportSqlRequest?: ExecuteSupportSqlRequest,
 options?: SecondParameter<typeof sendRequest<SupportSqlExecutionResult>>,) => {
      return sendRequest<SupportSqlExecutionResult>(
      {url: `/api/SupportSql/ExecuteSql`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeSupportSqlRequest
    },
      options);
    }

export const getApiTagGetTags = (
    params?: GetApiTagGetTagsParams,
 options?: SecondParameter<typeof sendRequest<TagDTOPaginatedResponseDTO>>,) => {
      return sendRequest<TagDTOPaginatedResponseDTO>(
      {url: `/api/Tag/GetTags`, method: 'GET',
        params
    },
      options);
    }

export const postApiTagCreateTag = (
    createOrModifyTagDTO?: CreateOrModifyTagDTO,
 options?: SecondParameter<typeof sendRequest<TagDTO>>,) => {
      return sendRequest<TagDTO>(
      {url: `/api/Tag/CreateTag`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrModifyTagDTO
    },
      options);
    }

export const postApiTagUpdateTag = (
    createOrModifyTagDTO?: CreateOrModifyTagDTO,
 options?: SecondParameter<typeof sendRequest<TagDTO>>,) => {
      return sendRequest<TagDTO>(
      {url: `/api/Tag/UpdateTag`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrModifyTagDTO
    },
      options);
    }

export const deleteApiTagDeleteTag = (
    deleteRequestDTO?: DeleteRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Tag/DeleteTag`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteRequestDTO
    },
      options);
    }

export const getApiTagGetClaimWiseTagsClaimId = (
    claimId: number,
 options?: SecondParameter<typeof sendRequest<TagDTO[]>>,) => {
      return sendRequest<TagDTO[]>(
      {url: `/api/Tag/GetClaimWiseTags/${claimId}`, method: 'GET'
    },
      options);
    }

export const postApiTagUpdateClaimWiseTags = (
    claimWiseTagRequestDTO?: ClaimWiseTagRequestDTO,
 options?: SecondParameter<typeof sendRequest<TagDTO>>,) => {
      return sendRequest<TagDTO>(
      {url: `/api/Tag/UpdateClaimWiseTags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: claimWiseTagRequestDTO
    },
      options);
    }

export const getApiTelehealthGetProviderJoinInfoEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<TelehealthProviderJoinInfoDTO>>,) => {
      return sendRequest<TelehealthProviderJoinInfoDTO>(
      {url: `/api/Telehealth/GetProviderJoinInfo/${encounterId}`, method: 'GET'
    },
      options);
    }

export const postApiTelehealthGetPatientJoinInfo = (
    getPatientJoinUrlRequestDTO?: GetPatientJoinUrlRequestDTO,
 options?: SecondParameter<typeof sendRequest<TelehealthPatientJoinInfoDTO>>,) => {
      return sendRequest<TelehealthPatientJoinInfoDTO>(
      {url: `/api/Telehealth/GetPatientJoinInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getPatientJoinUrlRequestDTO
    },
      options);
    }

export const postApiTelehealthRetryMeetingCreationForAppointmentEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<TelehealthMeetingStatusDTO>>,) => {
      return sendRequest<TelehealthMeetingStatusDTO>(
      {url: `/api/Telehealth/RetryMeetingCreationForAppointment/${encounterId}`, method: 'POST'
    },
      options);
    }

export const postApiTemplateSaveSectionTemplate = (
    saveSectionTemplateRequestDTO?: SaveSectionTemplateRequestDTO,
 options?: SecondParameter<typeof sendRequest<SectionTemplateDTO>>,) => {
      return sendRequest<SectionTemplateDTO>(
      {url: `/api/Template/SaveSectionTemplate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveSectionTemplateRequestDTO
    },
      options);
    }

export const getApiTemplateRetrieveSectionTemplate = (
    params?: GetApiTemplateRetrieveSectionTemplateParams,
 options?: SecondParameter<typeof sendRequest<string>>,) => {
      return sendRequest<string>(
      {url: `/api/Template/RetrieveSectionTemplate`, method: 'GET',
        params
    },
      options);
    }

export const postApiTemplateRetrieveSectionTemplates = (
    retrieveSectionTemplateRequestDTO?: RetrieveSectionTemplateRequestDTO[],
 options?: SecondParameter<typeof sendRequest<SectionTemplateContentDTO[]>>,) => {
      return sendRequest<SectionTemplateContentDTO[]>(
      {url: `/api/Template/RetrieveSectionTemplates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: retrieveSectionTemplateRequestDTO
    },
      options);
    }

export const deleteApiTemplateDeleteSectionTemplate = (
    deleteSectionTemplateRequestDTO?: DeleteSectionTemplateRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Template/DeleteSectionTemplate`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteSectionTemplateRequestDTO
    },
      options);
    }

export const getApiTemplateGetSectionTemplateList = (
    params?: GetApiTemplateGetSectionTemplateListParams,
 options?: SecondParameter<typeof sendRequest<TemplateListItemDTOPaginatedResponseDTO>>,) => {
      return sendRequest<TemplateListItemDTOPaginatedResponseDTO>(
      {url: `/api/Template/GetSectionTemplateList`, method: 'GET',
        params
    },
      options);
    }

export const postApiTemplateSaveMasterTemplate = (
    saveMasterTemplateRequestDTO?: SaveMasterTemplateRequestDTO,
 options?: SecondParameter<typeof sendRequest<MasterTemplateDTO>>,) => {
      return sendRequest<MasterTemplateDTO>(
      {url: `/api/Template/SaveMasterTemplate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveMasterTemplateRequestDTO
    },
      options);
    }

export const getApiTemplateRetrieveMasterTemplate = (
    params?: GetApiTemplateRetrieveMasterTemplateParams,
 options?: SecondParameter<typeof sendRequest<MasterTemplateDTO>>,) => {
      return sendRequest<MasterTemplateDTO>(
      {url: `/api/Template/RetrieveMasterTemplate`, method: 'GET',
        params
    },
      options);
    }

export const deleteApiTemplateDeleteMasterTemplate = (
    deleteMasterTemplateRequestDTO?: DeleteMasterTemplateRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Template/DeleteMasterTemplate`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteMasterTemplateRequestDTO
    },
      options);
    }

export const getApiTemplateGetMasterTemplateList = (
    params?: GetApiTemplateGetMasterTemplateListParams,
 options?: SecondParameter<typeof sendRequest<TemplateListItemDTOPaginatedResponseDTO>>,) => {
      return sendRequest<TemplateListItemDTOPaginatedResponseDTO>(
      {url: `/api/Template/GetMasterTemplateList`, method: 'GET',
        params
    },
      options);
    }

export const getApiTemplateGetFieldList = (
    params?: GetApiTemplateGetFieldListParams,
 options?: SecondParameter<typeof sendRequest<TemplateFieldDTOPaginatedResponseDTO>>,) => {
      return sendRequest<TemplateFieldDTOPaginatedResponseDTO>(
      {url: `/api/Template/GetFieldList`, method: 'GET',
        params
    },
      options);
    }

export const getApiTemplateGetFieldFieldId = (
    fieldId: number,
 options?: SecondParameter<typeof sendRequest<TemplateFieldDTO>>,) => {
      return sendRequest<TemplateFieldDTO>(
      {url: `/api/Template/GetField/${fieldId}`, method: 'GET'
    },
      options);
    }

export const postApiTemplateAddField = (
    templateFieldRequestDTO?: TemplateFieldRequestDTO,
 options?: SecondParameter<typeof sendRequest<TemplateFieldDTO>>,) => {
      return sendRequest<TemplateFieldDTO>(
      {url: `/api/Template/AddField`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: templateFieldRequestDTO
    },
      options);
    }

export const putApiTemplateEditField = (
    templateFieldRequestDTO?: TemplateFieldRequestDTO,
 options?: SecondParameter<typeof sendRequest<TemplateFieldDTO>>,) => {
      return sendRequest<TemplateFieldDTO>(
      {url: `/api/Template/EditField`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: templateFieldRequestDTO
    },
      options);
    }

export const deleteApiTemplateDeleteField = (
    templateFieldDTO?: TemplateFieldDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Template/DeleteField`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: templateFieldDTO
    },
      options);
    }

export const getApiTempoGetTempoStatusByPatientId = (
    params?: GetApiTempoGetTempoStatusByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<PatientTempoStatus>>,) => {
      return sendRequest<PatientTempoStatus>(
      {url: `/api/Tempo/GetTempoStatusByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const postApiTempoSendDayOneCommunique = (
    params?: PostApiTempoSendDayOneCommuniqueParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Tempo/SendDayOneCommunique`, method: 'POST',
        params
    },
      options);
    }

export const postApiTempoSendDayTwoCommunique = (
    params?: PostApiTempoSendDayTwoCommuniqueParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Tempo/SendDayTwoCommunique`, method: 'POST',
        params
    },
      options);
    }

export const postApiTempoDashboardGetPatients = (
    tempoPatientsRequestDTO?: NonReadonly<TempoPatientsRequestDTO>,
 options?: SecondParameter<typeof sendRequest<TempoPatientsResponseDTO>>,) => {
      return sendRequest<TempoPatientsResponseDTO>(
      {url: `/api/TempoDashboard/GetPatients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tempoPatientsRequestDTO
    },
      options);
    }

export const postApiTempoDashboardGetPatientDetail = (
    tempoPatientDetailRequestDTO?: TempoPatientDetailRequestDTO,
 options?: SecondParameter<typeof sendRequest<TempoPatientDetailDTO>>,) => {
      return sendRequest<TempoPatientDetailDTO>(
      {url: `/api/TempoDashboard/GetPatientDetail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tempoPatientDetailRequestDTO
    },
      options);
    }

export const postApiToDoRequestToDoList = (
    toDoRequestDTO?: ToDoRequestDTO,
 options?: SecondParameter<typeof sendRequest<ToDoPaginatedCollectionDTO>>,) => {
      return sendRequest<ToDoPaginatedCollectionDTO>(
      {url: `/api/ToDo/RequestToDoList`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: toDoRequestDTO
    },
      options);
    }

export const postApiToDoGetTodosByPatientId = (
    getTodosByPatientIdRequestDTO?: GetTodosByPatientIdRequestDTO,
 options?: SecondParameter<typeof sendRequest<ToDoPanelItemDTOPaginatedResponseDTO>>,) => {
      return sendRequest<ToDoPanelItemDTOPaginatedResponseDTO>(
      {url: `/api/ToDo/GetTodosByPatientId`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getTodosByPatientIdRequestDTO
    },
      options);
    }

export const getApiToDoGetToDoById = (
    params?: GetApiToDoGetToDoByIdParams,
 options?: SecondParameter<typeof sendRequest<ToDoResponseWithReferencedObjectsDTO | void>>,) => {
      return sendRequest<ToDoResponseWithReferencedObjectsDTO | void>(
      {url: `/api/ToDo/GetToDoById`, method: 'GET',
        params
    },
      options);
    }

export const getApiToDoGetCommentsByToDoId = (
    params?: GetApiToDoGetCommentsByToDoIdParams,
 options?: SecondParameter<typeof sendRequest<ToDoCommentsCollectionDTO | void>>,) => {
      return sendRequest<ToDoCommentsCollectionDTO | void>(
      {url: `/api/ToDo/GetCommentsByToDoId`, method: 'GET',
        params
    },
      options);
    }

export const postApiToDoCreateToDo = (
    createToDoRequestDTO?: CreateToDoRequestDTO,
 options?: SecondParameter<typeof sendRequest<ToDoResponseDTO | void>>,) => {
      return sendRequest<ToDoResponseDTO | void>(
      {url: `/api/ToDo/CreateToDo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createToDoRequestDTO
    },
      options);
    }

export const postApiToDoCommentOnToDo = (
    toDoCommentRequestDTO?: ToDoCommentRequestDTO,
 options?: SecondParameter<typeof sendRequest<ToDoCommentDTO | void>>,) => {
      return sendRequest<ToDoCommentDTO | void>(
      {url: `/api/ToDo/CommentOnToDo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: toDoCommentRequestDTO
    },
      options);
    }

export const putApiToDoUpdateToDo = (
    toDoUpdateRequestDTO?: ToDoUpdateRequestDTO,
 options?: SecondParameter<typeof sendRequest<ToDoResponseDTO | void>>,) => {
      return sendRequest<ToDoResponseDTO | void>(
      {url: `/api/ToDo/UpdateToDo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: toDoUpdateRequestDTO
    },
      options);
    }

export const putApiToDoUpdateToDoCollaborators = (
    updateToDoCollaboratorsRequestDTO?: UpdateToDoCollaboratorsRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/ToDo/UpdateToDoCollaborators`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateToDoCollaboratorsRequestDTO
    },
      options);
    }

export const getApiToDoGetUnreadToDoCountOfUser = (

 options?: SecondParameter<typeof sendRequest<ToDoCountResponseDTO | void>>,) => {
      return sendRequest<ToDoCountResponseDTO | void>(
      {url: `/api/ToDo/GetUnreadToDoCountOfUser`, method: 'GET'
    },
      options);
    }

export const getApiToDoGetFaxToDos = (
    params?: GetApiToDoGetFaxToDosParams,
 options?: SecondParameter<typeof sendRequest<ToDoPaginatedCollectionDTO>>,) => {
      return sendRequest<ToDoPaginatedCollectionDTO>(
      {url: `/api/ToDo/GetFaxToDos`, method: 'GET',
        params
    },
      options);
    }

export const getApiUserGetAllUsersByTitleTitle = (
    title: string,
 options?: SecondParameter<typeof sendRequest<UserDTO[]>>,) => {
      return sendRequest<UserDTO[]>(
      {url: `/api/User/GetAllUsersByTitle/${title}`, method: 'GET'
    },
      options);
    }

export const getApiUserGetLoggedInUserInfo = (

 options?: SecondParameter<typeof sendRequest<LoggedInUserInfoDTO>>,) => {
      return sendRequest<LoggedInUserInfoDTO>(
      {url: `/api/User/GetLoggedInUserInfo`, method: 'GET'
    },
      options);
    }

export const getApiUserGetLoggedInEMRUserInfo = (

 options?: SecondParameter<typeof sendRequest<LoggedInUserInfoBaseDTO>>,) => {
      return sendRequest<LoggedInUserInfoBaseDTO>(
      {url: `/api/User/GetLoggedInEMRUserInfo`, method: 'GET'
    },
      options);
    }

export const getApiUserGetUsers = (

 options?: SecondParameter<typeof sendRequest<UserDTO[]>>,) => {
      return sendRequest<UserDTO[]>(
      {url: `/api/User/GetUsers`, method: 'GET'
    },
      options);
    }

export const postApiUserCreateUser = (
    createUserRequestDTO?: CreateUserRequestDTO,
 options?: SecondParameter<typeof sendRequest<UserDTO>>,) => {
      return sendRequest<UserDTO>(
      {url: `/api/User/CreateUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequestDTO
    },
      options);
    }

export const postApiUserUpdateUser = (
    updateUserRequestDTO?: UpdateUserRequestDTO,
 options?: SecondParameter<typeof sendRequest<UserDTO>>,) => {
      return sendRequest<UserDTO>(
      {url: `/api/User/UpdateUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequestDTO
    },
      options);
    }

export const postApiUserMessageRequestUserMessageList = (
    userMessageListRequestDTO?: UserMessageListRequestDTO,
 options?: SecondParameter<typeof sendRequest<UserMessagePaginatedCollectionDTO>>,) => {
      return sendRequest<UserMessagePaginatedCollectionDTO>(
      {url: `/api/UserMessage/RequestUserMessageList`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userMessageListRequestDTO
    },
      options);
    }

export const getApiVisitNoteGetAllVisitNotesByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<VisitNoteDTO[]>>,) => {
      return sendRequest<VisitNoteDTO[]>(
      {url: `/api/VisitNote/GetAllVisitNotesByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetUpcomingAppointmentsByPatientIdPatientId = (
    patientId: number,
    params?: GetApiVisitNoteGetUpcomingAppointmentsByPatientIdPatientIdParams,
 options?: SecondParameter<typeof sendRequest<PatientVisitDTO[]>>,) => {
      return sendRequest<PatientVisitDTO[]>(
      {url: `/api/VisitNote/GetUpcomingAppointmentsByPatientId/${patientId}`, method: 'GET',
        params
    },
      options);
    }

export const getApiVisitNoteGetHistoricalVisitsByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientVisitDTO[]>>,) => {
      return sendRequest<PatientVisitDTO[]>(
      {url: `/api/VisitNote/GetHistoricalVisitsByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const postApiVisitNotePrintUpcomingAppointmentsPdf = (
    upcomingAppointmentsPdfRequestDTO?: UpcomingAppointmentsPdfRequestDTO,
 options?: SecondParameter<typeof sendRequest<FileResultDTO>>,) => {
      return sendRequest<FileResultDTO>(
      {url: `/api/VisitNote/PrintUpcomingAppointmentsPdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upcomingAppointmentsPdfRequestDTO
    },
      options);
    }

export const getApiVisitNoteGetVisitNoteByEncounterIdEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<VisitNotePageResponseDTO>>,) => {
      return sendRequest<VisitNotePageResponseDTO>(
      {url: `/api/VisitNote/GetVisitNoteByEncounterId/${encounterId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetAppointmentRelatedInfoByVisitNoteIdVisitNoteId = (
    visitNoteId: number,
 options?: SecondParameter<typeof sendRequest<AppointmentInfoForVisitNoteDTO>>,) => {
      return sendRequest<AppointmentInfoForVisitNoteDTO>(
      {url: `/api/VisitNote/GetAppointmentRelatedInfoByVisitNoteId/${visitNoteId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetUserFavoriteMedicalCodes = (

 options?: SecondParameter<typeof sendRequest<UserFavoritedMedicalCodesResponseDTO>>,) => {
      return sendRequest<UserFavoritedMedicalCodesResponseDTO>(
      {url: `/api/VisitNote/GetUserFavoriteMedicalCodes`, method: 'GET'
    },
      options);
    }

export const postApiVisitNoteApproveRTMPlanVisitNoteId = (
    visitNoteId: number,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/VisitNote/ApproveRTMPlan/${visitNoteId}`, method: 'POST'
    },
      options);
    }

export const postApiVisitNoteSaveVisitNote = (
    visitNoteDTO?: VisitNoteDTO,
 options?: SecondParameter<typeof sendRequest<VisitNoteDTO>>,) => {
      return sendRequest<VisitNoteDTO>(
      {url: `/api/VisitNote/SaveVisitNote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: visitNoteDTO
    },
      options);
    }

export const putApiVisitNoteSaveVisitNoteSOAP = (
    saveVisitNoteSOAPRequestDTO?: SaveVisitNoteSOAPRequestDTO,
 options?: SecondParameter<typeof sendRequest<VisitNoteDTO>>,) => {
      return sendRequest<VisitNoteDTO>(
      {url: `/api/VisitNote/SaveVisitNoteSOAP`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveVisitNoteSOAPRequestDTO
    },
      options);
    }

export const getApiVisitNoteGetBillingAssessmentCodesFromVisitNotePatientIdVisitNoteId = (
    patientId: number,
    visitNoteId: number,
 options?: SecondParameter<typeof sendRequest<VisitNoteBillingAssessmentCodeDTO[]>>,) => {
      return sendRequest<VisitNoteBillingAssessmentCodeDTO[]>(
      {url: `/api/VisitNote/GetBillingAssessmentCodesFromVisitNote/${patientId}/${visitNoteId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetBillingCodesFromVisitNotePatientIdVisitNoteId = (
    patientId: number,
    visitNoteId: number,
 options?: SecondParameter<typeof sendRequest<VisitNoteBillingCodeDTO[]>>,) => {
      return sendRequest<VisitNoteBillingCodeDTO[]>(
      {url: `/api/VisitNote/GetBillingCodesFromVisitNote/${patientId}/${visitNoteId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetCustomServiceCodesFromVisitNotePatientIdVisitNoteId = (
    patientId: number,
    visitNoteId: number,
 options?: SecondParameter<typeof sendRequest<VisitNoteBillingCustomServiceCodeDTO[]>>,) => {
      return sendRequest<VisitNoteBillingCustomServiceCodeDTO[]>(
      {url: `/api/VisitNote/GetCustomServiceCodesFromVisitNote/${patientId}/${visitNoteId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetHPIInParagraphForm = (
    params?: GetApiVisitNoteGetHPIInParagraphFormParams,
 options?: SecondParameter<typeof sendRequest<string>>,) => {
      return sendRequest<string>(
      {url: `/api/VisitNote/GetHPIInParagraphForm`, method: 'GET',
        params
    },
      options);
    }

export const getApiVisitNoteGetAICodeSuggestionsEncounterIdCodeType = (
    encounterId: number,
    codeType: string,
 options?: SecondParameter<typeof sendRequest<CPTCodeSuggestionsDTO>>,) => {
      return sendRequest<CPTCodeSuggestionsDTO>(
      {url: `/api/VisitNote/GetAICodeSuggestions/${encounterId}/${codeType}`, method: 'GET'
    },
      options);
    }

export const putApiVisitNoteAddAddendum = (
    addendumDTO?: AddendumDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/VisitNote/AddAddendum`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addendumDTO
    },
      options);
    }

export const getApiVisitNoteGetAddendumFinalizedVisitNoteId = (
    finalizedVisitNoteId: number,
 options?: SecondParameter<typeof sendRequest<AddendumDTO>>,) => {
      return sendRequest<AddendumDTO>(
      {url: `/api/VisitNote/GetAddendum/${finalizedVisitNoteId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetPastVisitNotesForPatient = (
    params?: GetApiVisitNoteGetPastVisitNotesForPatientParams,
 options?: SecondParameter<typeof sendRequest<VisitNoteSummaryDTO[]>>,) => {
      return sendRequest<VisitNoteSummaryDTO[]>(
      {url: `/api/VisitNote/GetPastVisitNotesForPatient`, method: 'GET',
        params
    },
      options);
    }

export const getApiVisitNoteGetSpecificVisitNoteForPatient = (
    params?: GetApiVisitNoteGetSpecificVisitNoteForPatientParams,
 options?: SecondParameter<typeof sendRequest<VisitNoteDTO>>,) => {
      return sendRequest<VisitNoteDTO>(
      {url: `/api/VisitNote/GetSpecificVisitNoteForPatient`, method: 'GET',
        params
    },
      options);
    }

export const getApiVisitNoteGetSpecificVisitNoteSectionForPatient = (
    params?: GetApiVisitNoteGetSpecificVisitNoteSectionForPatientParams,
 options?: SecondParameter<typeof sendRequest<string>>,) => {
      return sendRequest<string>(
      {url: `/api/VisitNote/GetSpecificVisitNoteSectionForPatient`, method: 'GET',
        params
    },
      options);
    }

export const postApiVisitNoteUnFinalize = (
    params?: PostApiVisitNoteUnFinalizeParams,
 options?: SecondParameter<typeof sendRequest<VisitNoteDTO>>,) => {
      return sendRequest<VisitNoteDTO>(
      {url: `/api/VisitNote/UnFinalize`, method: 'POST',
        params
    },
      options);
    }

export const postApiVisitNotePrintVisitNotePdfEncounterId = (
    encounterId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/VisitNote/PrintVisitNotePdf/${encounterId}`, method: 'POST'
    },
      options);
    }

export const getApiVisitNoteGetMipsSuggestionVisitNoteId = (
    visitNoteId: number,
 options?: SecondParameter<typeof sendRequest<MipsResponseDTO>>,) => {
      return sendRequest<MipsResponseDTO>(
      {url: `/api/VisitNote/GetMipsSuggestion/${visitNoteId}`, method: 'GET'
    },
      options);
    }

export const getApiVisitNoteGetMipsSubmissionData = (
    params?: GetApiVisitNoteGetMipsSubmissionDataParams,
 options?: SecondParameter<typeof sendRequest<MipsSubmissionByTinXmlDTO[]>>,) => {
      return sendRequest<MipsSubmissionByTinXmlDTO[]>(
      {url: `/api/VisitNote/GetMipsSubmissionData`, method: 'GET',
        params
    },
      options);
    }

export const getApiVoiceAssistantGetSession = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/VoiceAssistant/GetSession`, method: 'GET'
    },
      options);
    }

export const getApiVoiceAssistantInitializeEmbeddings = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/VoiceAssistant/InitializeEmbeddings`, method: 'GET'
    },
      options);
    }

export const getApiVoiceAssistantInitializeAppointmentEmbeddings = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/VoiceAssistant/InitializeAppointmentEmbeddings`, method: 'GET'
    },
      options);
    }

export const getApiVoiceAssistantInitializePatientEmbeddings = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/VoiceAssistant/InitializePatientEmbeddings`, method: 'GET'
    },
      options);
    }

export const getApiVoiceAssistantGetQueryAnswer = (
    params?: GetApiVoiceAssistantGetQueryAnswerParams,
 options?: SecondParameter<typeof sendRequest<ChatMessageContent>>,) => {
      return sendRequest<ChatMessageContent>(
      {url: `/api/VoiceAssistant/GetQueryAnswer`, method: 'GET',
        params
    },
      options);
    }

export const getApiVoiceAssistantGetContextFromPopulate = (
    params?: GetApiVoiceAssistantGetContextFromPopulateParams,
 options?: SecondParameter<typeof sendRequest<string>>,) => {
      return sendRequest<string>(
      {url: `/api/VoiceAssistant/GetContextFromPopulate`, method: 'GET',
        params
    },
      options);
    }

export const getApiZocdocGetAuthToken = (
    params?: GetApiZocdocGetAuthTokenParams,
 options?: SecondParameter<typeof sendRequest<string>>,) => {
      return sendRequest<string>(
      {url: `/api/Zocdoc/GetAuthToken`, method: 'GET',
        params
    },
      options);
    }

export const postApiZocdocEnqueueSyncZocdocTimeSlotsForAllFacilities = (
    dateTimeRangeDTO?: DateTimeRangeDTO,
    params?: PostApiZocdocEnqueueSyncZocdocTimeSlotsForAllFacilitiesParams,
 options?: SecondParameter<typeof sendRequest<string>>,) => {
      return sendRequest<string>(
      {url: `/api/Zocdoc/EnqueueSyncZocdocTimeSlotsForAllFacilities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dateTimeRangeDTO,
        params
    },
      options);
    }

export const postApiZocdocEnqueueSyncZocdocTimeSlotsForUsers = (
    enqueueSyncZocdocTimeSlotsForUsersRequestDTO?: EnqueueSyncZocdocTimeSlotsForUsersRequestDTO,
 options?: SecondParameter<typeof sendRequest<EnqueueZocdocTimeSlotsForUsersResultDTO>>,) => {
      return sendRequest<EnqueueZocdocTimeSlotsForUsersResultDTO>(
      {url: `/api/Zocdoc/EnqueueSyncZocdocTimeSlotsForUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enqueueSyncZocdocTimeSlotsForUsersRequestDTO
    },
      options);
    }

export const postApiZocdocRetryWebhookEvent = (
    params?: PostApiZocdocRetryWebhookEventParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Zocdoc/RetryWebhookEvent`, method: 'POST',
        params
    },
      options);
    }

export const postApiZocdocRetryFailedSlotCreationAttempt = (
    params?: PostApiZocdocRetryFailedSlotCreationAttemptParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Zocdoc/RetryFailedSlotCreationAttempt`, method: 'POST',
        params
    },
      options);
    }

export const postApiZocdocSyncPastAppointmentsForAllOrgs = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Zocdoc/SyncPastAppointmentsForAllOrgs`, method: 'POST'
    },
      options);
    }

export const postApiZocdocEventHandlerWebhookTenantId = (
    webhookTenantId: string,
    zocdocWebhookPayload?: ZocdocWebhookPayload,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Zocdoc/EventHandler/${webhookTenantId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: zocdocWebhookPayload
    },
      options);
    }

export const postApiZoomWebhook = (

 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/Zoom/Webhook`, method: 'POST'
    },
      options);
    }

export type GetApiAddressGetGeoCodeByAddressResult = NonNullable<Awaited<ReturnType<typeof getApiAddressGetGeoCodeByAddress>>>
export type PostApiAlertsGetPatientAlertsResult = NonNullable<Awaited<ReturnType<typeof postApiAlertsGetPatientAlerts>>>
export type GetApiAlertsGetAlertTypesResult = NonNullable<Awaited<ReturnType<typeof getApiAlertsGetAlertTypes>>>
export type PostApiAlertsExecuteActionResult = NonNullable<Awaited<ReturnType<typeof postApiAlertsExecuteAction>>>
export type PostApiAlertsTriggerInsuranceAlertSyncByOrgResult = NonNullable<Awaited<ReturnType<typeof postApiAlertsTriggerInsuranceAlertSyncByOrg>>>
export type PostApiAlertsTriggerInsuranceAlertSyncByPatientIdsResult = NonNullable<Awaited<ReturnType<typeof postApiAlertsTriggerInsuranceAlertSyncByPatientIds>>>
export type PostApiAlertsTriggerInsuranceAlertSyncResult = NonNullable<Awaited<ReturnType<typeof postApiAlertsTriggerInsuranceAlertSync>>>
export type PostApiAppointmentReminderAgentCallForAppointmentReminderResult = NonNullable<Awaited<ReturnType<typeof postApiAppointmentReminderAgentCallForAppointmentReminder>>>
export type PostApiAppointmentRemindersDashboardGetAppointmentsResult = NonNullable<Awaited<ReturnType<typeof postApiAppointmentRemindersDashboardGetAppointments>>>
export type PostApiAuthForgotPasswordResult = NonNullable<Awaited<ReturnType<typeof postApiAuthForgotPassword>>>
export type GetApiBillingGetPatientPaymentResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetPatientPayment>>>
export type PostApiBillingCreatePatientPaymentResult = NonNullable<Awaited<ReturnType<typeof postApiBillingCreatePatientPayment>>>
export type PostApiBillingCreatePatientPaymentRefundResult = NonNullable<Awaited<ReturnType<typeof postApiBillingCreatePatientPaymentRefund>>>
export type PostApiBillingDeletePatientPaymentResult = NonNullable<Awaited<ReturnType<typeof postApiBillingDeletePatientPayment>>>
export type PostApiBillingMovePaymentsFromAppointmentsToCreditResult = NonNullable<Awaited<ReturnType<typeof postApiBillingMovePaymentsFromAppointmentsToCredit>>>
export type PostApiBillingSendBillForOnlinePaymentResult = NonNullable<Awaited<ReturnType<typeof postApiBillingSendBillForOnlinePayment>>>
export type PostApiBillingAddOrUpdateEncounterPatientWriteOffsResult = NonNullable<Awaited<ReturnType<typeof postApiBillingAddOrUpdateEncounterPatientWriteOffs>>>
export type PostApiBillingTriggerZeroPatientBalanceResult = NonNullable<Awaited<ReturnType<typeof postApiBillingTriggerZeroPatientBalance>>>
export type PostApiBillingMarkInsuranceWorkflowResolvedResult = NonNullable<Awaited<ReturnType<typeof postApiBillingMarkInsuranceWorkflowResolved>>>
export type PostApiBillingTriggerMarkInsuranceWorkflowResolvedResult = NonNullable<Awaited<ReturnType<typeof postApiBillingTriggerMarkInsuranceWorkflowResolved>>>
export type GetApiBillingExplainInsuranceBalanceEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingExplainInsuranceBalanceEncounterId>>>
export type GetApiBillingGetInsurancePaymentsResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetInsurancePayments>>>
export type PostApiBillingGetEOBsResult = NonNullable<Awaited<ReturnType<typeof postApiBillingGetEOBs>>>
export type GetApiBillingGetEOBResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetEOB>>>
export type PostApiBillingCreateEOBWithInsurancePaymentResult = NonNullable<Awaited<ReturnType<typeof postApiBillingCreateEOBWithInsurancePayment>>>
export type PostApiBillingModifyEOBWithInsurancePaymentResult = NonNullable<Awaited<ReturnType<typeof postApiBillingModifyEOBWithInsurancePayment>>>
export type DeleteApiBillingDeleteEOBResult = NonNullable<Awaited<ReturnType<typeof deleteApiBillingDeleteEOB>>>
export type GetApiBillingGetBillingSummaryDataByEncounterIdEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetBillingSummaryDataByEncounterIdEncounterId>>>
export type GetApiBillingGetBillingSummaryDataByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetBillingSummaryDataByPatientIdPatientId>>>
export type GetApiBillingGetAutoAllocationPreviewPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetAutoAllocationPreviewPatientId>>>
export type PostApiBillingCreateAutoAllocationPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiBillingCreateAutoAllocationPatientId>>>
export type PostApiBillingCreateAllocationResult = NonNullable<Awaited<ReturnType<typeof postApiBillingCreateAllocation>>>
export type GetApiBillingGetEncounterBillingDataResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetEncounterBillingData>>>
export type GetApiBillingGetUnpaidEncounterBillingDataResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetUnpaidEncounterBillingData>>>
export type GetApiBillingGetEOBByPatientPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetEOBByPatientPatientId>>>
export type PostApiBillingGetPatientStatementResult = NonNullable<Awaited<ReturnType<typeof postApiBillingGetPatientStatement>>>
export type GetApiBillingGetDeliveredPatientStatementsPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetDeliveredPatientStatementsPatientId>>>
export type GetApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogId>>>
export type PostApiBillingPrintStatementPdfResult = NonNullable<Awaited<ReturnType<typeof postApiBillingPrintStatementPdf>>>
export type PostApiBillingSendStatementPdfResult = NonNullable<Awaited<ReturnType<typeof postApiBillingSendStatementPdf>>>
export type PostApiBillingPrintFinalLetterPdfResult = NonNullable<Awaited<ReturnType<typeof postApiBillingPrintFinalLetterPdf>>>
export type PostApiBillingSendFinalLetterPdfResult = NonNullable<Awaited<ReturnType<typeof postApiBillingSendFinalLetterPdf>>>
export type PostApiBillingGenerateBulkPatientStatementResult = NonNullable<Awaited<ReturnType<typeof postApiBillingGenerateBulkPatientStatement>>>
export type PostApiBillingGetBulkPatientStatementsResult = NonNullable<Awaited<ReturnType<typeof postApiBillingGetBulkPatientStatements>>>
export type GetApiBillingDownloadBulkPatientStatementResult = NonNullable<Awaited<ReturnType<typeof getApiBillingDownloadBulkPatientStatement>>>
export type GetApiBillingGetBulkPatientStatementOutputResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetBulkPatientStatementOutput>>>
export type GetApiBillingDownloadBulkPatientStatementOutputFileResult = NonNullable<Awaited<ReturnType<typeof getApiBillingDownloadBulkPatientStatementOutputFile>>>
export type GetApiBillingGetBulkPatientStatementOutputFilePreviewUrlResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetBulkPatientStatementOutputFilePreviewUrl>>>
export type PostApiBillingPrintInvoicePdfResult = NonNullable<Awaited<ReturnType<typeof postApiBillingPrintInvoicePdf>>>
export type PostApiBillingSendInvoicePdfResult = NonNullable<Awaited<ReturnType<typeof postApiBillingSendInvoicePdf>>>
export type GetApiBillingGetStatementLastSentInfoResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetStatementLastSentInfo>>>
export type GetApiBillingGetInvoiceSummaryResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetInvoiceSummary>>>
export type PostApiBillingShiftToPatientEobIdClaimIdResult = NonNullable<Awaited<ReturnType<typeof postApiBillingShiftToPatientEobIdClaimId>>>
export type PostApiBillingToggleExcludeServiceLineEobServiceCodePaymentInfoIdExcludeResult = NonNullable<Awaited<ReturnType<typeof postApiBillingToggleExcludeServiceLineEobServiceCodePaymentInfoIdExclude>>>
export type PostApiBillingTriggerSyncByOrgResult = NonNullable<Awaited<ReturnType<typeof postApiBillingTriggerSyncByOrg>>>
export type PostApiBillingTriggerSyncResult = NonNullable<Awaited<ReturnType<typeof postApiBillingTriggerSync>>>
export type PostApiBillingTriggerFinancialViewSyncByOrgResult = NonNullable<Awaited<ReturnType<typeof postApiBillingTriggerFinancialViewSyncByOrg>>>
export type PostApiBillingTriggerFinancialViewSyncResult = NonNullable<Awaited<ReturnType<typeof postApiBillingTriggerFinancialViewSync>>>
export type GetApiBillingGetPaymentMethodsResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetPaymentMethods>>>
export type GetApiBillingGetRefundMethodsResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetRefundMethods>>>
export type GetApiBillingGetEncountersWithPositivePaymentResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetEncountersWithPositivePayment>>>
export type PostApiBillingGetPatientPaymentTransactionsResult = NonNullable<Awaited<ReturnType<typeof postApiBillingGetPatientPaymentTransactions>>>
export type GetApiBillingGetPatientPaymentTransactionsByEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetPatientPaymentTransactionsByEncounterId>>>
export type GetApiBillingGetPatientPaymentRefundsResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetPatientPaymentRefunds>>>
export type PostApiBillingGetEOBUploadUrlResult = NonNullable<Awaited<ReturnType<typeof postApiBillingGetEOBUploadUrl>>>
export type PostApiBillingInitiateEOBDocumentExtractionResult = NonNullable<Awaited<ReturnType<typeof postApiBillingInitiateEOBDocumentExtraction>>>
export type GetApiBillingGetEOBExtractionResultResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetEOBExtractionResult>>>
export type PostApiBillingReconcileExtractedEOBResult = NonNullable<Awaited<ReturnType<typeof postApiBillingReconcileExtractedEOB>>>
export type PostApiBillingSendDailyClaimDeniedTestEmailResult = NonNullable<Awaited<ReturnType<typeof postApiBillingSendDailyClaimDeniedTestEmail>>>
export type PostApiBillingSendDailyDigestEmailsResult = NonNullable<Awaited<ReturnType<typeof postApiBillingSendDailyDigestEmails>>>
export type GetApiBillingCodeSearchResult = NonNullable<Awaited<ReturnType<typeof getApiBillingCodeSearch>>>
export type GetApiBillingCodeGetFavoritesForUserResult = NonNullable<Awaited<ReturnType<typeof getApiBillingCodeGetFavoritesForUser>>>
export type GetApiBillingCodeGetAliasesForUserResult = NonNullable<Awaited<ReturnType<typeof getApiBillingCodeGetAliasesForUser>>>
export type PutApiBillingCodeToggleFavoriteResult = NonNullable<Awaited<ReturnType<typeof putApiBillingCodeToggleFavorite>>>
export type PostApiBillingCodeCreateAliasResult = NonNullable<Awaited<ReturnType<typeof postApiBillingCodeCreateAlias>>>
export type DeleteApiBillingCodeDeleteAliasResult = NonNullable<Awaited<ReturnType<typeof deleteApiBillingCodeDeleteAlias>>>
export type GetApiBlandGetCallDetailsResult = NonNullable<Awaited<ReturnType<typeof getApiBlandGetCallDetails>>>
export type GetApiBlandGetCallRecordingResult = NonNullable<Awaited<ReturnType<typeof getApiBlandGetCallRecording>>>
export type GetApiBlockedTimeSlotGetBlockedTimeSlotResult = NonNullable<Awaited<ReturnType<typeof getApiBlockedTimeSlotGetBlockedTimeSlot>>>
export type PostApiBlockedTimeSlotAddOrUpdateResult = NonNullable<Awaited<ReturnType<typeof postApiBlockedTimeSlotAddOrUpdate>>>
export type DeleteApiBlockedTimeSlotDeleteResult = NonNullable<Awaited<ReturnType<typeof deleteApiBlockedTimeSlotDelete>>>
export type PostApiBlockedTimeSlotDeletePartiallyResult = NonNullable<Awaited<ReturnType<typeof postApiBlockedTimeSlotDeletePartially>>>
export type PostApiCCMAgentInitiateCallResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgentInitiateCall>>>
export type PostApiCcmMonthlyDashboardGetPatientsResult = NonNullable<Awaited<ReturnType<typeof postApiCcmMonthlyDashboardGetPatients>>>
export type PostApiCHCheckEligibilityResult = NonNullable<Awaited<ReturnType<typeof postApiCHCheckEligibility>>>
export type GetApiCHSearchInsuranceResult = NonNullable<Awaited<ReturnType<typeof getApiCHSearchInsurance>>>
export type GetApiCHGetPaginatedInsurancesResult = NonNullable<Awaited<ReturnType<typeof getApiCHGetPaginatedInsurances>>>
export type GetApiCHSearchInsuranceByOrgResult = NonNullable<Awaited<ReturnType<typeof getApiCHSearchInsuranceByOrg>>>
export type GetApiCHGetPayerEntryByIdResult = NonNullable<Awaited<ReturnType<typeof getApiCHGetPayerEntryById>>>
export type GetApiCHGetFavoriteInsurancesResult = NonNullable<Awaited<ReturnType<typeof getApiCHGetFavoriteInsurances>>>
export type GetApiCHGetFavoriteInsurancesByOrgResult = NonNullable<Awaited<ReturnType<typeof getApiCHGetFavoriteInsurancesByOrg>>>
export type PostApiCHClaimAcknowledgementHandlerResult = NonNullable<Awaited<ReturnType<typeof postApiCHClaimAcknowledgementHandler>>>
export type PostApiCHElectronicRemittanceAdviceHandlerResult = NonNullable<Awaited<ReturnType<typeof postApiCHElectronicRemittanceAdviceHandler>>>
export type PostApiCHEraPDFHandlerResult = NonNullable<Awaited<ReturnType<typeof postApiCHEraPDFHandler>>>
export type GetApiCHTriggerRawEraProcessorResult = NonNullable<Awaited<ReturnType<typeof getApiCHTriggerRawEraProcessor>>>
export type PostApiCHTriggerRawClaimAckProcessorResult = NonNullable<Awaited<ReturnType<typeof postApiCHTriggerRawClaimAckProcessor>>>
export type GetApiChargeSearchChargeMasterResult = NonNullable<Awaited<ReturnType<typeof getApiChargeSearchChargeMaster>>>
export type GetApiChargeSearchCustomChargeMasterResult = NonNullable<Awaited<ReturnType<typeof getApiChargeSearchCustomChargeMaster>>>
export type PostApiChargeCreateChargePolicyResult = NonNullable<Awaited<ReturnType<typeof postApiChargeCreateChargePolicy>>>
export type PostApiChargeCreateCustomCodeChargePolicyResult = NonNullable<Awaited<ReturnType<typeof postApiChargeCreateCustomCodeChargePolicy>>>
export type PostApiChargeModifyChargePolicyResult = NonNullable<Awaited<ReturnType<typeof postApiChargeModifyChargePolicy>>>
export type PostApiChargeModifyCustomCodeChargePolicyResult = NonNullable<Awaited<ReturnType<typeof postApiChargeModifyCustomCodeChargePolicy>>>
export type DeleteApiChargeDeleteChargePolicyResult = NonNullable<Awaited<ReturnType<typeof deleteApiChargeDeleteChargePolicy>>>
export type DeleteApiChargeDeleteCustomCodeChargePolicyResult = NonNullable<Awaited<ReturnType<typeof deleteApiChargeDeleteCustomCodeChargePolicy>>>
export type PostApiChargeGetChargesResult = NonNullable<Awaited<ReturnType<typeof postApiChargeGetCharges>>>
export type PostApiChargeGetClaimsResult = NonNullable<Awaited<ReturnType<typeof postApiChargeGetClaims>>>
export type PostApiChargeGetChargeDetailsByEncounterIdsResult = NonNullable<Awaited<ReturnType<typeof postApiChargeGetChargeDetailsByEncounterIds>>>
export type PostApiChargeGetClaimDetailsByClaimIdsResult = NonNullable<Awaited<ReturnType<typeof postApiChargeGetClaimDetailsByClaimIds>>>
export type PostApiChargeGetClaimSummaryByClaimIdsResult = NonNullable<Awaited<ReturnType<typeof postApiChargeGetClaimSummaryByClaimIds>>>
export type GetApiClaimSearchExternalProviderResult = NonNullable<Awaited<ReturnType<typeof getApiClaimSearchExternalProvider>>>
export type GetApiClaimSearchAdjustmentReasonCodeResult = NonNullable<Awaited<ReturnType<typeof getApiClaimSearchAdjustmentReasonCode>>>
export type GetApiClaimSearchRemittanceAdviceRemarkCodesResult = NonNullable<Awaited<ReturnType<typeof getApiClaimSearchRemittanceAdviceRemarkCodes>>>
export type GetApiClaimSearchNdcCodesResult = NonNullable<Awaited<ReturnType<typeof getApiClaimSearchNdcCodes>>>
export type PostApiClaimCreateClaimEncounterIdResult = NonNullable<Awaited<ReturnType<typeof postApiClaimCreateClaimEncounterId>>>
export type GetApiClaimGetClaimByIdClaimIdResult = NonNullable<Awaited<ReturnType<typeof getApiClaimGetClaimByIdClaimId>>>
export type PostApiClaimGetClaimLogByIdClaimIdResult = NonNullable<Awaited<ReturnType<typeof postApiClaimGetClaimLogByIdClaimId>>>
export type GetApiClaimGetSummaryForEncounterIdEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiClaimGetSummaryForEncounterIdEncounterId>>>
export type GetApiClaimGetReferringProviderSuggestionsClaimIdResult = NonNullable<Awaited<ReturnType<typeof getApiClaimGetReferringProviderSuggestionsClaimId>>>
export type GetApiClaimGetEOBSummariesByEncounterIdEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiClaimGetEOBSummariesByEncounterIdEncounterId>>>
export type DeleteApiClaimDeleteClaimByIdClaimIdResult = NonNullable<Awaited<ReturnType<typeof deleteApiClaimDeleteClaimByIdClaimId>>>
export type PostApiClaimSaveClaimResult = NonNullable<Awaited<ReturnType<typeof postApiClaimSaveClaim>>>
export type PostApiClaimTransmitClaimToClearinghouseClaimIdResult = NonNullable<Awaited<ReturnType<typeof postApiClaimTransmitClaimToClearinghouseClaimId>>>
export type PostApiClaimMarkClaimStatusResult = NonNullable<Awaited<ReturnType<typeof postApiClaimMarkClaimStatus>>>
export type PostApiClaimMarkClaimStatusBulkResult = NonNullable<Awaited<ReturnType<typeof postApiClaimMarkClaimStatusBulk>>>
export type PostApiClaimSetClaimNotesResult = NonNullable<Awaited<ReturnType<typeof postApiClaimSetClaimNotes>>>
export type PostApiClaimSetClaimInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiClaimSetClaimInsurance>>>
export type PostApiClaimPrintClaimResult = NonNullable<Awaited<ReturnType<typeof postApiClaimPrintClaim>>>
export type GetApiClaimGetSplitByEncounterIdEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiClaimGetSplitByEncounterIdEncounterId>>>
export type PostApiClaimSaveSplitResult = NonNullable<Awaited<ReturnType<typeof postApiClaimSaveSplit>>>
export type PostApiClaimCheckClaimStatusClaimIdResult = NonNullable<Awaited<ReturnType<typeof postApiClaimCheckClaimStatusClaimId>>>
export type PostApiClaimCreateSecondaryClaimResult = NonNullable<Awaited<ReturnType<typeof postApiClaimCreateSecondaryClaim>>>
export type GetApiClaimGetAccidentDatesByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiClaimGetAccidentDatesByPatientIdPatientId>>>
export type PostApiClaimGenerateBulkPaperClaimsResult = NonNullable<Awaited<ReturnType<typeof postApiClaimGenerateBulkPaperClaims>>>
export type PostApiClaimGetBulkPaperClaimsResult = NonNullable<Awaited<ReturnType<typeof postApiClaimGetBulkPaperClaims>>>
export type GetApiClaimDownloadBulkPaperClaimsResult = NonNullable<Awaited<ReturnType<typeof getApiClaimDownloadBulkPaperClaims>>>
export type GetApiClaimGetBillingProvidersResult = NonNullable<Awaited<ReturnType<typeof getApiClaimGetBillingProviders>>>
export type PostApiClaimResolveBillingProviderIdFromRulesResult = NonNullable<Awaited<ReturnType<typeof postApiClaimResolveBillingProviderIdFromRules>>>
export type PostApiClaimTriggerSetClaimNotesResult = NonNullable<Awaited<ReturnType<typeof postApiClaimTriggerSetClaimNotes>>>
export type PostApiClaimEnqueueReadyElectronicClaimsForBulkTransmissionResult = NonNullable<Awaited<ReturnType<typeof postApiClaimEnqueueReadyElectronicClaimsForBulkTransmission>>>
export type PostApiCommunicationSendPatientInfoMessageResult = NonNullable<Awaited<ReturnType<typeof postApiCommunicationSendPatientInfoMessage>>>
export type GetApiCommunicationGetPatientInfoCommuniqueByTokenTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetPatientInfoCommuniqueByTokenToken>>>
export type PostApiCommunicationSendReminderCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiCommunicationSendReminderCommunique>>>
export type GetApiCommunicationGetAppointmentCommuniqueByTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetAppointmentCommuniqueByToken>>>
export type PostApiCommunicationEnsureFormWorkflowForAppointmentCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiCommunicationEnsureFormWorkflowForAppointmentCommunique>>>
export type PostApiCommunicationGetOrCreateCommuniqueByPatientInfoAndUpdateAppointmentResult = NonNullable<Awaited<ReturnType<typeof postApiCommunicationGetOrCreateCommuniqueByPatientInfoAndUpdateAppointment>>>
export type GetApiCommunicationGetIntakeFlagsByTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetIntakeFlagsByToken>>>
export type GetApiCommunicationGetProceduralConsentFormsInfoByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetProceduralConsentFormsInfoByPatientIdPatientId>>>
export type GetApiCommunicationGetConsentFormCommuniqueByTokenTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetConsentFormCommuniqueByTokenToken>>>
export type GetApiCommunicationGetPhoneNumberTagResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetPhoneNumberTag>>>
export type GetApiCustomServiceCodeSearchResult = NonNullable<Awaited<ReturnType<typeof getApiCustomServiceCodeSearch>>>
export type PostApiCustomServiceCodeToggleFavoriteResult = NonNullable<Awaited<ReturnType<typeof postApiCustomServiceCodeToggleFavorite>>>
export type PostApiEFaxSendFaxResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxSendFax>>>
export type PostApiEFaxResendFaxResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxResendFax>>>
export type PostApiEFaxGetFaxesResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxGetFaxes>>>
export type PostApiEFaxSetInboundFaxInternalStatusResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxSetInboundFaxInternalStatus>>>
export type PostApiEFaxUploadInboundFileToPatientChartResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxUploadInboundFileToPatientChart>>>
export type PostApiEFaxAddFaxContactResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxAddFaxContact>>>
export type GetApiEFaxGetFaxContactsResult = NonNullable<Awaited<ReturnType<typeof getApiEFaxGetFaxContacts>>>
export type PostApiEFaxUpdateFaxContactResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxUpdateFaxContact>>>
export type DeleteApiEFaxDeleteFaxContactResult = NonNullable<Awaited<ReturnType<typeof deleteApiEFaxDeleteFaxContact>>>
export type GetApiEFaxDownloadFaxResult = NonNullable<Awaited<ReturnType<typeof getApiEFaxDownloadFax>>>
export type PostApiEFaxOutboundFaxEventHandlerResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxOutboundFaxEventHandler>>>
export type PostApiEFaxInboundFaxEventHandlerResult = NonNullable<Awaited<ReturnType<typeof postApiEFaxInboundFaxEventHandler>>>
export type PostApiEligibilityBatchStartBatchResult = NonNullable<Awaited<ReturnType<typeof postApiEligibilityBatchStartBatch>>>
export type PostApiEligibilityBatchPollBatchResult = NonNullable<Awaited<ReturnType<typeof postApiEligibilityBatchPollBatch>>>
export type GetApiEncounterGetEncounterSummariesByDateResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetEncounterSummariesByDate>>>
export type GetApiEncounterGetEncounterDetailsByIdResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetEncounterDetailsById>>>
export type GetApiEncounterGetAppointmentsByDateResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetAppointmentsByDate>>>
export type GetApiEncounterGetCalendarEventsByDateAndProviderResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetCalendarEventsByDateAndProvider>>>
export type GetApiEncounterGetAppointmentsByDateRangeResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetAppointmentsByDateRange>>>
export type GetApiEncounterGetCalendarEventsByDateRangeResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetCalendarEventsByDateRange>>>
export type GetApiEncounterGetAppointmentDetailsByAppointmentIdAppointmentIdResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetAppointmentDetailsByAppointmentIdAppointmentId>>>
export type GetApiEncounterGetVitalsEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetVitalsEncounterId>>>
export type PostApiEncounterCreateAppointmentResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterCreateAppointment>>>
export type PostApiEncounterSaveVitalsResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterSaveVitals>>>
export type DeleteApiEncounterDeleteAppointmentResult = NonNullable<Awaited<ReturnType<typeof deleteApiEncounterDeleteAppointment>>>
export type GetApiEncounterGetDailyAppointmentBreakdownByDateRangeResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetDailyAppointmentBreakdownByDateRange>>>
export type GetApiEncounterGetAppointmentClaimsSummaryResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetAppointmentClaimsSummary>>>
export type GetApiEncounterGetReferringProviderSuggestionsResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetReferringProviderSuggestions>>>
export type PostApiEncounterSetAppointmentConfirmationResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterSetAppointmentConfirmation>>>
export type PatchApiEncounterModifyAppointmentDetailsResult = NonNullable<Awaited<ReturnType<typeof patchApiEncounterModifyAppointmentDetails>>>
export type PostApiEncounterModifyAppointmentStatusResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterModifyAppointmentStatus>>>
export type PostApiEncounterModifyAppointmentPaymentTypeResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterModifyAppointmentPaymentType>>>
export type PostApiEncounterPrintEncounterScheduleResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterPrintEncounterSchedule>>>
export type PostApiEncounterGetEncounterPatientWriteOffsByEncounterIdResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterGetEncounterPatientWriteOffsByEncounterId>>>
export type GetApiEncounterGetTodaysEncountersWithCustomCodesByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetTodaysEncountersWithCustomCodesByPatientId>>>
export type PostApiEncounterCreatePurchaseResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterCreatePurchase>>>
export type GetApiERxUserNotificationCountsResult = NonNullable<Awaited<ReturnType<typeof getApiERxUserNotificationCounts>>>
export type GetApiERxGetAvailableClinicsResult = NonNullable<Awaited<ReturnType<typeof getApiERxGetAvailableClinics>>>
export type GetApiERxUserWebpageURLResult = NonNullable<Awaited<ReturnType<typeof getApiERxUserWebpageURL>>>
export type GetApiERxPatientWebpageURLResult = NonNullable<Awaited<ReturnType<typeof getApiERxPatientWebpageURL>>>
export type GetApiERxMedicationSearchResult = NonNullable<Awaited<ReturnType<typeof getApiERxMedicationSearch>>>
export type GetApiERxDrugAllergySearchResult = NonNullable<Awaited<ReturnType<typeof getApiERxDrugAllergySearch>>>
export type GetApiERxPharmacySearchResult = NonNullable<Awaited<ReturnType<typeof getApiERxPharmacySearch>>>
export type PostApiFormCreateFormResult = NonNullable<Awaited<ReturnType<typeof postApiFormCreateForm>>>
export type PostApiFormCopyFormResult = NonNullable<Awaited<ReturnType<typeof postApiFormCopyForm>>>
export type PostApiFormUpdateFormResult = NonNullable<Awaited<ReturnType<typeof postApiFormUpdateForm>>>
export type GetApiFormGetFormsResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetForms>>>
export type DeleteApiFormDeleteFormResult = NonNullable<Awaited<ReturnType<typeof deleteApiFormDeleteForm>>>
export type GetApiFormGetFormBuilderFormIdResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetFormBuilderFormId>>>
export type GetApiFormGetFormPreviewPdfResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetFormPreviewPdf>>>
export type GetApiFormGetFormPreviewForPatientGetFormPreviewForPatientFormIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetFormPreviewForPatientGetFormPreviewForPatientFormIdPatientId>>>
export type PostApiFormSaveFormFieldsResult = NonNullable<Awaited<ReturnType<typeof postApiFormSaveFormFields>>>
export type PostApiFormReplaceFormPdfResult = NonNullable<Awaited<ReturnType<typeof postApiFormReplaceFormPdf>>>
export type GetApiFormGetFormCategoriesResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetFormCategories>>>
export type GetApiFormGetFormWorkflowInitiationCategoriesResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetFormWorkflowInitiationCategories>>>
export type GetApiFormGetCategoryRulesResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetCategoryRules>>>
export type GetApiFormGetFormBuilderOptionsResult = NonNullable<Awaited<ReturnType<typeof getApiFormGetFormBuilderOptions>>>
export type PostApiFormWorkflowGetInitiationRequirementsResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowGetInitiationRequirements>>>
export type PostApiFormWorkflowInitiateResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowInitiate>>>
export type GetApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssigneeResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssignee>>>
export type PostApiFormWorkflowSaveClinicianFieldValuesResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowSaveClinicianFieldValues>>>
export type PostApiFormWorkflowCompleteClinicianStepResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowCompleteClinicianStep>>>
export type PostApiFormWorkflowCompletePatientStepResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowCompletePatientStep>>>
export type PostApiFormWorkflowCancelResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowCancel>>>
export type GetApiFormWorkflowGetFormStatusByPatientPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetFormStatusByPatientPatientId>>>
export type GetApiFormWorkflowGetWorkflowPdfsFormWorkflowIdResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetWorkflowPdfsFormWorkflowId>>>
export type PostApiFormWorkflowRequestFormWorkflowListResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowRequestFormWorkflowList>>>
export type GetApiFormWorkflowGetFormWorkflowByIdFormWorkflowIdResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetFormWorkflowByIdFormWorkflowId>>>
export type PostApiMipsSubmissionQueueMipsSubmissionResult = NonNullable<Awaited<ReturnType<typeof postApiMipsSubmissionQueueMipsSubmission>>>
export type GetApiMipsSubmissionGetMipsSubmissionStatusBatchIdResult = NonNullable<Awaited<ReturnType<typeof getApiMipsSubmissionGetMipsSubmissionStatusBatchId>>>
export type PostApiMonkeyPatchRequeueInvoicePdfGenerationResult = NonNullable<Awaited<ReturnType<typeof postApiMonkeyPatchRequeueInvoicePdfGeneration>>>
export type GetApiMonkeyPatchWaitForOneMinuteResult = NonNullable<Awaited<ReturnType<typeof getApiMonkeyPatchWaitForOneMinute>>>
export type GetApiMultimediaGetPatientMediaCategoryDetailsResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetPatientMediaCategoryDetails>>>
export type PostApiMultimediaDeleteMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaDeleteMultiMedia>>>
export type PostApiMultimediaRequestMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaRequestMultiMedia>>>
export type PostApiMultimediaPostPatientMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaPostPatientMultiMedia>>>
export type PostApiMultimediaBulkUploadPatientMultimediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaBulkUploadPatientMultimedia>>>
export type PostApiMultimediaBulkUploadUserMultimediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaBulkUploadUserMultimedia>>>
export type PutApiMultimediaUpdatePatientMultiMediaResult = NonNullable<Awaited<ReturnType<typeof putApiMultimediaUpdatePatientMultiMedia>>>
export type PostApiMultimediaPostBillingMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaPostBillingMultiMedia>>>
export type PostApiMultimediaPostOrgMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaPostOrgMultiMedia>>>
export type GetApiMultimediaGetOrgMultimediaByTypeOrgIdMultimediaTypeResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetOrgMultimediaByTypeOrgIdMultimediaType>>>
export type GetApiMultimediaGetOrgBannerPictureByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetOrgBannerPictureByPatientIdPatientId>>>
export type GetApiMultimediaGetBillingMultiMediaByIdBillingMultiMediaIdMultimediaTypeResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetBillingMultiMediaByIdBillingMultiMediaIdMultimediaType>>>
export type GetApiMultimediaGetBillingMultiMediaByIdForPatientBillingMultiMediaIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetBillingMultiMediaByIdForPatientBillingMultiMediaId>>>
export type GetApiMultimediaGetPatientMultiMediaByIdPatientMultiMediaIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetPatientMultiMediaByIdPatientMultiMediaId>>>
export type PostApiMultimediaGetPatientMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaGetPatientMultiMedia>>>
export type GetApiMultimediaSearchPatientMultimediaPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaSearchPatientMultimediaPatientId>>>
export type GetApiMultimediaGetPatientMultimediaByTypePatientIdMultimediaTypeResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetPatientMultimediaByTypePatientIdMultimediaType>>>
export type GetApiMultimediaGetFaxMultimediaByFaxIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetFaxMultimediaByFaxId>>>
export type PostApiMultimediaSignPatientMultimediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaSignPatientMultimedia>>>
export type PostApiMultimediaMigratePatientMutlimediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaMigratePatientMutlimedia>>>
export type GetApiOrganizationGetOrgByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiOrganizationGetOrgByPatientId>>>
export type PostApiOrganizationGetOrgByIpadBaseIntakeUrlResult = NonNullable<Awaited<ReturnType<typeof postApiOrganizationGetOrgByIpadBaseIntakeUrl>>>
export type GetApiOrgConfigurationGetServiceFacilitiesResult = NonNullable<Awaited<ReturnType<typeof getApiOrgConfigurationGetServiceFacilities>>>
export type PostApiOrgConfigurationAddServiceFacilityResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationAddServiceFacility>>>
export type PostApiOrgConfigurationUpdateServiceFacilityResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationUpdateServiceFacility>>>
export type DeleteApiOrgConfigurationDeleteServiceFacilityResult = NonNullable<Awaited<ReturnType<typeof deleteApiOrgConfigurationDeleteServiceFacility>>>
export type GetApiOrgConfigurationGetRenderingProvidersResult = NonNullable<Awaited<ReturnType<typeof getApiOrgConfigurationGetRenderingProviders>>>
export type PostApiOrgConfigurationUpdateRenderingProviderResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationUpdateRenderingProvider>>>
export type DeleteApiOrgConfigurationDeleteRenderingProviderResult = NonNullable<Awaited<ReturnType<typeof deleteApiOrgConfigurationDeleteRenderingProvider>>>
export type GetApiOrgConfigurationGetBillingProvidersByTypeResult = NonNullable<Awaited<ReturnType<typeof getApiOrgConfigurationGetBillingProvidersByType>>>
export type PostApiOrgConfigurationAddOrganizationBillingProviderResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationAddOrganizationBillingProvider>>>
export type PostApiOrgConfigurationAddIndividualBillingProviderResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationAddIndividualBillingProvider>>>
export type PostApiOrgConfigurationUpdateOrganizationBillingProviderResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationUpdateOrganizationBillingProvider>>>
export type PostApiOrgConfigurationUpdateIndividualBillingProviderResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationUpdateIndividualBillingProvider>>>
export type DeleteApiOrgConfigurationDeleteBillingProviderResult = NonNullable<Awaited<ReturnType<typeof deleteApiOrgConfigurationDeleteBillingProvider>>>
export type GetApiOrgConfigurationGetBillingProviderRulesResult = NonNullable<Awaited<ReturnType<typeof getApiOrgConfigurationGetBillingProviderRules>>>
export type PostApiOrgConfigurationAddBillingProviderRuleResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationAddBillingProviderRule>>>
export type PostApiOrgConfigurationUpdateBillingProviderRuleResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationUpdateBillingProviderRule>>>
export type DeleteApiOrgConfigurationDeleteBillingProviderRuleResult = NonNullable<Awaited<ReturnType<typeof deleteApiOrgConfigurationDeleteBillingProviderRule>>>
export type PostApiOrgConfigurationReorderBillingProviderRulesResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationReorderBillingProviderRules>>>
export type GetApiOrgConfigurationGetBillingProviderPtansResult = NonNullable<Awaited<ReturnType<typeof getApiOrgConfigurationGetBillingProviderPtans>>>
export type PostApiOrgConfigurationAddBillingProviderPtanResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationAddBillingProviderPtan>>>
export type PostApiOrgConfigurationUpdateBillingProviderPtanResult = NonNullable<Awaited<ReturnType<typeof postApiOrgConfigurationUpdateBillingProviderPtan>>>
export type DeleteApiOrgConfigurationDeleteBillingProviderPtanResult = NonNullable<Awaited<ReturnType<typeof deleteApiOrgConfigurationDeleteBillingProviderPtan>>>
export type PostApiPatientCreateNewPatientResult = NonNullable<Awaited<ReturnType<typeof postApiPatientCreateNewPatient>>>
export type GetApiPatientSearchPatientsResult = NonNullable<Awaited<ReturnType<typeof getApiPatientSearchPatients>>>
export type GetApiPatientSearchPatientsForFilterResult = NonNullable<Awaited<ReturnType<typeof getApiPatientSearchPatientsForFilter>>>
export type GetApiPatientGetPatientByIdIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientByIdId>>>
export type GetApiPatientGetPCCStatusByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPCCStatusByPatientIdPatientId>>>
export type GetApiPatientGetPCCItemsByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPCCItemsByPatientIdPatientId>>>
export type GetApiPatientGetPatientByIdWithPharmacyMedicationAndAllergyIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientByIdWithPharmacyMedicationAndAllergyId>>>
export type GetApiPatientGetCountsSummaryPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetCountsSummaryPatientId>>>
export type GetApiPatientGetPatientMedicalBackgroundIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientMedicalBackgroundId>>>
export type GetApiPatientGetPatientInsurancesByIdIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientInsurancesByIdId>>>
export type GetApiPatientGetPatientSummaryPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientSummaryPatientId>>>
export type PostApiPatientAddPatientMedicalHistoryResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddPatientMedicalHistory>>>
export type PostApiPatientAddPatientPharmacyAllergyAndMedicationResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddPatientPharmacyAllergyAndMedication>>>
export type PatchApiPatientUpdatePatientResult = NonNullable<Awaited<ReturnType<typeof patchApiPatientUpdatePatient>>>
export type PostApiPatientAddInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddInsurance>>>
export type PutApiPatientUpdateInsuranceResult = NonNullable<Awaited<ReturnType<typeof putApiPatientUpdateInsurance>>>
export type DeleteApiPatientDeleteInsuranceInsuranceIdResult = NonNullable<Awaited<ReturnType<typeof deleteApiPatientDeleteInsuranceInsuranceId>>>
export type GetApiPatientGetUnassociatedInsuranceCardsPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetUnassociatedInsuranceCardsPatientId>>>
export type GetApiPatientGetInsuranceAttachmentsInsuranceIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetInsuranceAttachmentsInsuranceId>>>
export type PostApiPatientUploadAndAssociateInsuranceCardWithInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientUploadAndAssociateInsuranceCardWithInsurance>>>
export type PostApiPatientAssociateInsuranceCardWithInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAssociateInsuranceCardWithInsurance>>>
export type DeleteApiPatientDisassociateInsuranceCardInsuranceAttachmentIdResult = NonNullable<Awaited<ReturnType<typeof deleteApiPatientDisassociateInsuranceCardInsuranceAttachmentId>>>
export type PostApiPatientSyncInsuranceAttachmentsResult = NonNullable<Awaited<ReturnType<typeof postApiPatientSyncInsuranceAttachments>>>
export type PostApiPatientAddPatientInsurancesResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddPatientInsurances>>>
export type PostApiPatientAddReasonForVisitResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddReasonForVisit>>>
export type GetApiPatientGetSymptomsFromImmediatePastVisitPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetSymptomsFromImmediatePastVisitPatientId>>>
export type GetApiPatientGetAgreementFormsForPatientPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetAgreementFormsForPatientPatientId>>>
export type PostApiPatientSubmitDosespotConsentFormResult = NonNullable<Awaited<ReturnType<typeof postApiPatientSubmitDosespotConsentForm>>>
export type PostApiPatientVerifyPatientDOBByIdResult = NonNullable<Awaited<ReturnType<typeof postApiPatientVerifyPatientDOBById>>>
export type GetApiPatientGetPatientLedgerPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientLedgerPatientId>>>
export type GetApiPatientPrintPatientFaceSheetResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPrintPatientFaceSheet>>>
export type GetApiPatientGetMoveToCreditLogsResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetMoveToCreditLogs>>>
export type GetApiPatientGetVitalsHistoryPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetVitalsHistoryPatientId>>>
export type PostApiPatientMigratePatientResult = NonNullable<Awaited<ReturnType<typeof postApiPatientMigratePatient>>>
export type PostApiPatientRecordChartAccessPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiPatientRecordChartAccessPatientId>>>
export type GetApiPatientRecentSearchesResult = NonNullable<Awaited<ReturnType<typeof getApiPatientRecentSearches>>>
export type DeleteApiPatientRecentSearchesResult = NonNullable<Awaited<ReturnType<typeof deleteApiPatientRecentSearches>>>
export type GetApiPatientAuthorizationGetByPatientPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientAuthorizationGetByPatientPatientId>>>
export type GetApiPatientAuthorizationGetByInsuranceInsuranceIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientAuthorizationGetByInsuranceInsuranceId>>>
export type GetApiPatientAuthorizationGetByIdPatientAuthorizationIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientAuthorizationGetByIdPatientAuthorizationId>>>
export type PostApiPatientAuthorizationSaveResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAuthorizationSave>>>
export type DeleteApiPatientAuthorizationDeletePatientAuthorizationIdResult = NonNullable<Awaited<ReturnType<typeof deleteApiPatientAuthorizationDeletePatientAuthorizationId>>>
export type GetApiPCCActivationGetSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiPCCActivationGetSettings>>>
export type PostApiPCCActivationSetSettingsResult = NonNullable<Awaited<ReturnType<typeof postApiPCCActivationSetSettings>>>
export type PostApiPCCActivationDeactivateResult = NonNullable<Awaited<ReturnType<typeof postApiPCCActivationDeactivate>>>
export type PostApiPCCCommuniqueSendByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiPCCCommuniqueSendByPatientId>>>
export type PostApiPCCCommuniqueSendModMedByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiPCCCommuniqueSendModMedByPatientId>>>
export type PostApiPCCConsentTriggerPCCEligibilityViewSyncByOrgResult = NonNullable<Awaited<ReturnType<typeof postApiPCCConsentTriggerPCCEligibilityViewSyncByOrg>>>
export type GetApiPCCConsentGetByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPCCConsentGetByPatientId>>>
export type PutApiPCCConsentUpdateResult = NonNullable<Awaited<ReturnType<typeof putApiPCCConsentUpdate>>>
export type PostApiPCCConsentOptInToCCMResult = NonNullable<Awaited<ReturnType<typeof postApiPCCConsentOptInToCCM>>>
export type PostApiPCCConsentEnrollPatientResult = NonNullable<Awaited<ReturnType<typeof postApiPCCConsentEnrollPatient>>>
export type GetApiPCCConsentGetEnabledProgramsResult = NonNullable<Awaited<ReturnType<typeof getApiPCCConsentGetEnabledPrograms>>>
export type PostApiPCCConsentSendPCCConsentResult = NonNullable<Awaited<ReturnType<typeof postApiPCCConsentSendPCCConsent>>>
export type PostApiPCCConsentTriggerDefaultConsentSyncByOrgResult = NonNullable<Awaited<ReturnType<typeof postApiPCCConsentTriggerDefaultConsentSyncByOrg>>>
export type PostApiPCCDashboardGetPCCPatientDetailsResult = NonNullable<Awaited<ReturnType<typeof postApiPCCDashboardGetPCCPatientDetails>>>
export type PostApiPCCDashboardGetPatientDetailsByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiPCCDashboardGetPatientDetailsByPatientId>>>
export type PostApiPCCDashboardGetCcmCallsByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiPCCDashboardGetCcmCallsByPatientId>>>
export type GetApiPopulateSupportGetAllOrganizationsResult = NonNullable<Awaited<ReturnType<typeof getApiPopulateSupportGetAllOrganizations>>>
export type GetApiPopulateSupportGetUsersByOrganizationResult = NonNullable<Awaited<ReturnType<typeof getApiPopulateSupportGetUsersByOrganization>>>
export type PostApiPopulateSupportImpersonateResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportImpersonate>>>
export type PostApiPopulateSupportMigratePatientNamesResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportMigratePatientNames>>>
export type PostApiPopulateSupportEnrollPatientsInPCCProgramsResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportEnrollPatientsInPCCPrograms>>>
export type PostApiPopulateSupportTriggerCommunicationMethodAlertSyncResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportTriggerCommunicationMethodAlertSync>>>
export type PostApiPopulateSupportTriggerSuperDialSubmissionResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportTriggerSuperDialSubmission>>>
export type PostApiPopulateSupportTriggerSuperDialSubmissionForClaimsResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportTriggerSuperDialSubmissionForClaims>>>
export type PostApiPopulateSupportRetryFailedSuperDialWebhookResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportRetryFailedSuperDialWebhook>>>
export type PostApiPopulateSupportSyncCompletedSuperDialSummaryResult = NonNullable<Awaited<ReturnType<typeof postApiPopulateSupportSyncCompletedSuperDialSummary>>>
export type GetApiProviderAvailabilityGetProviderAvailabilityResult = NonNullable<Awaited<ReturnType<typeof getApiProviderAvailabilityGetProviderAvailability>>>
export type PostApiProviderAvailabilityAddOrUpdateResult = NonNullable<Awaited<ReturnType<typeof postApiProviderAvailabilityAddOrUpdate>>>
export type DeleteApiProviderAvailabilityDeleteResult = NonNullable<Awaited<ReturnType<typeof deleteApiProviderAvailabilityDelete>>>
export type PostApiProviderAvailabilityDeletePartiallyResult = NonNullable<Awaited<ReturnType<typeof postApiProviderAvailabilityDeletePartially>>>
export type GetApiReportGetReportSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiReportGetReportSettings>>>
export type PostApiReportTriggerReportResult = NonNullable<Awaited<ReturnType<typeof postApiReportTriggerReport>>>
export type PostApiReportGetReportsResult = NonNullable<Awaited<ReturnType<typeof postApiReportGetReports>>>
export type GetApiReportDownloadReportResult = NonNullable<Awaited<ReturnType<typeof getApiReportDownloadReport>>>
export type GetApiReportGetReportOutputResult = NonNullable<Awaited<ReturnType<typeof getApiReportGetReportOutput>>>
export type GetApiReportDownloadReportOutputFileResult = NonNullable<Awaited<ReturnType<typeof getApiReportDownloadReportOutputFile>>>
export type GetApiReportGetReportOutputFilePreviewUrlResult = NonNullable<Awaited<ReturnType<typeof getApiReportGetReportOutputFilePreviewUrl>>>
export type PostApiReportDeleteReportResult = NonNullable<Awaited<ReturnType<typeof postApiReportDeleteReport>>>
export type PostApiReportTestWeeklyARReportResult = NonNullable<Awaited<ReturnType<typeof postApiReportTestWeeklyARReport>>>
export type PostApiReportTestWeeklyPCCReportResult = NonNullable<Awaited<ReturnType<typeof postApiReportTestWeeklyPCCReport>>>
export type PostApiReportTestMonthlyPCCCollectionsARReportResult = NonNullable<Awaited<ReturnType<typeof postApiReportTestMonthlyPCCCollectionsARReport>>>
export type GetApiRoomGetRoomStatusResult = NonNullable<Awaited<ReturnType<typeof getApiRoomGetRoomStatus>>>
export type GetApiRTMGetStatusByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiRTMGetStatusByPatientId>>>
export type PostApiRTMMonitoringAddQualificationByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiRTMMonitoringAddQualificationByPatientId>>>
export type PostApiRTMMonitoringGetPatientsResult = NonNullable<Awaited<ReturnType<typeof postApiRTMMonitoringGetPatients>>>
export type GetApiRTMMonitoringGetEncountersForRTMRecommendationResult = NonNullable<Awaited<ReturnType<typeof getApiRTMMonitoringGetEncountersForRTMRecommendation>>>
export type GetApiRTMMonitoringGetPatientTrendResult = NonNullable<Awaited<ReturnType<typeof getApiRTMMonitoringGetPatientTrend>>>
export type PostApiRTMMonitoringMarkPatientReviewedResult = NonNullable<Awaited<ReturnType<typeof postApiRTMMonitoringMarkPatientReviewed>>>
export type PostApiRTMMonitoringSendCheckInSurveyByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiRTMMonitoringSendCheckInSurveyByPatientId>>>
export type PostApiRTMMonitoringSendEnrollmentInvitationByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiRTMMonitoringSendEnrollmentInvitationByPatientId>>>
export type GetApiRTMMonitoringGetProviderThresholdsResult = NonNullable<Awaited<ReturnType<typeof getApiRTMMonitoringGetProviderThresholds>>>
export type PostApiRTMMonitoringAddOrUpdateProviderThresholdsResult = NonNullable<Awaited<ReturnType<typeof postApiRTMMonitoringAddOrUpdateProviderThresholds>>>
export type DeleteApiRTMMonitoringDeleteProviderThresholdsResult = NonNullable<Awaited<ReturnType<typeof deleteApiRTMMonitoringDeleteProviderThresholds>>>
export type PostApiScheduledJobRunBatchSyncMedicalHistoryForOrgOrgIdResult = NonNullable<Awaited<ReturnType<typeof postApiScheduledJobRunBatchSyncMedicalHistoryForOrgOrgId>>>
export type PostApiScheduledJobRunOldPatientDosespotSyncResult = NonNullable<Awaited<ReturnType<typeof postApiScheduledJobRunOldPatientDosespotSync>>>
export type GetApiSettingsHasUnseenUserMessagesResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsHasUnseenUserMessages>>>
export type GetApiSettingsGetIntakeFormSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetIntakeFormSettings>>>
export type GetApiSettingsGePatientHistoryOptionsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGePatientHistoryOptions>>>
export type GetApiSettingsGetClaimSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetClaimSettings>>>
export type GetApiSettingsGetInsuranceSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetInsuranceSettings>>>
export type GetApiSettingsGetEOBFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetEOBFilterSettings>>>
export type GetApiSettingsGetChargeFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetChargeFilterSettings>>>
export type GetApiSettingsGetCcmMonthlyDashboardFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetCcmMonthlyDashboardFilterSettings>>>
export type GetApiSettingsGetTempoDashboardFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetTempoDashboardFilterSettings>>>
export type GetApiSettingsGetRTMMonitoringFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetRTMMonitoringFilterSettings>>>
export type GetApiSettingsGetRTMSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetRTMSettings>>>
export type GetApiSettingsGetSurgicalChecklistFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetSurgicalChecklistFilterSettings>>>
export type GetApiSettingsGetPatientPaymentTransactionFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetPatientPaymentTransactionFilterSettings>>>
export type GetApiSettingsGetPatientMultimediaFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetPatientMultimediaFilterSettings>>>
export type GetApiSettingsGetAppointmentSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetAppointmentSettings>>>
export type GetApiSettingsGetPatientAppointmentChangeSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetPatientAppointmentChangeSettings>>>
export type PutApiSettingsUpdatePatientAppointmentChangeSettingsResult = NonNullable<Awaited<ReturnType<typeof putApiSettingsUpdatePatientAppointmentChangeSettings>>>
export type GetApiSettingsGetAppointmentTypeSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetAppointmentTypeSettings>>>
export type GetApiSettingsGetPatientAppointmentStatusSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetPatientAppointmentStatusSettings>>>
export type GetApiSettingsGetFixedAppointmentStatusesResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetFixedAppointmentStatuses>>>
export type GetApiSettingsGetRoomSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetRoomSettings>>>
export type PostApiSettingsAddRoomSettingResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsAddRoomSetting>>>
export type PatchApiSettingsUpdateRoomSettingResult = NonNullable<Awaited<ReturnType<typeof patchApiSettingsUpdateRoomSetting>>>
export type DeleteApiSettingsDeleteRoomSettingResult = NonNullable<Awaited<ReturnType<typeof deleteApiSettingsDeleteRoomSetting>>>
export type PostApiSettingsAddAppointmentTypeSettingResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsAddAppointmentTypeSetting>>>
export type PostApiSettingsUpdateAppointmentTypeSettingResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsUpdateAppointmentTypeSetting>>>
export type GetApiSettingsGetToDoSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetToDoSettings>>>
export type GetApiSettingsGetFormWorkflowSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetFormWorkflowSettings>>>
export type GetApiSettingsGetWriteOffSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetWriteOffSettings>>>
export type GetApiSettingsGetEFaxFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetEFaxFilterSettings>>>
export type GetApiSettingsGetUserManagementSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetUserManagementSettings>>>
export type GetApiSettingsGetMediaSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetMediaSettings>>>
export type GetApiSettingsGetOrCreateUserSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetOrCreateUserSettings>>>
export type PostApiSettingsCreateOrUpdateUserSettingsResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsCreateOrUpdateUserSettings>>>
export type GetApiSettingsGetModifierListSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetModifierListSettings>>>
export type GetApiSettingsGetPayerEntryConfigsByTypeResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetPayerEntryConfigsByType>>>
export type PostApiSettingsAddPaperPayerEntryResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsAddPaperPayerEntry>>>
export type PutApiSettingsUpdatePaperPayerEntryResult = NonNullable<Awaited<ReturnType<typeof putApiSettingsUpdatePaperPayerEntry>>>
export type DeleteApiSettingsDeletePaperPayerEntryResult = NonNullable<Awaited<ReturnType<typeof deleteApiSettingsDeletePaperPayerEntry>>>
export type PostApiSettingsAddElectronicPayerEntryConfigResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsAddElectronicPayerEntryConfig>>>
export type PutApiSettingsUpdateElectronicPayerEntryConfigResult = NonNullable<Awaited<ReturnType<typeof putApiSettingsUpdateElectronicPayerEntryConfig>>>
export type DeleteApiSettingsDeleteElectronicPayerEntryConfigResult = NonNullable<Awaited<ReturnType<typeof deleteApiSettingsDeleteElectronicPayerEntryConfig>>>
export type GetApiSettingsGetProviderEntryConfigResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetProviderEntryConfig>>>
export type PostApiSettingsUpsertProviderEntryConfigResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsUpsertProviderEntryConfig>>>
export type PostApiSnapGetAudioUploadUrlResult = NonNullable<Awaited<ReturnType<typeof postApiSnapGetAudioUploadUrl>>>
export type PostApiSnapEnqueueNoteGenerationResult = NonNullable<Awaited<ReturnType<typeof postApiSnapEnqueueNoteGeneration>>>
export type GetApiSnapGetNoteBySnapAttemptIdResult = NonNullable<Awaited<ReturnType<typeof getApiSnapGetNoteBySnapAttemptId>>>
export type GetApiSquareAuthorizationGetAuthorizationUrlResult = NonNullable<Awaited<ReturnType<typeof getApiSquareAuthorizationGetAuthorizationUrl>>>
export type GetApiSquareAuthorizationAuthorizationRedirectResult = NonNullable<Awaited<ReturnType<typeof getApiSquareAuthorizationAuthorizationRedirect>>>
export type PostApiSquareAuthorizationRetrieveTokenStatusResult = NonNullable<Awaited<ReturnType<typeof postApiSquareAuthorizationRetrieveTokenStatus>>>
export type PostApiSquareAuthorizationRefreshTokenResult = NonNullable<Awaited<ReturnType<typeof postApiSquareAuthorizationRefreshToken>>>
export type PostApiSquareAuthorizationRevokeTokenResult = NonNullable<Awaited<ReturnType<typeof postApiSquareAuthorizationRevokeToken>>>
export type PostApiSquarePaymentsHandleEventNotificationResult = NonNullable<Awaited<ReturnType<typeof postApiSquarePaymentsHandleEventNotification>>>
export type GetApiSquarePaymentsListLocationsResult = NonNullable<Awaited<ReturnType<typeof getApiSquarePaymentsListLocations>>>
export type GetApiSquarePaymentsGetDeviceByDeviceIdResult = NonNullable<Awaited<ReturnType<typeof getApiSquarePaymentsGetDeviceByDeviceId>>>
export type GetApiSquarePaymentsListDevicesResult = NonNullable<Awaited<ReturnType<typeof getApiSquarePaymentsListDevices>>>
export type PostApiSquarePaymentsCreateDeviceCodeForLocationResult = NonNullable<Awaited<ReturnType<typeof postApiSquarePaymentsCreateDeviceCodeForLocation>>>
export type PostApiSquarePaymentsCreateTerminalCheckoutResult = NonNullable<Awaited<ReturnType<typeof postApiSquarePaymentsCreateTerminalCheckout>>>
export type PostApiSquarePaymentsGetPaymentResult = NonNullable<Awaited<ReturnType<typeof postApiSquarePaymentsGetPayment>>>
export type PostApiSquarePaymentsCancelTerminalCheckoutResult = NonNullable<Awaited<ReturnType<typeof postApiSquarePaymentsCancelTerminalCheckout>>>
export type PostApiSquarePaymentsCreateQuickPayCheckoutResult = NonNullable<Awaited<ReturnType<typeof postApiSquarePaymentsCreateQuickPayCheckout>>>
export type GetApiStickyGetAllStickiesByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiStickyGetAllStickiesByPatientId>>>
export type GetApiStickyGetStickyByIdResult = NonNullable<Awaited<ReturnType<typeof getApiStickyGetStickyById>>>
export type PostApiStickyCreateStickyResult = NonNullable<Awaited<ReturnType<typeof postApiStickyCreateSticky>>>
export type PostApiStickyUpdateStickyResult = NonNullable<Awaited<ReturnType<typeof postApiStickyUpdateSticky>>>
export type DeleteApiStickyDeleteStickyResult = NonNullable<Awaited<ReturnType<typeof deleteApiStickyDeleteSticky>>>
export type PostApiSuperDialRequestWebhookResult = NonNullable<Awaited<ReturnType<typeof postApiSuperDialRequestWebhook>>>
export type PostApiSupportSqlGenerateSqlResult = NonNullable<Awaited<ReturnType<typeof postApiSupportSqlGenerateSql>>>
export type PostApiSupportSqlExecuteSqlResult = NonNullable<Awaited<ReturnType<typeof postApiSupportSqlExecuteSql>>>
export type GetApiTagGetTagsResult = NonNullable<Awaited<ReturnType<typeof getApiTagGetTags>>>
export type PostApiTagCreateTagResult = NonNullable<Awaited<ReturnType<typeof postApiTagCreateTag>>>
export type PostApiTagUpdateTagResult = NonNullable<Awaited<ReturnType<typeof postApiTagUpdateTag>>>
export type DeleteApiTagDeleteTagResult = NonNullable<Awaited<ReturnType<typeof deleteApiTagDeleteTag>>>
export type GetApiTagGetClaimWiseTagsClaimIdResult = NonNullable<Awaited<ReturnType<typeof getApiTagGetClaimWiseTagsClaimId>>>
export type PostApiTagUpdateClaimWiseTagsResult = NonNullable<Awaited<ReturnType<typeof postApiTagUpdateClaimWiseTags>>>
export type GetApiTelehealthGetProviderJoinInfoEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiTelehealthGetProviderJoinInfoEncounterId>>>
export type PostApiTelehealthGetPatientJoinInfoResult = NonNullable<Awaited<ReturnType<typeof postApiTelehealthGetPatientJoinInfo>>>
export type PostApiTelehealthRetryMeetingCreationForAppointmentEncounterIdResult = NonNullable<Awaited<ReturnType<typeof postApiTelehealthRetryMeetingCreationForAppointmentEncounterId>>>
export type PostApiTemplateSaveSectionTemplateResult = NonNullable<Awaited<ReturnType<typeof postApiTemplateSaveSectionTemplate>>>
export type GetApiTemplateRetrieveSectionTemplateResult = NonNullable<Awaited<ReturnType<typeof getApiTemplateRetrieveSectionTemplate>>>
export type PostApiTemplateRetrieveSectionTemplatesResult = NonNullable<Awaited<ReturnType<typeof postApiTemplateRetrieveSectionTemplates>>>
export type DeleteApiTemplateDeleteSectionTemplateResult = NonNullable<Awaited<ReturnType<typeof deleteApiTemplateDeleteSectionTemplate>>>
export type GetApiTemplateGetSectionTemplateListResult = NonNullable<Awaited<ReturnType<typeof getApiTemplateGetSectionTemplateList>>>
export type PostApiTemplateSaveMasterTemplateResult = NonNullable<Awaited<ReturnType<typeof postApiTemplateSaveMasterTemplate>>>
export type GetApiTemplateRetrieveMasterTemplateResult = NonNullable<Awaited<ReturnType<typeof getApiTemplateRetrieveMasterTemplate>>>
export type DeleteApiTemplateDeleteMasterTemplateResult = NonNullable<Awaited<ReturnType<typeof deleteApiTemplateDeleteMasterTemplate>>>
export type GetApiTemplateGetMasterTemplateListResult = NonNullable<Awaited<ReturnType<typeof getApiTemplateGetMasterTemplateList>>>
export type GetApiTemplateGetFieldListResult = NonNullable<Awaited<ReturnType<typeof getApiTemplateGetFieldList>>>
export type GetApiTemplateGetFieldFieldIdResult = NonNullable<Awaited<ReturnType<typeof getApiTemplateGetFieldFieldId>>>
export type PostApiTemplateAddFieldResult = NonNullable<Awaited<ReturnType<typeof postApiTemplateAddField>>>
export type PutApiTemplateEditFieldResult = NonNullable<Awaited<ReturnType<typeof putApiTemplateEditField>>>
export type DeleteApiTemplateDeleteFieldResult = NonNullable<Awaited<ReturnType<typeof deleteApiTemplateDeleteField>>>
export type GetApiTempoGetTempoStatusByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiTempoGetTempoStatusByPatientId>>>
export type PostApiTempoSendDayOneCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiTempoSendDayOneCommunique>>>
export type PostApiTempoSendDayTwoCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiTempoSendDayTwoCommunique>>>
export type PostApiTempoDashboardGetPatientsResult = NonNullable<Awaited<ReturnType<typeof postApiTempoDashboardGetPatients>>>
export type PostApiTempoDashboardGetPatientDetailResult = NonNullable<Awaited<ReturnType<typeof postApiTempoDashboardGetPatientDetail>>>
export type PostApiToDoRequestToDoListResult = NonNullable<Awaited<ReturnType<typeof postApiToDoRequestToDoList>>>
export type PostApiToDoGetTodosByPatientIdResult = NonNullable<Awaited<ReturnType<typeof postApiToDoGetTodosByPatientId>>>
export type GetApiToDoGetToDoByIdResult = NonNullable<Awaited<ReturnType<typeof getApiToDoGetToDoById>>>
export type GetApiToDoGetCommentsByToDoIdResult = NonNullable<Awaited<ReturnType<typeof getApiToDoGetCommentsByToDoId>>>
export type PostApiToDoCreateToDoResult = NonNullable<Awaited<ReturnType<typeof postApiToDoCreateToDo>>>
export type PostApiToDoCommentOnToDoResult = NonNullable<Awaited<ReturnType<typeof postApiToDoCommentOnToDo>>>
export type PutApiToDoUpdateToDoResult = NonNullable<Awaited<ReturnType<typeof putApiToDoUpdateToDo>>>
export type PutApiToDoUpdateToDoCollaboratorsResult = NonNullable<Awaited<ReturnType<typeof putApiToDoUpdateToDoCollaborators>>>
export type GetApiToDoGetUnreadToDoCountOfUserResult = NonNullable<Awaited<ReturnType<typeof getApiToDoGetUnreadToDoCountOfUser>>>
export type GetApiToDoGetFaxToDosResult = NonNullable<Awaited<ReturnType<typeof getApiToDoGetFaxToDos>>>
export type GetApiUserGetAllUsersByTitleTitleResult = NonNullable<Awaited<ReturnType<typeof getApiUserGetAllUsersByTitleTitle>>>
export type GetApiUserGetLoggedInUserInfoResult = NonNullable<Awaited<ReturnType<typeof getApiUserGetLoggedInUserInfo>>>
export type GetApiUserGetLoggedInEMRUserInfoResult = NonNullable<Awaited<ReturnType<typeof getApiUserGetLoggedInEMRUserInfo>>>
export type GetApiUserGetUsersResult = NonNullable<Awaited<ReturnType<typeof getApiUserGetUsers>>>
export type PostApiUserCreateUserResult = NonNullable<Awaited<ReturnType<typeof postApiUserCreateUser>>>
export type PostApiUserUpdateUserResult = NonNullable<Awaited<ReturnType<typeof postApiUserUpdateUser>>>
export type PostApiUserMessageRequestUserMessageListResult = NonNullable<Awaited<ReturnType<typeof postApiUserMessageRequestUserMessageList>>>
export type GetApiVisitNoteGetAllVisitNotesByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetAllVisitNotesByPatientIdPatientId>>>
export type GetApiVisitNoteGetUpcomingAppointmentsByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetUpcomingAppointmentsByPatientIdPatientId>>>
export type GetApiVisitNoteGetHistoricalVisitsByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetHistoricalVisitsByPatientIdPatientId>>>
export type PostApiVisitNotePrintUpcomingAppointmentsPdfResult = NonNullable<Awaited<ReturnType<typeof postApiVisitNotePrintUpcomingAppointmentsPdf>>>
export type GetApiVisitNoteGetVisitNoteByEncounterIdEncounterIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetVisitNoteByEncounterIdEncounterId>>>
export type GetApiVisitNoteGetAppointmentRelatedInfoByVisitNoteIdVisitNoteIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetAppointmentRelatedInfoByVisitNoteIdVisitNoteId>>>
export type GetApiVisitNoteGetUserFavoriteMedicalCodesResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetUserFavoriteMedicalCodes>>>
export type PostApiVisitNoteApproveRTMPlanVisitNoteIdResult = NonNullable<Awaited<ReturnType<typeof postApiVisitNoteApproveRTMPlanVisitNoteId>>>
export type PostApiVisitNoteSaveVisitNoteResult = NonNullable<Awaited<ReturnType<typeof postApiVisitNoteSaveVisitNote>>>
export type PutApiVisitNoteSaveVisitNoteSOAPResult = NonNullable<Awaited<ReturnType<typeof putApiVisitNoteSaveVisitNoteSOAP>>>
export type GetApiVisitNoteGetBillingAssessmentCodesFromVisitNotePatientIdVisitNoteIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetBillingAssessmentCodesFromVisitNotePatientIdVisitNoteId>>>
export type GetApiVisitNoteGetBillingCodesFromVisitNotePatientIdVisitNoteIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetBillingCodesFromVisitNotePatientIdVisitNoteId>>>
export type GetApiVisitNoteGetCustomServiceCodesFromVisitNotePatientIdVisitNoteIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetCustomServiceCodesFromVisitNotePatientIdVisitNoteId>>>
export type GetApiVisitNoteGetHPIInParagraphFormResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetHPIInParagraphForm>>>
export type GetApiVisitNoteGetAICodeSuggestionsEncounterIdCodeTypeResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetAICodeSuggestionsEncounterIdCodeType>>>
export type PutApiVisitNoteAddAddendumResult = NonNullable<Awaited<ReturnType<typeof putApiVisitNoteAddAddendum>>>
export type GetApiVisitNoteGetAddendumFinalizedVisitNoteIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetAddendumFinalizedVisitNoteId>>>
export type GetApiVisitNoteGetPastVisitNotesForPatientResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetPastVisitNotesForPatient>>>
export type GetApiVisitNoteGetSpecificVisitNoteForPatientResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetSpecificVisitNoteForPatient>>>
export type GetApiVisitNoteGetSpecificVisitNoteSectionForPatientResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetSpecificVisitNoteSectionForPatient>>>
export type PostApiVisitNoteUnFinalizeResult = NonNullable<Awaited<ReturnType<typeof postApiVisitNoteUnFinalize>>>
export type PostApiVisitNotePrintVisitNotePdfEncounterIdResult = NonNullable<Awaited<ReturnType<typeof postApiVisitNotePrintVisitNotePdfEncounterId>>>
export type GetApiVisitNoteGetMipsSuggestionVisitNoteIdResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetMipsSuggestionVisitNoteId>>>
export type GetApiVisitNoteGetMipsSubmissionDataResult = NonNullable<Awaited<ReturnType<typeof getApiVisitNoteGetMipsSubmissionData>>>
export type GetApiVoiceAssistantGetSessionResult = NonNullable<Awaited<ReturnType<typeof getApiVoiceAssistantGetSession>>>
export type GetApiVoiceAssistantInitializeEmbeddingsResult = NonNullable<Awaited<ReturnType<typeof getApiVoiceAssistantInitializeEmbeddings>>>
export type GetApiVoiceAssistantInitializeAppointmentEmbeddingsResult = NonNullable<Awaited<ReturnType<typeof getApiVoiceAssistantInitializeAppointmentEmbeddings>>>
export type GetApiVoiceAssistantInitializePatientEmbeddingsResult = NonNullable<Awaited<ReturnType<typeof getApiVoiceAssistantInitializePatientEmbeddings>>>
export type GetApiVoiceAssistantGetQueryAnswerResult = NonNullable<Awaited<ReturnType<typeof getApiVoiceAssistantGetQueryAnswer>>>
export type GetApiVoiceAssistantGetContextFromPopulateResult = NonNullable<Awaited<ReturnType<typeof getApiVoiceAssistantGetContextFromPopulate>>>
export type GetApiZocdocGetAuthTokenResult = NonNullable<Awaited<ReturnType<typeof getApiZocdocGetAuthToken>>>
export type PostApiZocdocEnqueueSyncZocdocTimeSlotsForAllFacilitiesResult = NonNullable<Awaited<ReturnType<typeof postApiZocdocEnqueueSyncZocdocTimeSlotsForAllFacilities>>>
export type PostApiZocdocEnqueueSyncZocdocTimeSlotsForUsersResult = NonNullable<Awaited<ReturnType<typeof postApiZocdocEnqueueSyncZocdocTimeSlotsForUsers>>>
export type PostApiZocdocRetryWebhookEventResult = NonNullable<Awaited<ReturnType<typeof postApiZocdocRetryWebhookEvent>>>
export type PostApiZocdocRetryFailedSlotCreationAttemptResult = NonNullable<Awaited<ReturnType<typeof postApiZocdocRetryFailedSlotCreationAttempt>>>
export type PostApiZocdocSyncPastAppointmentsForAllOrgsResult = NonNullable<Awaited<ReturnType<typeof postApiZocdocSyncPastAppointmentsForAllOrgs>>>
export type PostApiZocdocEventHandlerWebhookTenantIdResult = NonNullable<Awaited<ReturnType<typeof postApiZocdocEventHandlerWebhookTenantId>>>
export type PostApiZoomWebhookResult = NonNullable<Awaited<ReturnType<typeof postApiZoomWebhook>>>
